module.exports = {
	"contractName": "AsyncCoin",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "name",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"name": "addressToBalance",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "decimals",
			"outputs": [
				{
					"name": "",
					"type": "uint8"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "renounceOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "symbol",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "etherBalance",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"payable": true,
			"stateMutability": "payable",
			"type": "fallback"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "from",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "to",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "tokens",
					"type": "uint256"
				}
			],
			"name": "Transfer",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "tokenOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "spender",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "tokens",
					"type": "uint256"
				}
			],
			"name": "Approval",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "to",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "tokens",
					"type": "uint256"
				},
				{
					"indexed": false,
					"name": "newTotalSupply",
					"type": "uint256"
				}
			],
			"name": "TokensMinted",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "to",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "state",
					"type": "bool"
				}
			],
			"name": "AddressFreezeChange",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "to",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "tokens",
					"type": "uint256"
				}
			],
			"name": "TokensBought",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "to",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "name",
					"type": "string"
				}
			],
			"name": "AddressNameChange",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "to",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "state",
					"type": "bool"
				}
			],
			"name": "AddressCanBuyTokensStatusChange",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				}
			],
			"name": "OwnershipRenounced",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "isOwner",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "totalSupply",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "myBalance",
			"outputs": [
				{
					"name": "balance",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "tokenOwner",
					"type": "address"
				}
			],
			"name": "balanceOf",
			"outputs": [
				{
					"name": "balance",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_tokenOwner",
					"type": "address"
				},
				{
					"name": "_spender",
					"type": "address"
				}
			],
			"name": "allowance",
			"outputs": [
				{
					"name": "remaining",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_to",
					"type": "address"
				},
				{
					"name": "_tokens",
					"type": "uint256"
				}
			],
			"name": "transfer",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_from",
					"type": "address"
				},
				{
					"name": "_to",
					"type": "address"
				},
				{
					"name": "_tokens",
					"type": "uint256"
				}
			],
			"name": "transferFrom",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_spender",
					"type": "address"
				},
				{
					"name": "_tokens",
					"type": "uint256"
				}
			],
			"name": "approve",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_receiver",
					"type": "address"
				},
				{
					"name": "_tokens",
					"type": "uint256"
				}
			],
			"name": "ownerMintTokens",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_couponCode",
					"type": "string"
				},
				{
					"name": "_tokenReward",
					"type": "uint256"
				},
				{
					"name": "_timeCouponCanBeUsed",
					"type": "uint256"
				}
			],
			"name": "createCoupon",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_couponCode",
					"type": "string"
				}
			],
			"name": "disableCoupon",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_couponCode",
					"type": "string"
				}
			],
			"name": "enableCoupon",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_couponCode",
					"type": "string"
				}
			],
			"name": "redeemCoupon",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_frozenAddress",
					"type": "address"
				}
			],
			"name": "freezeAddress",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_frozenAddress",
					"type": "address"
				}
			],
			"name": "unfreezeAddress",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_addressName",
					"type": "string"
				}
			],
			"name": "setName",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_address",
					"type": "address"
				}
			],
			"name": "setAllowedToBuy",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_address",
					"type": "address"
				}
			],
			"name": "setNotAllowedToBuy",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_address",
					"type": "address"
				}
			],
			"name": "canBuyTokens",
			"outputs": [
				{
					"name": "addressCanBuyTokens",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "buyTokens",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "sendEtherToContract",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "getEtherFromContract",
			"outputs": [
				{
					"name": "success",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "getContractEtherBalance",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_addressToFind",
					"type": "address"
				}
			],
			"name": "getAddressName",
			"outputs": [
				{
					"name": "addressName",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "0x608060405260043610610196576000357c0100000000000000000000000000000000000000000000000000000000900463ffffffff16806306fdde03146101a1578063095ea7b31461023157806318160ddd1461029657806320d58664146102c1578063237c980a1461031c57806323b872dd1461037357806330e76dae146103f8578063313ce56714610423578063325ec7681461045457806351e946d514610476578063584f1753146104d157806359b763f7146105525780636cc866e8146105e757806370a0823114610668578063715018a6146106bf5780638a0a2485146106d65780638da5cb5b146107055780638f32d59b1461075c57806395d89b411461078b5780639700be2c1461081b578063a9059cbb14610880578063ad66e52a146108e5578063bfb8054714610910578063c47f00271461096b578063c9116b69146109ec578063d0febe4c14610a17578063dd2e413414610a39578063dd62ed3e14610af5578063e2e3855a14610b6c578063e71d1c1014610bed578063f159e25d14610c48578063f2fde38b14610ca3575b61019e610ce6565b50005b3480156101ad57600080fd5b506101b6610f70565b6040518080602001828103825283818151815260200191508051906020019080838360005b838110156101f65780820151818401526020810190506101db565b50505050905090810190601f1680156102235780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b34801561023d57600080fd5b5061027c600480360381019080803573ffffffffffffffffffffffffffffffffffffffff16906020019092919080359060200190929190505050610fa9565b604051808215151515815260200191505060405180910390f35b3480156102a257600080fd5b506102ab6111ae565b6040518082815260200191505060405180910390f35b3480156102cd57600080fd5b50610302600480360381019080803573ffffffffffffffffffffffffffffffffffffffff1690602001909291905050506111b8565b604051808215151515815260200191505060405180910390f35b34801561032857600080fd5b5061035d600480360381019080803573ffffffffffffffffffffffffffffffffffffffff16906020019092919050505061126c565b6040518082815260200191505060405180910390f35b34801561037f57600080fd5b506103de600480360381019080803573ffffffffffffffffffffffffffffffffffffffff169060200190929190803573ffffffffffffffffffffffffffffffffffffffff16906020019092919080359060200190929190505050611284565b604051808215151515815260200191505060405180910390f35b34801561040457600080fd5b5061040d611728565b6040518082815260200191505060405180910390f35b34801561042f57600080fd5b50610438611732565b604051808260ff1660ff16815260200191505060405180910390f35b61045c611737565b604051808215151515815260200191505060405180910390f35b34801561048257600080fd5b506104b7600480360381019080803573ffffffffffffffffffffffffffffffffffffffff1690602001909291905050506117a5565b604051808215151515815260200191505060405180910390f35b3480156104dd57600080fd5b50610538600480360381019080803590602001908201803590602001908080601f016020809104026020016040519081016040528093929190818152602001838380828437820191505050505050919291929050505061192d565b604051808215151515815260200191505060405180910390f35b34801561055e57600080fd5b506105cd600480360381019080803590602001908201803590602001908080601f01602080910402602001604051908101604052809392919081815260200183838082843782019150505050505091929192908035906020019092919080359060200190929190505050611a98565b604051808215151515815260200191505060405180910390f35b3480156105f357600080fd5b5061064e600480360381019080803590602001908201803590602001908080601f0160208091040260200160405190810160405280939291908181526020018383808284378201915050505050509192919290505050611cab565b604051808215151515815260200191505060405180910390f35b34801561067457600080fd5b506106a9600480360381019080803573ffffffffffffffffffffffffffffffffffffffff16906020019092919050505061230d565b6040518082815260200191505060405180910390f35b3480156106cb57600080fd5b506106d4612391565b005b3480156106e257600080fd5b506106eb612493565b604051808215151515815260200191505060405180910390f35b34801561071157600080fd5b5061071a612527565b604051808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200191505060405180910390f35b34801561076857600080fd5b5061077161254c565b604051808215151515815260200191505060405180910390f35b34801561079757600080fd5b506107a06125a3565b6040518080602001828103825283818151815260200191508051906020019080838360005b838110156107e05780820151818401526020810190506107c5565b50505050905090810190601f16801561080d5780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b34801561082757600080fd5b50610866600480360381019080803573ffffffffffffffffffffffffffffffffffffffff169060200190929190803590602001909291905050506125dc565b604051808215151515815260200191505060405180910390f35b34801561088c57600080fd5b506108cb600480360381019080803573ffffffffffffffffffffffffffffffffffffffff16906020019092919080359060200190929190505050612699565b604051808215151515815260200191505060405180910390f35b3480156108f157600080fd5b506108fa612be5565b6040518082815260200191505060405180910390f35b34801561091c57600080fd5b50610951600480360381019080803573ffffffffffffffffffffffffffffffffffffffff169060200190929190505050612beb565b604051808215151515815260200191505060405180910390f35b34801561097757600080fd5b506109d2600480360381019080803590602001908201803590602001908080601f0160208091040260200160405190810160405280939291908181526020018383808284378201915050505050509192919290505050612d97565b604051808215151515815260200191505060405180910390f35b3480156109f857600080fd5b50610a01612ee4565b6040518082815260200191505060405180910390f35b610a1f610ce6565b604051808215151515815260200191505060405180910390f35b348015610a4557600080fd5b50610a7a600480360381019080803573ffffffffffffffffffffffffffffffffffffffff169060200190929190505050612ef4565b6040518080602001828103825283818151815260200191508051906020019080838360005b83811015610aba578082015181840152602081019050610a9f565b50505050905090810190601f168015610ae75780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b348015610b0157600080fd5b50610b56600480360381019080803573ffffffffffffffffffffffffffffffffffffffff169060200190929190803573ffffffffffffffffffffffffffffffffffffffff169060200190929190505050612fd5565b6040518082815260200191505060405180910390f35b348015610b7857600080fd5b50610bd3600480360381019080803590602001908201803590602001908080601f016020809104026020016040519081016040528093929190818152602001838380828437820191505050505050919291929050505061310e565b604051808215151515815260200191505060405180910390f35b348015610bf957600080fd5b50610c2e600480360381019080803573ffffffffffffffffffffffffffffffffffffffff169060200190929190505050613279565b604051808215151515815260200191505060405180910390f35b348015610c5457600080fd5b50610c89600480360381019080803573ffffffffffffffffffffffffffffffffffffffff1690602001909291905050506133c6565b604051808215151515815260200191505060405180910390f35b348015610caf57600080fd5b50610ce4600480360381019080803573ffffffffffffffffffffffffffffffffffffffff169060200190929190505050613513565b005b600080600080600073ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614151515610d2857600080fd5b600034111515610d3757600080fd5b60011515600960003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff1615151480610de257503373ffffffffffffffffffffffffffffffffffffffff166000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16145b1515610ded57600080fd5b610e08670de0b6b3a76400003461357a90919063ffffffff16565b9250610e1d833461359f90919063ffffffff16565b9150610e4d600a610e3f670de0b6b3a7640000856135c090919063ffffffff16565b6135ea90919063ffffffff16565b9050600082111515610e5e57600080fd5b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff166108fc839081150290604051600060405180830381858888f19350505050158015610ec5573d6000803e3d6000fd5b503373ffffffffffffffffffffffffffffffffffffffff166108fc849081150290604051600060405180830381858888f19350505050158015610f0c573d6000803e3d6000fd5b50610f173382613628565b503373ffffffffffffffffffffffffffffffffffffffff167f745f661b8143944fb883f50694ebed3a871e43c451d9d4bf4648a9d551d7e47a826040518082815260200191505060405180910390a26001935050505090565b6040805190810160405280600981526020017f4173796e63436f696e000000000000000000000000000000000000000000000081525081565b60008073ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff1614151515610fe657600080fd5b3373ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff161415151561102157600080fd5b60008211151561103057600080fd5b6110bf82600460003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020546137a290919063ffffffff16565b600460003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055508273ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925846040518082815260200191505060405180910390a36001905092915050565b6000600154905090565b600060011515600960008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff161515148061126557506000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff16145b9050919050565b60036020528060005260406000206000915090505481565b60008073ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff16141515156112c157600080fd5b600073ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff16141515156112fd57600080fd5b8273ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff161415151561133857600080fd5b60008211151561134757600080fd5b81600460008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054101515156113d257600080fd5b81600360008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020541015151561142057600080fd5b60001515600760008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff16151514151561147f57600080fd5b6114d182600360008773ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000205461359f90919063ffffffff16565b600360008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055506115a382600460008773ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000205461359f90919063ffffffff16565b600460008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000208190555061167582600360008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020546137a290919063ffffffff16565b600360008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055508273ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef846040518082815260200191505060405180910390a3600190509392505050565b6000600254905090565b600081565b60008073ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff161415151561177457600080fd5b60003411151561178357600080fd5b611798346002546137a290919063ffffffff16565b6002819055506001905090565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614151561180257600080fd5b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff161415151561183e57600080fd5b8173ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff161415151561187957600080fd5b6001600760008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055508173ffffffffffffffffffffffffffffffffffffffff167fed1f6e797f4e79540fc2ab1c0bde260881a7e648335b83f2bc0f265f5f61c8f36001604051808215151515815260200191505060405180910390a260019050919050565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614151561198a57600080fd5b60006005836040518082805190602001908083835b6020831015156119c4578051825260208201915060208101905060208303925061199f565b6001836020036101000a03801982511681845116808217855250505050505090500191505090815260200160405180910390206001015414151515611a0857600080fd5b60006005836040518082805190602001908083835b602083101515611a425780518252602082019150602081019050602083039250611a1d565b6001836020036101000a038019825116818451168082178552505050505050905001915050908152602001604051809103902060030160016101000a81548160ff02191690831515021790555060019050919050565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff16141515611af557600080fd5b600083111515611b0457600080fd5b60008451111515611b1457600080fd5b60006005856040518082805190602001908083835b602083101515611b4e5780518252602082019150602081019050602083039250611b29565b6001836020036101000a038019825116818451168082178552505050505050905001915050908152602001604051809103902060010154141515611b9157600080fd5b60a0604051908101604052808581526020018481526020018381526020016000841415158152602001600115158152506005856040518082805190602001908083835b602083101515611bf95780518252602082019150602081019050602083039250611bd4565b6001836020036101000a03801982511681845116808217855250505050505090500191505090815260200160405180910390206000820151816000019080519060200190611c489291906138bd565b50602082015181600101556040820151816002015560608201518160030160006101000a81548160ff02191690831515021790555060808201518160030160016101000a81548160ff021916908315150217905550905050600190509392505050565b60008073ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614151515611ce857600080fd5b60008251111515611cf857600080fd5b600115156005836040518082805190602001908083835b602083101515611d345780518252602082019150602081019050602083039250611d0f565b6001836020036101000a038019825116818451168082178552505050505050905001915050908152602001604051809103902060030160019054906101000a900460ff161515141515611d8657600080fd5b600015156005836040518082805190602001908083835b602083101515611dc25780518252602082019150602081019050602083039250611d9d565b6001836020036101000a038019825116818451168082178552505050505050905001915050908152602001604051809103902060030160009054906101000a900460ff1615151415611e8c5760006005836040518082805190602001908083835b602083101515611e485780518252602082019150602081019050602083039250611e23565b6001836020036101000a038019825116818451168082178552505050505050905001915050908152602001604051809103902060020154111515611e8b57600080fd5b5b600660003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020826040518082805190602001908083835b602083101515611f015780518252602082019150602081019050602083039250611edc565b6001836020036101000a038019825116818451168082178552505050505050905001915050908152602001604051809103902060009054906101000a900460ff16151515611f4e57600080fd5b600015156005836040518082805190602001908083835b602083101515611f8a5780518252602082019150602081019050602083039250611f65565b6001836020036101000a038019825116818451168082178552505050505050905001915050908152602001604051809103902060030160009054906101000a900460ff16151514156121ca5761205860016005846040518082805190602001908083835b6020831015156120135780518252602082019150602081019050602083039250611fee565b6001836020036101000a03801982511681845116808217855250505050505090500191505090815260200160405180910390206002015461359f90919063ffffffff16565b6005836040518082805190602001908083835b602083101515612090578051825260208201915060208101905060208303925061206b565b6001836020036101000a03801982511681845116808217855250505050505090500191505090815260200160405180910390206002018190555060016005836040518082805190602001908083835b60208310151561210457805182526020820191506020810190506020830392506120df565b6001836020036101000a03801982511681845116808217855250505050505090500191505090815260200160405180910390206002015410156121c95760006005836040518082805190602001908083835b60208310151561217b5780518252602082019150602081019050602083039250612156565b6001836020036101000a038019825116818451168082178552505050505050905001915050908152602001604051809103902060030160016101000a81548160ff0219169083151502179055505b5b6001600660003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020836040518082805190602001908083835b602083101515612241578051825260208201915060208101905060208303925061221c565b6001836020036101000a038019825116818451168082178552505050505050905001915050908152602001604051809103902060006101000a81548160ff021916908315150217905550612303336005846040518082805190602001908083835b6020831015156122c757805182526020820191506020810190506020830392506122a2565b6001836020036101000a038019825116818451168082178552505050505050905001915050908152602001604051809103902060010154613628565b5060019050919050565b60008073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff161415151561234a57600080fd5b600360008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020549050919050565b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff161415156123ec57600080fd5b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff167ff8df31144d9c2f0f6b59d69b8b98abd5459d07f2742c4df920b25aae33c6482060405160405180910390a260008060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550565b6000670de0b6b3a7640000600254101515156124ae57600080fd5b3373ffffffffffffffffffffffffffffffffffffffff166108fc670de0b6b3a76400009081150290604051600060405180830381858888f193505050501580156124fc573d6000803e3d6000fd5b5061251a670de0b6b3a764000060025461359f90919063ffffffff16565b6002819055506001905090565b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614905090565b6040805190810160405280600381526020017f415343000000000000000000000000000000000000000000000000000000000081525081565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614151561263957600080fd5b600073ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff161415151561267557600080fd5b60008211151561268457600080fd5b61268e8383613628565b506001905092915050565b60008073ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff161415151561273f576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004018080602001828103825260208152602001807f526563656976696e6720616464726573732063616e2774206265206e756c6c2e81525060200191505060405180910390fd5b3373ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff16141515156127e3576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040180806020018281038252601e8152602001807f43616e27742073656e7420746f6b656e7320746f20796f757273656c662e000081525060200191505060405180910390fd5b600082111515612881576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040180806020018281038252602f8152602001807f4e756d626572206f662073656e7420746f6b656e73206d75737420626520626981526020017f67676572207468616e207a65726f2e000000000000000000000000000000000081525060400191505060405180910390fd5b81600360003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020541015151561295e576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004018080602001828103825260328152602001807f53656e6465722068617320746f206861766520656e6f75676820746f6b656e7381526020017f20746f207472616e73666572207468656d2e000000000000000000000000000081525060400191505060405180910390fd5b60001515600760003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff161515141515612a4c576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040180806020018281038252603b8152602001807f596f7572206163636f756e742069732066726f7a656e2c20736f20796f75206381526020017f616e2774206d616b652074686973207472616e73616374696f6e2e000000000081525060400191505060405180910390fd5b612a9e82600360003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000205461359f90919063ffffffff16565b600360003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550612b3382600360008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020546137a290919063ffffffff16565b600360008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055508273ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef846040518082815260200191505060405180910390a36001905092915050565b60025481565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff16141515612c4857600080fd5b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff1614151515612c8457600080fd5b60011515600760008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff161515141515612ce357600080fd5b6000600760008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055508173ffffffffffffffffffffffffffffffffffffffff167fed1f6e797f4e79540fc2ab1c0bde260881a7e648335b83f2bc0f265f5f61c8f36000604051808215151515815260200191505060405180910390a260019050919050565b60008073ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614151515612dd457600080fd5b81600860003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000209080519060200190612e2792919061393d565b503373ffffffffffffffffffffffffffffffffffffffff167f9d66026e90bfcfa3441b38593073f8789a74b61b6f846d0344f5adf405172dcd836040518080602001828103825283818151815260200191508051906020019080838360005b83811015612ea1578082015181840152602081019050612e86565b50505050905090810190601f168015612ece5780820380516001836020036101000a031916815260200191505b509250505060405180910390a260019050919050565b6000612eef3361230d565b905090565b6060600860008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000208054600181600116156101000203166002900480601f016020809104026020016040519081016040528092919081815260200182805460018160011615610100020316600290048015612fc95780601f10612f9e57610100808354040283529160200191612fc9565b820191906000526020600020905b815481529060010190602001808311612fac57829003601f168201915b50505050509050919050565b60008073ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff161415151561301257600080fd5b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff161415151561304e57600080fd5b8173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff161415151561308957600080fd5b600460008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054905092915050565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614151561316b57600080fd5b60006005836040518082805190602001908083835b6020831015156131a55780518252602082019150602081019050602083039250613180565b6001836020036101000a038019825116818451168082178552505050505050905001915050908152602001604051809103902060010154141515156131e957600080fd5b60016005836040518082805190602001908083835b60208310151561322357805182526020820191506020810190506020830392506131fe565b6001836020036101000a038019825116818451168082178552505050505050905001915050908152602001604051809103902060030160016101000a81548160ff02191690831515021790555060019050919050565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff161415156132d657600080fd5b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff161415151561331257600080fd5b6001600960008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055508173ffffffffffffffffffffffffffffffffffffffff167f59b1b9196d59abf518ad9e44f305781aefd78a31ee0f486555a429c530c0f5d96001604051808215151515815260200191505060405180910390a260019050919050565b60008060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614151561342357600080fd5b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff161415151561345f57600080fd5b6000600960008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055508173ffffffffffffffffffffffffffffffffffffffff167f59b1b9196d59abf518ad9e44f305781aefd78a31ee0f486555a429c530c0f5d96000604051808215151515815260200191505060405180910390a260019050919050565b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614151561356e57600080fd5b613577816137c3565b50565b600080821415151561358b57600080fd5b818381151561359657fe5b06905092915050565b6000808383111515156135b157600080fd5b82840390508091505092915050565b6000806000831115156135d257600080fd5b82848115156135dd57fe5b0490508091505092915050565b60008060008414156135ff5760009150613621565b828402905082848281151561361057fe5b0414151561361d57600080fd5b8091505b5092915050565b600061367c82600360008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020546137a290919063ffffffff16565b600360008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020819055506136d4826001546137a290919063ffffffff16565b6001819055508273ffffffffffffffffffffffffffffffffffffffff167f2e8ac5177a616f2aec08c3048f5021e4e9743ece034e8d83ba5caf76688bb47583600154604051808381526020018281526020019250505060405180910390a28273ffffffffffffffffffffffffffffffffffffffff16600073ffffffffffffffffffffffffffffffffffffffff167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef846040518082815260200191505060405180910390a36001905092915050565b60008082840190508381101515156137b957600080fd5b8091505092915050565b600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff16141515156137ff57600080fd5b8073ffffffffffffffffffffffffffffffffffffffff166000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e060405160405180910390a3806000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555050565b828054600181600116156101000203166002900490600052602060002090601f016020900481019282601f106138fe57805160ff191683800117855561392c565b8280016001018555821561392c579182015b8281111561392b578251825591602001919060010190613910565b5b50905061393991906139bd565b5090565b828054600181600116156101000203166002900490600052602060002090601f016020900481019282601f1061397e57805160ff19168380011785556139ac565b828001600101855582156139ac579182015b828111156139ab578251825591602001919060010190613990565b5b5090506139b991906139bd565b5090565b6139df91905b808211156139db5760008160009055506001016139c3565b5090565b905600a165627a7a7230582041141bd6e5c8925eab8183a2d8d8615f7e94e82dd64c87f412a4b517f552f2720029",
	"sourceMap": "147:11247:0:-;;;2184:440;8:9:-1;5:2;;;30:1;27;20:12;5:2;2184:440:0;605:10:2;597:5;;:18;;;;;;;;;;;;;;;;;;2386:1:0;2364:24;;:10;:24;;;;2356:58;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2488:10;2480:5;;:18;;;;;;;;;;;;;;;;;;2616:1;2602:11;:15;;;;147:11247;;;;;;",
	"deployedSourceMap": "147:11247:0:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;10655:11;:9;:11::i;:::-;;147:11247;948:41;;8:9:-1;5:2;;;30:1;27;20:12;5:2;948:41:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;948:41:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5073:358;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5073:358:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2736:88;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2736:88:0;;;;;;;;;;;;;;;;;;;;;;;9816:171;;8:9:-1;5:2;;;30:1;27;20:12;5:2;9816:171:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1346:51;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1346:51:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4260:807;;8:9:-1;5:2;;;30:1;27;20:12;5:2;4260:807:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;11137:104;;8:9:-1;5:2;;;30:1;27;20:12;5:2;11137:104:0;;;;;;;;;;;;;;;;;;;;;;;1093:34;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1093:34:0;;;;;;;;;;;;;;;;;;;;;;;;;;;10679:225;;;;;;;;;;;;;;;;;;;;;;;;;;;8325:314;;8:9:-1;5:2;;;30:1;27;20:12;5:2;8325:314:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6674:213;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6674:213:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6077:591;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6077:591:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7110:1185;;8:9:-1;5:2;;;30:1;27;20:12;5:2;7110:1185:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2940:173;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2940:173:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1065:121:2;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1065:121:2;;;;;;10910:221:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;10910:221:0;;;;;;;;;;;;;;;;;;;;;;;;;;;240:20:2;;8:9:-1;5:2;;;30:1;27;20:12;5:2;240:20:2;;;;;;;;;;;;;;;;;;;;;;;;;;;2630:100:0;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2630:100:0;;;;;;;;;;;;;;;;;;;;;;;;;;;995:37;;8:9:-1;5:2;;;30:1;27;20:12;5:2;995:37:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;995:37:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5832:239;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5832:239:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3405:849;;8:9:-1;5:2;;;30:1;27;20:12;5:2;3405:849:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1258:27;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1258:27:0;;;;;;;;;;;;;;;;;;;;;;;8687:329;;8:9:-1;5:2;;;30:1;27;20:12;5:2;8687:329:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;9022:249;;8:9:-1;5:2;;;30:1;27;20:12;5:2;9022:249:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2830:104;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2830:104:0;;;;;;;;;;;;;;;;;;;;;;;9993:620;;;;;;;;;;;;;;;;;;;;;;;;;;;11247:145;;8:9:-1;5:2;;;30:1;27;20:12;5:2;11247:145:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;11247:145:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3119:280;;8:9:-1;5:2;;;30:1;27;20:12;5:2;3119:280:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6893:211;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6893:211:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;9277:261;;8:9:-1;5:2;;;30:1;27;20:12;5:2;9277:261:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;9544:266;;8:9:-1;5:2;;;30:1;27;20:12;5:2;9544:266:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1358:109:2;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1358:109:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;9993:620:0;10038:12;10217:14;10268:15;10322:17;10091:1;10069:24;;:10;:24;;;;10061:33;;;;;;;;10124:1;10112:9;:13;10104:22;;;;;;;;10178:4;10144:38;;:18;:30;10163:10;10144:30;;;;;;;;;;;;;;;;;;;;;;;;;:38;;;:61;;;;10195:10;10186:19;;:5;;;;;;;;;;;:19;;;10144:61;10136:70;;;;;;;;10234:24;10250:7;10235:9;10234:15;;:24;;;;:::i;:::-;10217:41;;10286:26;10302:9;10287;10286:15;;:26;;;;:::i;:::-;10268:44;;10342:31;10370:2;10342:23;10357:7;10342:10;:14;;:23;;;;:::i;:::-;:27;;:31;;;;:::i;:::-;10322:51;;10405:1;10392:10;:14;10384:23;;;;;;;;10418:5;;;;;;;;;;;:14;;:26;10433:10;10418:26;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;10418:26:0;10454:10;:19;;:30;10474:9;10454:30;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;10454:30:0;10494:36;10505:10;10517:12;10494:10;:36::i;:::-;;10559:10;10546:38;;;10571:12;10546:38;;;;;;;;;;;;;;;;;;10602:4;10595:11;;9993:620;;;;:::o;948:41::-;;;;;;;;;;;;;;;;;;;;:::o;5073:358::-;5138:12;5189:1;5169:22;;:8;:22;;;;5161:31;;;;;;;;5222:10;5210:22;;:8;:22;;;;5202:31;;;;;;;;5261:1;5251:7;:11;5243:20;;;;;;;;5306:42;5340:7;5306;:19;5314:10;5306:19;;;;;;;;;;;;;;;:29;5326:8;5306:29;;;;;;;;;;;;;;;;:33;;:42;;;;:::i;:::-;5274:7;:19;5282:10;5274:19;;;;;;;;;;;;;;;:29;5294:8;5274:29;;;;;;;;;;;;;;;:74;;;;5384:8;5363:39;;5372:10;5363:39;;;5394:7;5363:39;;;;;;;;;;;;;;;;;;5420:4;5413:11;;5073:358;;;;:::o;2736:88::-;2784:4;2806:11;;2799:18;;2736:88;:::o;9816:171::-;9881:24;9955:4;9923:36;;:18;:28;9942:8;9923:28;;;;;;;;;;;;;;;;;;;;;;;;;:36;;;:57;;;;9975:5;;;;;;;;;;;9963:17;;:8;:17;;;9923:57;9916:64;;9816:171;;;:::o;1346:51::-;;;;;;;;;;;;;;;;;:::o;4260:807::-;4340:12;4440:1;4423:19;;:5;:19;;;;4415:28;;;;;;;;4476:1;4461:17;;:3;:17;;;;4453:26;;;;;;;;4506:3;4497:12;;:5;:12;;;;4489:21;;;;;;;;4538:1;4528:7;:11;4520:20;;;;;;;;4581:7;4558;:14;4566:5;4558:14;;;;;;;;;;;;;;;:19;4573:3;4558:19;;;;;;;;;;;;;;;;:30;;4550:39;;;;;;;;4634:7;4607:16;:23;4624:5;4607:23;;;;;;;;;;;;;;;;:34;;4599:43;;;;;;;;4742:5;4716:31;;:15;:22;4732:5;4716:22;;;;;;;;;;;;;;;;;;;;;;;;;:31;;;4708:40;;;;;;;;4812:36;4840:7;4812:16;:23;4829:5;4812:23;;;;;;;;;;;;;;;;:27;;:36;;;;:::i;:::-;4786:16;:23;4803:5;4786:23;;;;;;;;;;;;;;;:62;;;;4887:39;4918:7;4887;:14;4895:5;4887:14;;;;;;;;;;;;;;;:26;4902:10;4887:26;;;;;;;;;;;;;;;;:30;;:39;;;;:::i;:::-;4858:7;:14;4866:5;4858:14;;;;;;;;;;;;;;;:26;4873:10;4858:26;;;;;;;;;;;;;;;:68;;;;4960:34;4986:7;4960:16;:21;4977:3;4960:21;;;;;;;;;;;;;;;;:25;;:34;;;;:::i;:::-;4936:16;:21;4953:3;4936:21;;;;;;;;;;;;;;;:58;;;;5025:3;5009:29;;5018:5;5009:29;;;5030:7;5009:29;;;;;;;;;;;;;;;;;;5056:4;5049:11;;4260:807;;;;;:::o;11137:104::-;11197:7;11222:12;;11215:19;;11137:104;:::o;1093:34::-;1126:1;1093:34;:::o;10679:225::-;10734:12;10787:1;10765:24;;:10;:24;;;;10757:33;;;;;;;;10820:1;10808:9;:13;10800:22;;;;;;;;10848:27;10865:9;10848:12;;:16;;:27;;;;:::i;:::-;10833:12;:42;;;;10893:4;10886:11;;10679:225;:::o;8325:314::-;8398:12;763:5:2;;;;;;;;;;;749:19;;:10;:19;;;741:28;;;;;;;;8455:1:0;8429:28;;:14;:28;;;;8421:37;;;;;;;;8490:14;8476:28;;:10;:28;;;;8468:37;;;;;;;;8550:4;8516:15;:31;8532:14;8516:31;;;;;;;;;;;;;;;;:38;;;;;;;;;;;;;;;;;;8589:14;8569:41;;;8605:4;8569:41;;;;;;;;;;;;;;;;;;;;;;8628:4;8621:11;;8325:314;;;:::o;6674:213::-;6743:12;763:5:2;;;;;;;;;;;749:19;;:10;:19;;;741:28;;;;;;;;6810:1:0;6774:7;6782:11;6774:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;6774:20:0;;;;;;;;;;;;;;;;;;;;;:32;;;:37;;6766:46;;;;;;;;6853:5;6823:7;6831:11;6823:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;6823:20:0;;;;;;;;;;;;;;;;;;;;;:27;;;:35;;;;;;;;;;;;;;;;;;6876:4;6869:11;;6674:213;;;:::o;6077:591::-;6191:12;763:5:2;;;;;;;;;;;749:19;;:10;:19;;;741:28;;;;;;;;6237:1:0;6222:12;:16;6214:25;;;;;;;;6285:1;6263:11;6257:25;:29;6249:38;;;;;;;;6384:1;6348:7;6356:11;6348:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;6348:20:0;;;;;;;;;;;;;;;;;;;;;:32;;;:37;6340:46;;;;;;;;6420:219;;;;;;;;;6448:11;6420:219;;;;6487:12;6420:219;;;;6527:20;6420:219;;;;6623:1;6599:20;:25;6420:219;;;;;;6570:4;6420:219;;;;;6397:7;6405:11;6397:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;6397:20:0;;;;;;;;;;;;;;;;;;;;;:242;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6657:4;6650:11;;6077:591;;;;;:::o;7110:1185::-;7168:12;7221:1;7199:24;;:10;:24;;;;7191:33;;;;;;;;7270:1;7248:11;7242:25;:29;7234:38;;;;;;;;7369:4;7338:35;;:7;7346:11;7338:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;7338:20:0;;;;;;;;;;;;;;;;;;;;;:27;;;;;;;;;;;;:35;;;7330:44;;;;;;;;7489:5;7456:38;;:7;7464:11;7456:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;7456:20:0;;;;;;;;;;;;;;;;;;;;;:29;;;;;;;;;;;;:38;;;7452:114;;;7553:1;7518:7;7526:11;7518:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;7518:20:0;;;;;;;;;;;;;;;;;;;;;:32;;;:36;7510:45;;;;;;;;7452:114;7652:15;:27;7668:10;7652:27;;;;;;;;;;;;;;;7680:11;7652:40;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;7652:40:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7651:41;7643:50;;;;;;;;7784:5;7751:38;;:7;7759:11;7751:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;7751:20:0;;;;;;;;;;;;;;;;;;;;;:29;;;;;;;;;;;;:38;;;7747:335;;;7840:39;7877:1;7840:7;7848:11;7840:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;7840:20:0;;;;;;;;;;;;;;;;;;;;;:32;;;:36;;:39;;;;:::i;:::-;7805:7;7813:11;7805:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;7805:20:0;;;;;;;;;;;;;;;;;;;;;:32;;:74;;;;8001:1;7966:7;7974:11;7966:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;7966:20:0;;;;;;;;;;;;;;;;;;;;;:32;;;:36;7962:110;;;8052:5;8022:7;8030:11;8022:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;8022:20:0;;;;;;;;;;;;;;;;;;;;;:27;;;:35;;;;;;;;;;;;;;;;;;7962:110;7747:335;8196:4;8153:15;:27;8169:10;8153:27;;;;;;;;;;;;;;;8181:11;8153:40;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;8153:40:0;;;;;;;;;;;;;;;;;;;;;;:47;;;;;;;;;;;;;;;;;;8210:56;8221:10;8233:7;8241:11;8233:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;8233:20:0;;;;;;;;;;;;;;;;;;;;;:32;;;8210:10;:56::i;:::-;;8284:4;8277:11;;7110:1185;;;:::o;2940:173::-;3004:12;3057:1;3035:24;;:10;:24;;;;3027:33;;;;;;;;3078:16;:28;3095:10;3078:28;;;;;;;;;;;;;;;;3071:35;;2940:173;;;:::o;1065:121:2:-;763:5;;;;;;;;;;;749:19;;:10;:19;;;741:28;;;;;;;;1145:5;;;;;;;;;;;1126:25;;;;;;;;;;;;1177:1;1161:5;;:18;;;;;;;;;;;;;;;;;;1065:121::o;10910:221:0:-;10958:12;11005:7;10989:12;;:23;;10981:32;;;;;;;;11024:10;:19;;:28;11044:7;11024:28;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;11024:28:0;11077:25;11094:7;11077:12;;:16;;:25;;;;:::i;:::-;11062:12;:40;;;;11120:4;11113:11;;10910:221;:::o;240:20:2:-;;;;;;;;;;;;;:::o;2630:100:0:-;2674:12;2718:5;;;;;;;;;;;2704:19;;:10;:19;;;2697:26;;2630:100;:::o;995:37::-;;;;;;;;;;;;;;;;;;;;:::o;5832:239::-;5916:12;763:5:2;;;;;;;;;;;749:19;;:10;:19;;;741:28;;;;;;;;5968:1:0;5947:23;;:9;:23;;;;5939:32;;;;;;;;5999:1;5989:7;:11;5981:20;;;;;;;;6012:30;6023:9;6034:7;6012:10;:30::i;:::-;;6060:4;6053:11;;5832:239;;;;:::o;3405:849::-;3466:12;3512:1;3497:17;;:3;:17;;;;3489:62;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3576:10;3569:17;;:3;:17;;;;3561:60;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3649:1;3639:7;:11;3631:71;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3752:7;3720:16;:28;3737:10;3720:28;;;;;;;;;;;;;;;;:39;;3712:102;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3919:5;3888:36;;:15;:27;3904:10;3888:27;;;;;;;;;;;;;;;;;;;;;;;;;:36;;;3880:108;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4067:41;4100:7;4067:16;:28;4084:10;4067:28;;;;;;;;;;;;;;;;:32;;:41;;;;:::i;:::-;4036:16;:28;4053:10;4036:28;;;;;;;;;;;;;;;:72;;;;4142:34;4168:7;4142:16;:21;4159:3;4142:21;;;;;;;;;;;;;;;;:25;;:34;;;;:::i;:::-;4118:16;:21;4135:3;4118:21;;;;;;;;;;;;;;;:58;;;;4212:3;4191:34;;4200:10;4191:34;;;4217:7;4191:34;;;;;;;;;;;;;;;;;;4243:4;4236:11;;3405:849;;;;:::o;1258:27::-;;;;:::o;8687:329::-;8762:12;763:5:2;;;;;;;;;;;749:19;;:10;:19;;;741:28;;;;;;;;8819:1:0;8793:28;;:14;:28;;;;8785:37;;;;;;;;8875:4;8840:39;;:15;:31;8856:14;8840:31;;;;;;;;;;;;;;;;;;;;;;;;;:39;;;8832:48;;;;;;;;8925:5;8891:15;:31;8907:14;8891:31;;;;;;;;;;;;;;;;:39;;;;;;;;;;;;;;;;;;8965:14;8945:42;;;8981:5;8945:42;;;;;;;;;;;;;;;;;;;;;;9005:4;8998:11;;8687:329;;;:::o;9022:249::-;9076:12;9129:1;9107:24;;:10;:24;;;;9099:33;;;;;;;;9171:12;9143:13;:25;9157:10;9143:25;;;;;;;;;;;;;;;:40;;;;;;;;;;;;:::i;:::-;;9217:10;9199:43;;;9229:12;9199:43;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;9199:43:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;9260:4;9253:11;;9022:249;;;:::o;2830:104::-;2876:12;2906:21;2916:10;2906:9;:21::i;:::-;2899:28;;2830:104;:::o;11247:145::-;11320:18;11356:13;:29;11370:14;11356:29;;;;;;;;;;;;;;;11349:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;11247:145;;;:::o;3119:280::-;3202:14;3258:1;3235:25;;:11;:25;;;;3227:34;;;;;;;;3299:1;3279:22;;:8;:22;;;;3271:31;;;;;;;;3335:8;3320:23;;:11;:23;;;;3312:32;;;;;;;;3362:7;:20;3370:11;3362:20;;;;;;;;;;;;;;;:30;3383:8;3362:30;;;;;;;;;;;;;;;;3355:37;;3119:280;;;;:::o;6893:211::-;6961:12;763:5:2;;;;;;;;;;;749:19;;:10;:19;;;741:28;;;;;;;;7028:1:0;6992:7;7000:11;6992:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;6992:20:0;;;;;;;;;;;;;;;;;;;;;:32;;;:37;;6984:46;;;;;;;;7071:4;7041:7;7049:11;7041:20;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;7041:20:0;;;;;;;;;;;;;;;;;;;;;:27;;;:34;;;;;;;;;;;;;;;;;;7093:4;7086:11;;6893:211;;;:::o;9277:261::-;9346:12;763:5:2;;;;;;;;;;;749:19;;:10;:19;;;741:28;;;;;;;;9397:1:0;9377:22;;:8;:22;;;;9369:31;;;;;;;;9442:4;9411:18;:28;9430:8;9411:28;;;;;;;;;;;;;;;;:35;;;;;;;;;;;;;;;;;;9494:8;9462:47;;;9504:4;9462:47;;;;;;;;;;;;;;;;;;;;;;9527:4;9520:11;;9277:261;;;:::o;9544:266::-;9616:12;763:5:2;;;;;;;;;;;749:19;;:10;:19;;;741:28;;;;;;;;9667:1:0;9647:22;;:8;:22;;;;9639:31;;;;;;;;9712:5;9681:18;:28;9700:8;9681:28;;;;;;;;;;;;;;;;:36;;;;;;;;;;;;;;;;;;9765:8;9733:48;;;9775:5;9733:48;;;;;;;;;;;;;;;;;;;;;;9799:4;9792:11;;9544:266;;;:::o;1358:109:2:-;763:5;;;;;;;;;;;749:19;;:10;:19;;;741:28;;;;;;;;1431:29;1450:9;1431:18;:29::i;:::-;1358:109;:::o;1691:121:3:-;1749:7;1781:1;1776;:6;;1768:15;;;;;;;;1804:1;1800;:5;;;;;;;;1793:12;;1691:121;;;;:::o;1177:151::-;1237:7;1283:9;1270:2;1264;:8;;1256:17;;;;;;;;1300:2;1295;:7;1283:19;;1320:1;1313:8;;1177:151;;;;;:::o;759:297::-;819:7;921:9;851:1;846:2;:6;838:15;;;;;;;;938:2;933;:7;;;;;;;;921:19;;1048:1;1041:8;;759:297;;;;;:::o;213:428::-;273:7;565:9;519:1;513:2;:7;509:46;;;543:1;536:8;;;;509:46;582:2;577;:7;565:19;;612:2;606;602:1;:6;;;;;;;;:12;594:21;;;;;;;;633:1;626:8;;213:428;;;;;;:::o;5470:356:0:-;5540:12;5593:40;5625:7;5593:16;:27;5610:9;5593:27;;;;;;;;;;;;;;;;:31;;:40;;;;:::i;:::-;5563:16;:27;5580:9;5563:27;;;;;;;;;;;;;;;:70;;;;5657:24;5673:7;5657:11;;:15;;:24;;;;:::i;:::-;5643:11;:38;;;;5710:9;5697:45;;;5721:7;5730:11;;5697:45;;;;;;;;;;;;;;;;;;;;;;;;5778:9;5757:40;;5774:1;5757:40;;;5789:7;5757:40;;;;;;;;;;;;;;;;;;5815:4;5808:11;;5470:356;;;;:::o;1399:150:3:-;1459:7;1478:9;1495:2;1490;:7;1478:19;;1520:2;1515:1;:7;;1507:16;;;;;;;;1541:1;1534:8;;1399:150;;;;;:::o;1612:185:2:-;1707:1;1686:23;;:9;:23;;;;1678:32;;;;;;;;1753:9;1725:38;;1746:5;;;;;;;;;;;1725:38;;;;;;;;;;;;1781:9;1773:5;;:17;;;;;;;;;;;;;;;;;;1612:185;:::o;147:11247:0:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.24;\n\nimport \"./open-zeppellin/SafeMath.sol\";\nimport \"./open-zeppellin/Ownable.sol\";\nimport \"./interface/ERC20Interface.sol\";\n\ncontract AsyncCoin is Ownable, ERC20Interface {\n    struct Coupon {\n        string code;\n        uint256 tokenReward;\n        uint256 timesUsable;\n        bool infinite;\n        bool active;\n    }\n\n    // We need SafeMath to guard against number overflow\n    using SafeMath for uint256;\n\n    event Transfer(address indexed from, address indexed to, uint256 tokens);\n    event Approval(address indexed tokenOwner, address indexed spender, uint256 tokens);\n    event TokensMinted(address indexed to, uint256 tokens, uint256 newTotalSupply);\n    event AddressFreezeChange(address indexed to, bool state);\n    event TokensBought(address indexed to, uint tokens);\n    event AddressNameChange(address indexed to, string name);\n    event AddressCanBuyTokensStatusChange(address indexed to, bool state);\n\n    string public constant name = \"AsyncCoin\";\n    string public constant symbol = \"ASC\";\n\n    // Async Coin is a coin, there is no smaller unit\n    uint8 public constant decimals = 0;\n    // Total Available supply updated when total supply increases\n    uint256 public totalSupply;\n\n    // Ether pipe storage\n    uint256 public etherBalance;\n\n    // Here we store final value of Tokens for adress\n    mapping(address => uint256) public addressToBalance;\n\n    // Here approved withdrawing from other users account\n    // Structure allowed[tokenOwner][spender] => allowedTokens to spend\n    mapping(address => mapping(address => uint)) allowed;\n\n    // Here we store coupons\n    // Structure: coupons[couponCode] => Coupon\n    mapping(string => Coupon) coupons;\n\n    // Here we store redeemed coupons\n    // Structure: redeemedCoupons[receiver][couponCode] => tokensReceived\n    mapping(address => mapping(string => bool)) redeemedCoupons;\n\n    // Here we store addresses of users who are blocked by admin\n    mapping(address => bool) frozenAddresses;\n\n    // Additional storing of names with addresses\n    mapping(address => string) addressToName;\n\n    // Who can buy tokens with Ether\n    mapping(address => bool) allowedToBuyTokens;\n\n    constructor() public {\n        // Initial OwnerDashboardPage address must be different than address(0), I forgot what address(0) is, but let's say its null address\n        require(msg.sender != address(0), \"Owner can't be empty.\");\n        // Set Contract owner to be creator of Contract\n        owner = msg.sender;\n\n        // Init total supply at 0, because tokens are minted only after coupons are redeemed\n        totalSupply = 0;\n    }\n\n    function isOwner() public constant returns (bool success){\n        return msg.sender == owner;\n    }\n\n    function totalSupply() public constant returns (uint){\n        return totalSupply;\n    }\n\n    function myBalance() public constant returns (uint balance){\n        return balanceOf(msg.sender);\n    }\n\n    function balanceOf(address tokenOwner) public constant returns (uint balance){\n        require(tokenOwner != address(0));\n\n        return addressToBalance[tokenOwner];\n    }\n\n    function allowance(address _tokenOwner, address _spender) public constant returns (uint remaining){\n        require(_tokenOwner != address(0));\n        require(_spender != address(0));\n        require(_tokenOwner != _spender);\n\n        return allowed[_tokenOwner][_spender];\n    }\n\n    function transfer(address _to, uint _tokens) public returns (bool success){\n        require(_to != address(0), \"Receiving address can't be null.\");\n        require(_to != msg.sender, \"Can't sent tokens to yourself.\");\n        require(_tokens > 0, \"Number of sent tokens must be bigger than zero.\");\n        require(addressToBalance[msg.sender] >= _tokens, \"Sender has to have enough tokens to transfer them.\");\n        // We can't transfer tokens from frozen address\n        require(frozenAddresses[msg.sender] == false, \"Your account is frozen, so you can't make this transaction.\");\n\n        // Actual transfer of tokens\n        addressToBalance[msg.sender] = addressToBalance[msg.sender].sub(_tokens);\n        addressToBalance[_to] = addressToBalance[_to].add(_tokens);\n        emit Transfer(msg.sender, _to, _tokens);\n\n        return true;\n    }\n\n    function transferFrom(address _from, address _to, uint _tokens) public returns (bool success){\n        // Check if spender can spend owners tokens\n        require(_from != address(0));\n        require(_to != address(0));\n        require(_from != _to);\n        require(_tokens > 0);\n        require(allowed[_from][_to] >= _tokens);\n        require(addressToBalance[_from] >= _tokens);\n        // We can't transfer tokens from frozen address\n        require(frozenAddresses[_from] == false);\n\n        // Withdraw tokens\n        addressToBalance[_from] = addressToBalance[_from].sub(_tokens);\n        allowed[_from][msg.sender] = allowed[_from][msg.sender].sub(_tokens);\n        addressToBalance[_to] = addressToBalance[_to].add(_tokens);\n        emit Transfer(_from, _to, _tokens);\n\n        return true;\n    }\n\n    function approve(address _spender, uint _tokens) public returns (bool success){\n        require(_spender != address(0));\n        require(_spender != msg.sender);\n        require(_tokens > 0);\n\n        allowed[msg.sender][_spender] = allowed[msg.sender][_spender].add(_tokens);\n        emit Approval(msg.sender, _spender, _tokens);\n\n        return true;\n    }\n\n    // Mint tokens from thin air\n    function mintTokens(address _receiver, uint _tokens) private returns (bool success){\n        addressToBalance[_receiver] = addressToBalance[_receiver].add(_tokens);\n        totalSupply = totalSupply.add(_tokens);\n\n        emit TokensMinted(_receiver, _tokens, totalSupply);\n        emit Transfer(address(0), _receiver, _tokens);\n\n        return true;\n    }\n\n    function ownerMintTokens(address _receiver, uint _tokens) public onlyOwner returns (bool success){\n        require(_receiver != address(0));\n        require(_tokens > 0);\n\n        mintTokens(_receiver, _tokens);\n\n        return true;\n    }\n\n    function createCoupon(string _couponCode, uint _tokenReward, uint _timeCouponCanBeUsed) public onlyOwner returns (bool success){\n        require(_tokenReward > 0);\n        require(bytes(_couponCode).length > 0);\n        // Check that coupon doesn't exist\n        require(coupons[_couponCode].tokenReward == 0);\n\n        coupons[_couponCode] = Coupon({\n            code : _couponCode,\n            tokenReward : _tokenReward,\n            timesUsable : _timeCouponCanBeUsed,\n            active : true,\n            infinite : _timeCouponCanBeUsed == 0\n            });\n\n        return true;\n    }\n\n    function disableCoupon(string _couponCode) public onlyOwner returns (bool success){\n        require(coupons[_couponCode].tokenReward != 0);\n\n        coupons[_couponCode].active = false;\n\n        return true;\n    }\n\n    function enableCoupon(string _couponCode) public onlyOwner returns (bool success){\n        require(coupons[_couponCode].tokenReward != 0);\n\n        coupons[_couponCode].active = true;\n\n        return true;\n    }\n\n    function redeemCoupon(string _couponCode) public returns (bool success){\n        require(msg.sender != address(0));\n        require(bytes(_couponCode).length > 0);\n        // Check does Coupon exist or is active\n        require(coupons[_couponCode].active == true);\n        // Check if coupon still has uses on it and is not infinite\n        if (coupons[_couponCode].infinite == false) {\n            require(coupons[_couponCode].timesUsable > 0);\n        }\n        // Check that coupon isn't already redeemed by this address\n        require(!redeemedCoupons[msg.sender][_couponCode]);\n\n        // Remove use if it's NOT infinite\n        if (coupons[_couponCode].infinite == false) {\n            coupons[_couponCode].timesUsable = coupons[_couponCode].timesUsable.sub(1);\n\n            // If coupon was used by everyone, set it to not active\n            if (coupons[_couponCode].timesUsable < 1) {\n                coupons[_couponCode].active = false;\n            }\n        }\n\n        // This needs to be before, so we prepare reentrancy\n        redeemedCoupons[msg.sender][_couponCode] = true;\n        mintTokens(msg.sender, coupons[_couponCode].tokenReward);\n\n        return true;\n    }\n\n\n    // Freeze/Ban user\n    function freezeAddress(address _frozenAddress) public onlyOwner returns (bool success){\n        require(_frozenAddress != address(0));\n        require(msg.sender != _frozenAddress);\n\n        frozenAddresses[_frozenAddress] = true;\n        emit AddressFreezeChange(_frozenAddress, true);\n\n        return true;\n    }\n\n    // Allow address to have transactions\n    function unfreezeAddress(address _frozenAddress) public onlyOwner returns (bool success){\n        require(_frozenAddress != address(0));\n        require(frozenAddresses[_frozenAddress] == true);\n\n        frozenAddresses[_frozenAddress] = false;\n        emit AddressFreezeChange(_frozenAddress, false);\n\n        return true;\n    }\n\n    function setName(string _addressName) public returns (bool success){\n        require(msg.sender != address(0));\n\n        addressToName[msg.sender] = _addressName;\n\n        emit AddressNameChange(msg.sender, _addressName);\n\n        return true;\n    }\n\n    function setAllowedToBuy(address _address) public onlyOwner returns (bool success){\n        require(_address != address(0));\n\n        allowedToBuyTokens[_address] = true;\n\n        emit AddressCanBuyTokensStatusChange(_address, true);\n\n        return true;\n    }\n\n    function setNotAllowedToBuy(address _address) public onlyOwner returns (bool success){\n        require(_address != address(0));\n\n        allowedToBuyTokens[_address] = false;\n\n        emit AddressCanBuyTokensStatusChange(_address, false);\n\n        return true;\n    }\n\n    function canBuyTokens(address _address) public constant returns (bool addressCanBuyTokens){\n        return allowedToBuyTokens[_address] == true || _address == owner;\n    }\n\n    function buyTokens() public payable returns (bool success){\n        require(msg.sender != address(0));\n        require(msg.value > 0);\n        require(allowedToBuyTokens[msg.sender] == true || owner == msg.sender);\n\n        uint remaining = (msg.value).mod(1 ether);\n        uint spentEther = (msg.value).sub(remaining);\n        uint tokensBought = spentEther.div(1 ether).mul(10);\n\n        require(spentEther > 0);\n\n        owner.transfer(spentEther);\n        msg.sender.transfer(remaining);\n        mintTokens(msg.sender, tokensBought);\n\n        emit TokensBought(msg.sender, tokensBought);\n\n        return true;\n    }\n\n    function() public payable {\n        buyTokens();\n    }\n\n    function sendEtherToContract() public payable returns (bool success){\n        require(msg.sender != address(0));\n        require(msg.value > 0);\n\n        etherBalance = etherBalance.add(msg.value);\n\n        return true;\n    }\n\n    function getEtherFromContract() public returns (bool success){\n        require(etherBalance >= 1 ether);\n\n        msg.sender.transfer(1 ether);\n        etherBalance = etherBalance.sub(1 ether);\n\n        return true;\n    }\n\n    function getContractEtherBalance() public constant returns (uint256){\n        return etherBalance;\n    }\n\n    function getAddressName(address _addressToFind) public constant returns (string addressName){\n        return addressToName[_addressToFind];\n    }\n}\n",
	"sourcePath": "/home/marko/EthereumAsyncProjects/AsyncCoinContract/contracts/AsyncCoin.sol",
	"ast": {
		"absolutePath": "/home/marko/EthereumAsyncProjects/AsyncCoinContract/contracts/AsyncCoin.sol",
		"exportedSymbols": {
			"AsyncCoin": [
				1164
			]
		},
		"id": 1165,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:0"
			},
			{
				"absolutePath": "/home/marko/EthereumAsyncProjects/AsyncCoinContract/contracts/open-zeppellin/SafeMath.sol",
				"file": "./open-zeppellin/SafeMath.sol",
				"id": 2,
				"nodeType": "ImportDirective",
				"scope": 1165,
				"sourceUnit": 1448,
				"src": "26:39:0",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/home/marko/EthereumAsyncProjects/AsyncCoinContract/contracts/open-zeppellin/Ownable.sol",
				"file": "./open-zeppellin/Ownable.sol",
				"id": 3,
				"nodeType": "ImportDirective",
				"scope": 1165,
				"sourceUnit": 1320,
				"src": "66:38:0",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/home/marko/EthereumAsyncProjects/AsyncCoinContract/contracts/interface/ERC20Interface.sol",
				"file": "./interface/ERC20Interface.sol",
				"id": 4,
				"nodeType": "ImportDirective",
				"scope": 1165,
				"sourceUnit": 1234,
				"src": "105:40:0",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 5,
							"name": "Ownable",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 1319,
							"src": "169:7:0",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Ownable_$1319",
								"typeString": "contract Ownable"
							}
						},
						"id": 6,
						"nodeType": "InheritanceSpecifier",
						"src": "169:7:0"
					},
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 7,
							"name": "ERC20Interface",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 1233,
							"src": "178:14:0",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_ERC20Interface_$1233",
								"typeString": "contract ERC20Interface"
							}
						},
						"id": 8,
						"nodeType": "InheritanceSpecifier",
						"src": "178:14:0"
					}
				],
				"contractDependencies": [
					1233,
					1319
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1164,
				"linearizedBaseContracts": [
					1164,
					1233,
					1319
				],
				"name": "AsyncCoin",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"canonicalName": "AsyncCoin.Coupon",
						"id": 19,
						"members": [
							{
								"constant": false,
								"id": 10,
								"name": "code",
								"nodeType": "VariableDeclaration",
								"scope": 19,
								"src": "223:11:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_string_storage_ptr",
									"typeString": "string"
								},
								"typeName": {
									"id": 9,
									"name": "string",
									"nodeType": "ElementaryTypeName",
									"src": "223:6:0",
									"typeDescriptions": {
										"typeIdentifier": "t_string_storage_ptr",
										"typeString": "string"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 12,
								"name": "tokenReward",
								"nodeType": "VariableDeclaration",
								"scope": 19,
								"src": "244:19:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 11,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "244:7:0",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 14,
								"name": "timesUsable",
								"nodeType": "VariableDeclaration",
								"scope": 19,
								"src": "273:19:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 13,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "273:7:0",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 16,
								"name": "infinite",
								"nodeType": "VariableDeclaration",
								"scope": 19,
								"src": "302:13:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								},
								"typeName": {
									"id": 15,
									"name": "bool",
									"nodeType": "ElementaryTypeName",
									"src": "302:4:0",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 18,
								"name": "active",
								"nodeType": "VariableDeclaration",
								"scope": 19,
								"src": "325:11:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								},
								"typeName": {
									"id": 17,
									"name": "bool",
									"nodeType": "ElementaryTypeName",
									"src": "325:4:0",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									}
								},
								"value": null,
								"visibility": "internal"
							}
						],
						"name": "Coupon",
						"nodeType": "StructDefinition",
						"scope": 1164,
						"src": "199:144:0",
						"visibility": "public"
					},
					{
						"id": 22,
						"libraryName": {
							"contractScope": null,
							"id": 20,
							"name": "SafeMath",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 1447,
							"src": "412:8:0",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_SafeMath_$1447",
								"typeString": "library SafeMath"
							}
						},
						"nodeType": "UsingForDirective",
						"src": "406:27:0",
						"typeName": {
							"id": 21,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "425:7:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						}
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 30,
						"name": "Transfer",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 29,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 24,
									"indexed": true,
									"name": "from",
									"nodeType": "VariableDeclaration",
									"scope": 30,
									"src": "454:20:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 23,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "454:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 26,
									"indexed": true,
									"name": "to",
									"nodeType": "VariableDeclaration",
									"scope": 30,
									"src": "476:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 25,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "476:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 28,
									"indexed": false,
									"name": "tokens",
									"nodeType": "VariableDeclaration",
									"scope": 30,
									"src": "496:14:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 27,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "496:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "453:58:0"
						},
						"src": "439:73:0"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 38,
						"name": "Approval",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 37,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 32,
									"indexed": true,
									"name": "tokenOwner",
									"nodeType": "VariableDeclaration",
									"scope": 38,
									"src": "532:26:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 31,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "532:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 34,
									"indexed": true,
									"name": "spender",
									"nodeType": "VariableDeclaration",
									"scope": 38,
									"src": "560:23:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 33,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "560:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 36,
									"indexed": false,
									"name": "tokens",
									"nodeType": "VariableDeclaration",
									"scope": 38,
									"src": "585:14:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 35,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "585:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "531:69:0"
						},
						"src": "517:84:0"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 46,
						"name": "TokensMinted",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 45,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 40,
									"indexed": true,
									"name": "to",
									"nodeType": "VariableDeclaration",
									"scope": 46,
									"src": "625:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 39,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "625:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 42,
									"indexed": false,
									"name": "tokens",
									"nodeType": "VariableDeclaration",
									"scope": 46,
									"src": "645:14:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 41,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "645:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 44,
									"indexed": false,
									"name": "newTotalSupply",
									"nodeType": "VariableDeclaration",
									"scope": 46,
									"src": "661:22:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 43,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "661:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "624:60:0"
						},
						"src": "606:79:0"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 52,
						"name": "AddressFreezeChange",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 51,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 48,
									"indexed": true,
									"name": "to",
									"nodeType": "VariableDeclaration",
									"scope": 52,
									"src": "716:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 47,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "716:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 50,
									"indexed": false,
									"name": "state",
									"nodeType": "VariableDeclaration",
									"scope": 52,
									"src": "736:10:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 49,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "736:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "715:32:0"
						},
						"src": "690:58:0"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 58,
						"name": "TokensBought",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 57,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 54,
									"indexed": true,
									"name": "to",
									"nodeType": "VariableDeclaration",
									"scope": 58,
									"src": "772:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 53,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "772:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 56,
									"indexed": false,
									"name": "tokens",
									"nodeType": "VariableDeclaration",
									"scope": 58,
									"src": "792:11:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 55,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "792:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "771:33:0"
						},
						"src": "753:52:0"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 64,
						"name": "AddressNameChange",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 63,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 60,
									"indexed": true,
									"name": "to",
									"nodeType": "VariableDeclaration",
									"scope": 64,
									"src": "834:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 59,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "834:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 62,
									"indexed": false,
									"name": "name",
									"nodeType": "VariableDeclaration",
									"scope": 64,
									"src": "854:11:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 61,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "854:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "833:33:0"
						},
						"src": "810:57:0"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 70,
						"name": "AddressCanBuyTokensStatusChange",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 69,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 66,
									"indexed": true,
									"name": "to",
									"nodeType": "VariableDeclaration",
									"scope": 70,
									"src": "910:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 65,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "910:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 68,
									"indexed": false,
									"name": "state",
									"nodeType": "VariableDeclaration",
									"scope": 70,
									"src": "930:10:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 67,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "930:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "909:32:0"
						},
						"src": "872:70:0"
					},
					{
						"constant": true,
						"id": 73,
						"name": "name",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "948:41:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_string_memory",
							"typeString": "string"
						},
						"typeName": {
							"id": 71,
							"name": "string",
							"nodeType": "ElementaryTypeName",
							"src": "948:6:0",
							"typeDescriptions": {
								"typeIdentifier": "t_string_storage_ptr",
								"typeString": "string"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "4173796e63436f696e",
							"id": 72,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "string",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "978:11:0",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_stringliteral_946342d9d738e5fc5b5dd6b522fe4479e6dabaf2260b065b3234fe31cd82028e",
								"typeString": "literal_string \"AsyncCoin\""
							},
							"value": "AsyncCoin"
						},
						"visibility": "public"
					},
					{
						"constant": true,
						"id": 76,
						"name": "symbol",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "995:37:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_string_memory",
							"typeString": "string"
						},
						"typeName": {
							"id": 74,
							"name": "string",
							"nodeType": "ElementaryTypeName",
							"src": "995:6:0",
							"typeDescriptions": {
								"typeIdentifier": "t_string_storage_ptr",
								"typeString": "string"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "415343",
							"id": 75,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "string",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1027:5:0",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_stringliteral_5f832cd8e5ac2aef6affd696bae37ca133688daf268e883c50499a707b642c07",
								"typeString": "literal_string \"ASC\""
							},
							"value": "ASC"
						},
						"visibility": "public"
					},
					{
						"constant": true,
						"id": 79,
						"name": "decimals",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1093:34:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint8",
							"typeString": "uint8"
						},
						"typeName": {
							"id": 77,
							"name": "uint8",
							"nodeType": "ElementaryTypeName",
							"src": "1093:5:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint8",
								"typeString": "uint8"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "30",
							"id": 78,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1126:1:0",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_0_by_1",
								"typeString": "int_const 0"
							},
							"value": "0"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 81,
						"name": "totalSupply",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1199:26:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 80,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "1199:7:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 83,
						"name": "etherBalance",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1258:27:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 82,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "1258:7:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 87,
						"name": "addressToBalance",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1346:51:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
							"typeString": "mapping(address => uint256)"
						},
						"typeName": {
							"id": 86,
							"keyType": {
								"id": 84,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "1354:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "1346:27:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
								"typeString": "mapping(address => uint256)"
							},
							"valueType": {
								"id": 85,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "1365:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 93,
						"name": "allowed",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1534:52:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
							"typeString": "mapping(address => mapping(address => uint256))"
						},
						"typeName": {
							"id": 92,
							"keyType": {
								"id": 88,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "1542:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "1534:44:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
								"typeString": "mapping(address => mapping(address => uint256))"
							},
							"valueType": {
								"id": 91,
								"keyType": {
									"id": 89,
									"name": "address",
									"nodeType": "ElementaryTypeName",
									"src": "1561:7:0",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									}
								},
								"nodeType": "Mapping",
								"src": "1553:24:0",
								"typeDescriptions": {
									"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
									"typeString": "mapping(address => uint256)"
								},
								"valueType": {
									"id": 90,
									"name": "uint",
									"nodeType": "ElementaryTypeName",
									"src": "1572:4:0",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 97,
						"name": "coupons",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1670:33:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
							"typeString": "mapping(string => struct AsyncCoin.Coupon)"
						},
						"typeName": {
							"id": 96,
							"keyType": {
								"id": 94,
								"name": "string",
								"nodeType": "ElementaryTypeName",
								"src": "1678:6:0",
								"typeDescriptions": {
									"typeIdentifier": "t_string_storage_ptr",
									"typeString": "string"
								}
							},
							"nodeType": "Mapping",
							"src": "1670:25:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
								"typeString": "mapping(string => struct AsyncCoin.Coupon)"
							},
							"valueType": {
								"contractScope": null,
								"id": 95,
								"name": "Coupon",
								"nodeType": "UserDefinedTypeName",
								"referencedDeclaration": 19,
								"src": "1688:6:0",
								"typeDescriptions": {
									"typeIdentifier": "t_struct$_Coupon_$19_storage_ptr",
									"typeString": "struct AsyncCoin.Coupon"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 103,
						"name": "redeemedCoupons",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1822:59:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_string_memory_$_t_bool_$_$",
							"typeString": "mapping(address => mapping(string => bool))"
						},
						"typeName": {
							"id": 102,
							"keyType": {
								"id": 98,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "1830:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "1822:43:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_string_memory_$_t_bool_$_$",
								"typeString": "mapping(address => mapping(string => bool))"
							},
							"valueType": {
								"id": 101,
								"keyType": {
									"id": 99,
									"name": "string",
									"nodeType": "ElementaryTypeName",
									"src": "1849:6:0",
									"typeDescriptions": {
										"typeIdentifier": "t_string_storage_ptr",
										"typeString": "string"
									}
								},
								"nodeType": "Mapping",
								"src": "1841:23:0",
								"typeDescriptions": {
									"typeIdentifier": "t_mapping$_t_string_memory_$_t_bool_$",
									"typeString": "mapping(string => bool)"
								},
								"valueType": {
									"id": 100,
									"name": "bool",
									"nodeType": "ElementaryTypeName",
									"src": "1859:4:0",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									}
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 107,
						"name": "frozenAddresses",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1953:40:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
							"typeString": "mapping(address => bool)"
						},
						"typeName": {
							"id": 106,
							"keyType": {
								"id": 104,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "1961:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "1953:24:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
								"typeString": "mapping(address => bool)"
							},
							"valueType": {
								"id": 105,
								"name": "bool",
								"nodeType": "ElementaryTypeName",
								"src": "1972:4:0",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 111,
						"name": "addressToName",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "2050:40:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_string_storage_$",
							"typeString": "mapping(address => string)"
						},
						"typeName": {
							"id": 110,
							"keyType": {
								"id": 108,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "2058:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "2050:26:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_string_storage_$",
								"typeString": "mapping(address => string)"
							},
							"valueType": {
								"id": 109,
								"name": "string",
								"nodeType": "ElementaryTypeName",
								"src": "2069:6:0",
								"typeDescriptions": {
									"typeIdentifier": "t_string_storage_ptr",
									"typeString": "string"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 115,
						"name": "allowedToBuyTokens",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "2134:43:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
							"typeString": "mapping(address => bool)"
						},
						"typeName": {
							"id": 114,
							"keyType": {
								"id": 112,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "2142:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "2134:24:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
								"typeString": "mapping(address => bool)"
							},
							"valueType": {
								"id": 113,
								"name": "bool",
								"nodeType": "ElementaryTypeName",
								"src": "2153:4:0",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 137,
							"nodeType": "Block",
							"src": "2205:419:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 124,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 119,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "2364:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 120,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "2364:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 122,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "2386:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 121,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "2378:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 123,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2378:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "2364:24:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4f776e65722063616e277420626520656d7074792e",
												"id": 125,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "2390:23:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_634950abcb8478dd0330e12f30b8d97418887bd958dc983f2d95ac6b97db28db",
													"typeString": "literal_string \"Owner can't be empty.\""
												},
												"value": "Owner can't be empty."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_634950abcb8478dd0330e12f30b8d97418887bd958dc983f2d95ac6b97db28db",
													"typeString": "literal_string \"Owner can't be empty.\""
												}
											],
											"id": 118,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1466,
											"src": "2356:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 126,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2356:58:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 127,
									"nodeType": "ExpressionStatement",
									"src": "2356:58:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 131,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 128,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1237,
											"src": "2480:5:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 129,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1462,
												"src": "2488:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 130,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sender",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "2488:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "2480:18:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 132,
									"nodeType": "ExpressionStatement",
									"src": "2480:18:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 135,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 133,
											"name": "totalSupply",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												81
											],
											"referencedDeclaration": 81,
											"src": "2602:11:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 134,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "2616:1:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "2602:15:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 136,
									"nodeType": "ExpressionStatement",
									"src": "2602:15:0"
								}
							]
						},
						"documentation": null,
						"id": 138,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 116,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2195:2:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 117,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2205:0:0"
						},
						"scope": 1164,
						"src": "2184:440:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 148,
							"nodeType": "Block",
							"src": "2687:43:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										},
										"id": 146,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 143,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1462,
												"src": "2704:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 144,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sender",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "2704:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"id": 145,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1237,
											"src": "2718:5:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "2704:19:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 142,
									"id": 147,
									"nodeType": "Return",
									"src": "2697:26:0"
								}
							]
						},
						"documentation": null,
						"id": 149,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "isOwner",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 139,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2646:2:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 142,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 141,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 149,
									"src": "2674:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 140,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "2674:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2673:14:0"
						},
						"scope": 1164,
						"src": "2630:100:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 156,
							"nodeType": "Block",
							"src": "2789:35:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 154,
										"name": "totalSupply",
										"nodeType": "Identifier",
										"overloadedDeclarations": [
											81
										],
										"referencedDeclaration": 81,
										"src": "2806:11:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 153,
									"id": 155,
									"nodeType": "Return",
									"src": "2799:18:0"
								}
							]
						},
						"documentation": null,
						"id": 157,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "totalSupply",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 150,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2756:2:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 153,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 152,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 157,
									"src": "2784:4:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 151,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "2784:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2783:6:0"
						},
						"scope": 1164,
						"src": "2736:88:0",
						"stateMutability": "view",
						"superFunction": 1171,
						"visibility": "public"
					},
					{
						"body": {
							"id": 167,
							"nodeType": "Block",
							"src": "2889:45:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 163,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "2916:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 164,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "2916:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 162,
											"name": "balanceOf",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												188
											],
											"referencedDeclaration": 188,
											"src": "2906:9:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_view$_t_address_$returns$_t_uint256_$",
												"typeString": "function (address) view returns (uint256)"
											}
										},
										"id": 165,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2906:21:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 161,
									"id": 166,
									"nodeType": "Return",
									"src": "2899:28:0"
								}
							]
						},
						"documentation": null,
						"id": 168,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "myBalance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 158,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2848:2:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 161,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 160,
									"name": "balance",
									"nodeType": "VariableDeclaration",
									"scope": 168,
									"src": "2876:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 159,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "2876:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2875:14:0"
						},
						"scope": 1164,
						"src": "2830:104:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 187,
							"nodeType": "Block",
							"src": "3017:96:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 180,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 176,
													"name": "tokenOwner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 170,
													"src": "3035:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 178,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "3057:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 177,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "3049:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 179,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "3049:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "3035:24:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 175,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "3027:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 181,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3027:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 182,
									"nodeType": "ExpressionStatement",
									"src": "3027:33:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 183,
											"name": "addressToBalance",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 87,
											"src": "3078:16:0",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
												"typeString": "mapping(address => uint256)"
											}
										},
										"id": 185,
										"indexExpression": {
											"argumentTypes": null,
											"id": 184,
											"name": "tokenOwner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 170,
											"src": "3095:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "3078:28:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 174,
									"id": 186,
									"nodeType": "Return",
									"src": "3071:35:0"
								}
							]
						},
						"documentation": null,
						"id": 188,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "balanceOf",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 171,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 170,
									"name": "tokenOwner",
									"nodeType": "VariableDeclaration",
									"scope": 188,
									"src": "2959:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 169,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "2959:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2958:20:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 174,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 173,
									"name": "balance",
									"nodeType": "VariableDeclaration",
									"scope": 188,
									"src": "3004:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 172,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "3004:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "3003:14:0"
						},
						"scope": 1164,
						"src": "2940:173:0",
						"stateMutability": "view",
						"superFunction": 1178,
						"visibility": "public"
					},
					{
						"body": {
							"id": 225,
							"nodeType": "Block",
							"src": "3217:182:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 202,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 198,
													"name": "_tokenOwner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 190,
													"src": "3235:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 200,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "3258:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 199,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "3250:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 201,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "3250:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "3235:25:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 197,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "3227:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 203,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3227:34:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 204,
									"nodeType": "ExpressionStatement",
									"src": "3227:34:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 210,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 206,
													"name": "_spender",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 192,
													"src": "3279:8:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 208,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "3299:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 207,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "3291:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 209,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "3291:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "3279:22:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 205,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "3271:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 211,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3271:31:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 212,
									"nodeType": "ExpressionStatement",
									"src": "3271:31:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 216,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 214,
													"name": "_tokenOwner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 190,
													"src": "3320:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 215,
													"name": "_spender",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 192,
													"src": "3335:8:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "3320:23:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 213,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "3312:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 217,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3312:32:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 218,
									"nodeType": "ExpressionStatement",
									"src": "3312:32:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 219,
												"name": "allowed",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 93,
												"src": "3362:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
													"typeString": "mapping(address => mapping(address => uint256))"
												}
											},
											"id": 221,
											"indexExpression": {
												"argumentTypes": null,
												"id": 220,
												"name": "_tokenOwner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 190,
												"src": "3370:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "3362:20:0",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
												"typeString": "mapping(address => uint256)"
											}
										},
										"id": 223,
										"indexExpression": {
											"argumentTypes": null,
											"id": 222,
											"name": "_spender",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 192,
											"src": "3383:8:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "3362:30:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 196,
									"id": 224,
									"nodeType": "Return",
									"src": "3355:37:0"
								}
							]
						},
						"documentation": null,
						"id": 226,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "allowance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 193,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 190,
									"name": "_tokenOwner",
									"nodeType": "VariableDeclaration",
									"scope": 226,
									"src": "3138:19:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 189,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "3138:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 192,
									"name": "_spender",
									"nodeType": "VariableDeclaration",
									"scope": 226,
									"src": "3159:16:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 191,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "3159:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "3137:39:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 196,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 195,
									"name": "remaining",
									"nodeType": "VariableDeclaration",
									"scope": 226,
									"src": "3202:14:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 194,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "3202:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "3201:16:0"
						},
						"scope": 1164,
						"src": "3119:280:0",
						"stateMutability": "view",
						"superFunction": 1187,
						"visibility": "public"
					},
					{
						"body": {
							"id": 312,
							"nodeType": "Block",
							"src": "3479:775:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 240,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 236,
													"name": "_to",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 228,
													"src": "3497:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 238,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "3512:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 237,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "3504:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 239,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "3504:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "3497:17:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "526563656976696e6720616464726573732063616e2774206265206e756c6c2e",
												"id": 241,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "3516:34:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_6d5fdf6af8261d9a72c25f6bc01c1a2c29bcc416d9522e22de92761934f87ef5",
													"typeString": "literal_string \"Receiving address can't be null.\""
												},
												"value": "Receiving address can't be null."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_6d5fdf6af8261d9a72c25f6bc01c1a2c29bcc416d9522e22de92761934f87ef5",
													"typeString": "literal_string \"Receiving address can't be null.\""
												}
											],
											"id": 235,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1466,
											"src": "3489:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 242,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3489:62:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 243,
									"nodeType": "ExpressionStatement",
									"src": "3489:62:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 248,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 245,
													"name": "_to",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 228,
													"src": "3569:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 246,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "3576:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 247,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "3576:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "3569:17:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "43616e27742073656e7420746f6b656e7320746f20796f757273656c662e",
												"id": 249,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "3588:32:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_1a17f82f54ef3f6fe463f559ee8301b95cff1cc53df2855bcf30073872397d2d",
													"typeString": "literal_string \"Can't sent tokens to yourself.\""
												},
												"value": "Can't sent tokens to yourself."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_1a17f82f54ef3f6fe463f559ee8301b95cff1cc53df2855bcf30073872397d2d",
													"typeString": "literal_string \"Can't sent tokens to yourself.\""
												}
											],
											"id": 244,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1466,
											"src": "3561:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 250,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3561:60:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 251,
									"nodeType": "ExpressionStatement",
									"src": "3561:60:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 255,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 253,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 230,
													"src": "3639:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 254,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "3649:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "3639:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4e756d626572206f662073656e7420746f6b656e73206d75737420626520626967676572207468616e207a65726f2e",
												"id": 256,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "3652:49:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_587a5ac3c46e5f4f85b60e367c506728bc721ff94224395f3e325d3bb49c6c62",
													"typeString": "literal_string \"Number of sent tokens must be bigger than zero.\""
												},
												"value": "Number of sent tokens must be bigger than zero."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_587a5ac3c46e5f4f85b60e367c506728bc721ff94224395f3e325d3bb49c6c62",
													"typeString": "literal_string \"Number of sent tokens must be bigger than zero.\""
												}
											],
											"id": 252,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1466,
											"src": "3631:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 257,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3631:71:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 258,
									"nodeType": "ExpressionStatement",
									"src": "3631:71:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 265,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 260,
														"name": "addressToBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 87,
														"src": "3720:16:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 263,
													"indexExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 261,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1462,
															"src": "3737:3:0",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 262,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "3737:10:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "3720:28:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 264,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 230,
													"src": "3752:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "3720:39:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "53656e6465722068617320746f206861766520656e6f75676820746f6b656e7320746f207472616e73666572207468656d2e",
												"id": 266,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "3761:52:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_7330adee06735ce1ece281681981471736da8ebd318c34c473f3c0fd645c9bbe",
													"typeString": "literal_string \"Sender has to have enough tokens to transfer them.\""
												},
												"value": "Sender has to have enough tokens to transfer them."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_7330adee06735ce1ece281681981471736da8ebd318c34c473f3c0fd645c9bbe",
													"typeString": "literal_string \"Sender has to have enough tokens to transfer them.\""
												}
											],
											"id": 259,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1466,
											"src": "3712:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 267,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3712:102:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 268,
									"nodeType": "ExpressionStatement",
									"src": "3712:102:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 275,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 270,
														"name": "frozenAddresses",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 107,
														"src": "3888:15:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
															"typeString": "mapping(address => bool)"
														}
													},
													"id": 273,
													"indexExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 271,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1462,
															"src": "3904:3:0",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 272,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "3904:10:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "3888:27:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 274,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "3919:5:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												},
												"src": "3888:36:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "596f7572206163636f756e742069732066726f7a656e2c20736f20796f752063616e2774206d616b652074686973207472616e73616374696f6e2e",
												"id": 276,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "3926:61:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_3856f85f82a560a0a31551c9d6e47baac36cd12415d9e0d221798851c6ba3f6a",
													"typeString": "literal_string \"Your account is frozen, so you can't make this transaction.\""
												},
												"value": "Your account is frozen, so you can't make this transaction."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_3856f85f82a560a0a31551c9d6e47baac36cd12415d9e0d221798851c6ba3f6a",
													"typeString": "literal_string \"Your account is frozen, so you can't make this transaction.\""
												}
											],
											"id": 269,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1466,
											"src": "3880:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 277,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3880:108:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 278,
									"nodeType": "ExpressionStatement",
									"src": "3880:108:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 290,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 279,
												"name": "addressToBalance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 87,
												"src": "4036:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 282,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 280,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "4053:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 281,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "4053:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "4036:28:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 288,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 230,
													"src": "4100:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 283,
														"name": "addressToBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 87,
														"src": "4067:16:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 286,
													"indexExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 284,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1462,
															"src": "4084:3:0",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 285,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "4084:10:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4067:28:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 287,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sub",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1402,
												"src": "4067:32:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 289,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "4067:41:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "4036:72:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 291,
									"nodeType": "ExpressionStatement",
									"src": "4036:72:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 301,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 292,
												"name": "addressToBalance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 87,
												"src": "4118:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 294,
											"indexExpression": {
												"argumentTypes": null,
												"id": 293,
												"name": "_to",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 228,
												"src": "4135:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "4118:21:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 299,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 230,
													"src": "4168:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 295,
														"name": "addressToBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 87,
														"src": "4142:16:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 297,
													"indexExpression": {
														"argumentTypes": null,
														"id": 296,
														"name": "_to",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 228,
														"src": "4159:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4142:21:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 298,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "add",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1426,
												"src": "4142:25:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 300,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "4142:34:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "4118:58:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 302,
									"nodeType": "ExpressionStatement",
									"src": "4118:58:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 304,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "4200:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 305,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "4200:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 306,
												"name": "_to",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 228,
												"src": "4212:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 307,
												"name": "_tokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 230,
												"src": "4217:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 303,
											"name": "Transfer",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												30
											],
											"referencedDeclaration": 30,
											"src": "4191:8:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
												"typeString": "function (address,address,uint256)"
											}
										},
										"id": 308,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4191:34:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 309,
									"nodeType": "EmitStatement",
									"src": "4186:39:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 310,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "4243:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 234,
									"id": 311,
									"nodeType": "Return",
									"src": "4236:11:0"
								}
							]
						},
						"documentation": null,
						"id": 313,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "transfer",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 231,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 228,
									"name": "_to",
									"nodeType": "VariableDeclaration",
									"scope": 313,
									"src": "3423:11:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 227,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "3423:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 230,
									"name": "_tokens",
									"nodeType": "VariableDeclaration",
									"scope": 313,
									"src": "3436:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 229,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "3436:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "3422:27:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 234,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 233,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 313,
									"src": "3466:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 232,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "3466:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "3465:14:0"
						},
						"scope": 1164,
						"src": "3405:849:0",
						"stateMutability": "nonpayable",
						"superFunction": 1196,
						"visibility": "public"
					},
					{
						"body": {
							"id": 425,
							"nodeType": "Block",
							"src": "4353:714:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 329,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 325,
													"name": "_from",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 315,
													"src": "4423:5:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 327,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "4440:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 326,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "4432:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 328,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "4432:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "4423:19:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 324,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "4415:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 330,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4415:28:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 331,
									"nodeType": "ExpressionStatement",
									"src": "4415:28:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 337,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 333,
													"name": "_to",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 317,
													"src": "4461:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 335,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "4476:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 334,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "4468:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 336,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "4468:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "4461:17:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 332,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "4453:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 338,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4453:26:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 339,
									"nodeType": "ExpressionStatement",
									"src": "4453:26:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 343,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 341,
													"name": "_from",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 315,
													"src": "4497:5:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 342,
													"name": "_to",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 317,
													"src": "4506:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "4497:12:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 340,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "4489:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 344,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4489:21:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 345,
									"nodeType": "ExpressionStatement",
									"src": "4489:21:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 349,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 347,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 319,
													"src": "4528:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 348,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "4538:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "4528:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 346,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "4520:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 350,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4520:20:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 351,
									"nodeType": "ExpressionStatement",
									"src": "4520:20:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 359,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 353,
															"name": "allowed",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 93,
															"src": "4558:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
																"typeString": "mapping(address => mapping(address => uint256))"
															}
														},
														"id": 355,
														"indexExpression": {
															"argumentTypes": null,
															"id": 354,
															"name": "_from",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 315,
															"src": "4566:5:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "4558:14:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 357,
													"indexExpression": {
														"argumentTypes": null,
														"id": 356,
														"name": "_to",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 317,
														"src": "4573:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4558:19:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 358,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 319,
													"src": "4581:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "4558:30:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 352,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "4550:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 360,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4550:39:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 361,
									"nodeType": "ExpressionStatement",
									"src": "4550:39:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 367,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 363,
														"name": "addressToBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 87,
														"src": "4607:16:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 365,
													"indexExpression": {
														"argumentTypes": null,
														"id": 364,
														"name": "_from",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 315,
														"src": "4624:5:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4607:23:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 366,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 319,
													"src": "4634:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "4607:34:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 362,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "4599:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 368,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4599:43:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 369,
									"nodeType": "ExpressionStatement",
									"src": "4599:43:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 375,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 371,
														"name": "frozenAddresses",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 107,
														"src": "4716:15:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
															"typeString": "mapping(address => bool)"
														}
													},
													"id": 373,
													"indexExpression": {
														"argumentTypes": null,
														"id": 372,
														"name": "_from",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 315,
														"src": "4732:5:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4716:22:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 374,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "4742:5:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												},
												"src": "4716:31:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 370,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "4708:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 376,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4708:40:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 377,
									"nodeType": "ExpressionStatement",
									"src": "4708:40:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 387,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 378,
												"name": "addressToBalance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 87,
												"src": "4786:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 380,
											"indexExpression": {
												"argumentTypes": null,
												"id": 379,
												"name": "_from",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 315,
												"src": "4803:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "4786:23:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 385,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 319,
													"src": "4840:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 381,
														"name": "addressToBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 87,
														"src": "4812:16:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 383,
													"indexExpression": {
														"argumentTypes": null,
														"id": 382,
														"name": "_from",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 315,
														"src": "4829:5:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4812:23:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 384,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sub",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1402,
												"src": "4812:27:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 386,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "4812:36:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "4786:62:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 388,
									"nodeType": "ExpressionStatement",
									"src": "4786:62:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 404,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 389,
													"name": "allowed",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 93,
													"src": "4858:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
														"typeString": "mapping(address => mapping(address => uint256))"
													}
												},
												"id": 393,
												"indexExpression": {
													"argumentTypes": null,
													"id": 390,
													"name": "_from",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 315,
													"src": "4866:5:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "4858:14:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 394,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 391,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "4873:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 392,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "4873:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "4858:26:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 402,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 319,
													"src": "4918:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 395,
															"name": "allowed",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 93,
															"src": "4887:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
																"typeString": "mapping(address => mapping(address => uint256))"
															}
														},
														"id": 397,
														"indexExpression": {
															"argumentTypes": null,
															"id": 396,
															"name": "_from",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 315,
															"src": "4895:5:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "4887:14:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 400,
													"indexExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 398,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1462,
															"src": "4902:3:0",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 399,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "4902:10:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4887:26:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 401,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sub",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1402,
												"src": "4887:30:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 403,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "4887:39:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "4858:68:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 405,
									"nodeType": "ExpressionStatement",
									"src": "4858:68:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 415,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 406,
												"name": "addressToBalance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 87,
												"src": "4936:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 408,
											"indexExpression": {
												"argumentTypes": null,
												"id": 407,
												"name": "_to",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 317,
												"src": "4953:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "4936:21:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 413,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 319,
													"src": "4986:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 409,
														"name": "addressToBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 87,
														"src": "4960:16:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 411,
													"indexExpression": {
														"argumentTypes": null,
														"id": 410,
														"name": "_to",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 317,
														"src": "4977:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4960:21:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 412,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "add",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1426,
												"src": "4960:25:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 414,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "4960:34:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "4936:58:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 416,
									"nodeType": "ExpressionStatement",
									"src": "4936:58:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 418,
												"name": "_from",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 315,
												"src": "5018:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 419,
												"name": "_to",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 317,
												"src": "5025:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 420,
												"name": "_tokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 319,
												"src": "5030:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 417,
											"name": "Transfer",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												30
											],
											"referencedDeclaration": 30,
											"src": "5009:8:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
												"typeString": "function (address,address,uint256)"
											}
										},
										"id": 421,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5009:29:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 422,
									"nodeType": "EmitStatement",
									"src": "5004:34:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 423,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "5056:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 323,
									"id": 424,
									"nodeType": "Return",
									"src": "5049:11:0"
								}
							]
						},
						"documentation": null,
						"id": 426,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "transferFrom",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 320,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 315,
									"name": "_from",
									"nodeType": "VariableDeclaration",
									"scope": 426,
									"src": "4282:13:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 314,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "4282:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 317,
									"name": "_to",
									"nodeType": "VariableDeclaration",
									"scope": 426,
									"src": "4297:11:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 316,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "4297:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 319,
									"name": "_tokens",
									"nodeType": "VariableDeclaration",
									"scope": 426,
									"src": "4310:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 318,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "4310:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "4281:42:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 323,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 322,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 426,
									"src": "4340:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 321,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "4340:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "4339:14:0"
						},
						"scope": 1164,
						"src": "4260:807:0",
						"stateMutability": "nonpayable",
						"superFunction": 1216,
						"visibility": "public"
					},
					{
						"body": {
							"id": 482,
							"nodeType": "Block",
							"src": "5151:280:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 440,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 436,
													"name": "_spender",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 428,
													"src": "5169:8:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 438,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "5189:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 437,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "5181:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 439,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "5181:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "5169:22:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 435,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "5161:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 441,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5161:31:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 442,
									"nodeType": "ExpressionStatement",
									"src": "5161:31:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 447,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 444,
													"name": "_spender",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 428,
													"src": "5210:8:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 445,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "5222:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 446,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "5222:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "5210:22:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 443,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "5202:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 448,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5202:31:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 449,
									"nodeType": "ExpressionStatement",
									"src": "5202:31:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 453,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 451,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 430,
													"src": "5251:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 452,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "5261:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "5251:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 450,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "5243:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 454,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5243:20:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 455,
									"nodeType": "ExpressionStatement",
									"src": "5243:20:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 471,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 456,
													"name": "allowed",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 93,
													"src": "5274:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
														"typeString": "mapping(address => mapping(address => uint256))"
													}
												},
												"id": 460,
												"indexExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 457,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "5282:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 458,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "5282:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "5274:19:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 461,
											"indexExpression": {
												"argumentTypes": null,
												"id": 459,
												"name": "_spender",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 428,
												"src": "5294:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "5274:29:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 469,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 430,
													"src": "5340:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 462,
															"name": "allowed",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 93,
															"src": "5306:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
																"typeString": "mapping(address => mapping(address => uint256))"
															}
														},
														"id": 465,
														"indexExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 463,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1462,
																"src": "5314:3:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 464,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "5314:10:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "5306:19:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 467,
													"indexExpression": {
														"argumentTypes": null,
														"id": 466,
														"name": "_spender",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 428,
														"src": "5326:8:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "5306:29:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 468,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "add",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1426,
												"src": "5306:33:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 470,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "5306:42:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "5274:74:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 472,
									"nodeType": "ExpressionStatement",
									"src": "5274:74:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 474,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "5372:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 475,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "5372:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 476,
												"name": "_spender",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 428,
												"src": "5384:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 477,
												"name": "_tokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 430,
												"src": "5394:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 473,
											"name": "Approval",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												38
											],
											"referencedDeclaration": 38,
											"src": "5363:8:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
												"typeString": "function (address,address,uint256)"
											}
										},
										"id": 478,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5363:39:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 479,
									"nodeType": "EmitStatement",
									"src": "5358:44:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 480,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "5420:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 434,
									"id": 481,
									"nodeType": "Return",
									"src": "5413:11:0"
								}
							]
						},
						"documentation": null,
						"id": 483,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "approve",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 431,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 428,
									"name": "_spender",
									"nodeType": "VariableDeclaration",
									"scope": 483,
									"src": "5090:16:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 427,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "5090:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 430,
									"name": "_tokens",
									"nodeType": "VariableDeclaration",
									"scope": 483,
									"src": "5108:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 429,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "5108:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "5089:32:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 434,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 433,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 483,
									"src": "5138:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 432,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "5138:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "5137:14:0"
						},
						"scope": 1164,
						"src": "5073:358:0",
						"stateMutability": "nonpayable",
						"superFunction": 1205,
						"visibility": "public"
					},
					{
						"body": {
							"id": 526,
							"nodeType": "Block",
							"src": "5553:273:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 501,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 492,
												"name": "addressToBalance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 87,
												"src": "5563:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 494,
											"indexExpression": {
												"argumentTypes": null,
												"id": 493,
												"name": "_receiver",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 485,
												"src": "5580:9:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "5563:27:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 499,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 487,
													"src": "5625:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 495,
														"name": "addressToBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 87,
														"src": "5593:16:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 497,
													"indexExpression": {
														"argumentTypes": null,
														"id": 496,
														"name": "_receiver",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 485,
														"src": "5610:9:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "5593:27:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 498,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "add",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1426,
												"src": "5593:31:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 500,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "5593:40:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "5563:70:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 502,
									"nodeType": "ExpressionStatement",
									"src": "5563:70:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 508,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 503,
											"name": "totalSupply",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												81
											],
											"referencedDeclaration": 81,
											"src": "5643:11:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 506,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 487,
													"src": "5673:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"id": 504,
													"name": "totalSupply",
													"nodeType": "Identifier",
													"overloadedDeclarations": [
														81
													],
													"referencedDeclaration": 81,
													"src": "5657:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 505,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "add",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1426,
												"src": "5657:15:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 507,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "5657:24:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "5643:38:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 509,
									"nodeType": "ExpressionStatement",
									"src": "5643:38:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 511,
												"name": "_receiver",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 485,
												"src": "5710:9:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 512,
												"name": "_tokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 487,
												"src": "5721:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											{
												"argumentTypes": null,
												"id": 513,
												"name": "totalSupply",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													81
												],
												"referencedDeclaration": 81,
												"src": "5730:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 510,
											"name": "TokensMinted",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 46,
											"src": "5697:12:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_uint256_$_t_uint256_$returns$__$",
												"typeString": "function (address,uint256,uint256)"
											}
										},
										"id": 514,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5697:45:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 515,
									"nodeType": "EmitStatement",
									"src": "5692:50:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"hexValue": "30",
														"id": 518,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "5774:1:0",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														}
													],
													"id": 517,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "5766:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_address_$",
														"typeString": "type(address)"
													},
													"typeName": "address"
												},
												"id": 519,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "5766:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 520,
												"name": "_receiver",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 485,
												"src": "5778:9:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 521,
												"name": "_tokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 487,
												"src": "5789:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 516,
											"name": "Transfer",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												30
											],
											"referencedDeclaration": 30,
											"src": "5757:8:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
												"typeString": "function (address,address,uint256)"
											}
										},
										"id": 522,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5757:40:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 523,
									"nodeType": "EmitStatement",
									"src": "5752:45:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 524,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "5815:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 491,
									"id": 525,
									"nodeType": "Return",
									"src": "5808:11:0"
								}
							]
						},
						"documentation": null,
						"id": 527,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "mintTokens",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 488,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 485,
									"name": "_receiver",
									"nodeType": "VariableDeclaration",
									"scope": 527,
									"src": "5490:17:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 484,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "5490:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 487,
									"name": "_tokens",
									"nodeType": "VariableDeclaration",
									"scope": 527,
									"src": "5509:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 486,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "5509:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "5489:33:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 491,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 490,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 527,
									"src": "5540:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 489,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "5540:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "5539:14:0"
						},
						"scope": 1164,
						"src": "5470:356:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 559,
							"nodeType": "Block",
							"src": "5929:142:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 543,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 539,
													"name": "_receiver",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 529,
													"src": "5947:9:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 541,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "5968:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 540,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "5960:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 542,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "5960:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "5947:23:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 538,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "5939:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 544,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5939:32:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 545,
									"nodeType": "ExpressionStatement",
									"src": "5939:32:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 549,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 547,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 531,
													"src": "5989:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 548,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "5999:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "5989:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 546,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "5981:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 550,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5981:20:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 551,
									"nodeType": "ExpressionStatement",
									"src": "5981:20:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 553,
												"name": "_receiver",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 529,
												"src": "6023:9:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 554,
												"name": "_tokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 531,
												"src": "6034:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 552,
											"name": "mintTokens",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 527,
											"src": "6012:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
												"typeString": "function (address,uint256) returns (bool)"
											}
										},
										"id": 555,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6012:30:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 556,
									"nodeType": "ExpressionStatement",
									"src": "6012:30:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 557,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "6060:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 537,
									"id": 558,
									"nodeType": "Return",
									"src": "6053:11:0"
								}
							]
						},
						"documentation": null,
						"id": 560,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 534,
								"modifierName": {
									"argumentTypes": null,
									"id": 533,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "5897:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "5897:9:0"
							}
						],
						"name": "ownerMintTokens",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 532,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 529,
									"name": "_receiver",
									"nodeType": "VariableDeclaration",
									"scope": 560,
									"src": "5857:17:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 528,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "5857:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 531,
									"name": "_tokens",
									"nodeType": "VariableDeclaration",
									"scope": 560,
									"src": "5876:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 530,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "5876:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "5856:33:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 537,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 536,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 560,
									"src": "5916:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 535,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "5916:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "5915:14:0"
						},
						"scope": 1164,
						"src": "5832:239:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 613,
							"nodeType": "Block",
							"src": "6204:464:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 576,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 574,
													"name": "_tokenReward",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 564,
													"src": "6222:12:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 575,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6237:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "6222:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 573,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "6214:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 577,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6214:25:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 578,
									"nodeType": "ExpressionStatement",
									"src": "6214:25:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 585,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 581,
																"name": "_couponCode",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 562,
																"src": "6263:11:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_string_memory_ptr",
																	"typeString": "string memory"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_string_memory_ptr",
																	"typeString": "string memory"
																}
															],
															"id": 580,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "6257:5:0",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
																"typeString": "type(bytes storage pointer)"
															},
															"typeName": "bytes"
														},
														"id": 582,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "6257:18:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes_memory",
															"typeString": "bytes memory"
														}
													},
													"id": 583,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "length",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "6257:25:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 584,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6285:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "6257:29:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 579,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "6249:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 586,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6249:38:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 587,
									"nodeType": "ExpressionStatement",
									"src": "6249:38:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 594,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 589,
															"name": "coupons",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 97,
															"src": "6348:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
															}
														},
														"id": 591,
														"indexExpression": {
															"argumentTypes": null,
															"id": 590,
															"name": "_couponCode",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 562,
															"src": "6356:11:0",
															"typeDescriptions": {
																"typeIdentifier": "t_string_memory_ptr",
																"typeString": "string memory"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "6348:20:0",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_Coupon_$19_storage",
															"typeString": "struct AsyncCoin.Coupon storage ref"
														}
													},
													"id": 592,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "tokenReward",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 12,
													"src": "6348:32:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 593,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6384:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "6348:37:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 588,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "6340:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 595,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6340:46:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 596,
									"nodeType": "ExpressionStatement",
									"src": "6340:46:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 609,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 597,
												"name": "coupons",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 97,
												"src": "6397:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
													"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
												}
											},
											"id": 599,
											"indexExpression": {
												"argumentTypes": null,
												"id": 598,
												"name": "_couponCode",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 562,
												"src": "6405:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "6397:20:0",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_Coupon_$19_storage",
												"typeString": "struct AsyncCoin.Coupon storage ref"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 601,
													"name": "_couponCode",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 562,
													"src": "6448:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 602,
													"name": "_tokenReward",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 564,
													"src": "6487:12:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 603,
													"name": "_timeCouponCanBeUsed",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 566,
													"src": "6527:20:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "74727565",
													"id": 604,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6570:4:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "true"
												},
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 607,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 605,
														"name": "_timeCouponCanBeUsed",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 566,
														"src": "6599:20:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 606,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "6623:1:0",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"src": "6599:25:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												}
											],
											"expression": {
												"argumentTypes": null,
												"id": 600,
												"name": "Coupon",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 19,
												"src": "6420:6:0",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_struct$_Coupon_$19_storage_ptr_$",
													"typeString": "type(struct AsyncCoin.Coupon storage pointer)"
												}
											},
											"id": 608,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "structConstructorCall",
											"lValueRequested": false,
											"names": [
												"code",
												"tokenReward",
												"timesUsable",
												"active",
												"infinite"
											],
											"nodeType": "FunctionCall",
											"src": "6420:219:0",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_Coupon_$19_memory",
												"typeString": "struct AsyncCoin.Coupon memory"
											}
										},
										"src": "6397:242:0",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_Coupon_$19_storage",
											"typeString": "struct AsyncCoin.Coupon storage ref"
										}
									},
									"id": 610,
									"nodeType": "ExpressionStatement",
									"src": "6397:242:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 611,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "6657:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 572,
									"id": 612,
									"nodeType": "Return",
									"src": "6650:11:0"
								}
							]
						},
						"documentation": null,
						"id": 614,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 569,
								"modifierName": {
									"argumentTypes": null,
									"id": 568,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "6172:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "6172:9:0"
							}
						],
						"name": "createCoupon",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 567,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 562,
									"name": "_couponCode",
									"nodeType": "VariableDeclaration",
									"scope": 614,
									"src": "6099:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 561,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "6099:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 564,
									"name": "_tokenReward",
									"nodeType": "VariableDeclaration",
									"scope": 614,
									"src": "6119:17:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 563,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "6119:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 566,
									"name": "_timeCouponCanBeUsed",
									"nodeType": "VariableDeclaration",
									"scope": 614,
									"src": "6138:25:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 565,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "6138:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "6098:66:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 572,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 571,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 614,
									"src": "6191:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 570,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "6191:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "6190:14:0"
						},
						"scope": 1164,
						"src": "6077:591:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 641,
							"nodeType": "Block",
							"src": "6756:131:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 629,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 624,
															"name": "coupons",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 97,
															"src": "6774:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
															}
														},
														"id": 626,
														"indexExpression": {
															"argumentTypes": null,
															"id": 625,
															"name": "_couponCode",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 616,
															"src": "6782:11:0",
															"typeDescriptions": {
																"typeIdentifier": "t_string_memory_ptr",
																"typeString": "string memory"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "6774:20:0",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_Coupon_$19_storage",
															"typeString": "struct AsyncCoin.Coupon storage ref"
														}
													},
													"id": 627,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "tokenReward",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 12,
													"src": "6774:32:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 628,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6810:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "6774:37:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 623,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "6766:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 630,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6766:46:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 631,
									"nodeType": "ExpressionStatement",
									"src": "6766:46:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 637,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 632,
													"name": "coupons",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 97,
													"src": "6823:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
														"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
													}
												},
												"id": 634,
												"indexExpression": {
													"argumentTypes": null,
													"id": 633,
													"name": "_couponCode",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 616,
													"src": "6831:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "6823:20:0",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_Coupon_$19_storage",
													"typeString": "struct AsyncCoin.Coupon storage ref"
												}
											},
											"id": 635,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "active",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 18,
											"src": "6823:27:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 636,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "6853:5:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "6823:35:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 638,
									"nodeType": "ExpressionStatement",
									"src": "6823:35:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 639,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "6876:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 622,
									"id": 640,
									"nodeType": "Return",
									"src": "6869:11:0"
								}
							]
						},
						"documentation": null,
						"id": 642,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 619,
								"modifierName": {
									"argumentTypes": null,
									"id": 618,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "6724:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "6724:9:0"
							}
						],
						"name": "disableCoupon",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 617,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 616,
									"name": "_couponCode",
									"nodeType": "VariableDeclaration",
									"scope": 642,
									"src": "6697:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 615,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "6697:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "6696:20:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 622,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 621,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 642,
									"src": "6743:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 620,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "6743:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "6742:14:0"
						},
						"scope": 1164,
						"src": "6674:213:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 669,
							"nodeType": "Block",
							"src": "6974:130:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 657,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 652,
															"name": "coupons",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 97,
															"src": "6992:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
															}
														},
														"id": 654,
														"indexExpression": {
															"argumentTypes": null,
															"id": 653,
															"name": "_couponCode",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 644,
															"src": "7000:11:0",
															"typeDescriptions": {
																"typeIdentifier": "t_string_memory_ptr",
																"typeString": "string memory"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "6992:20:0",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_Coupon_$19_storage",
															"typeString": "struct AsyncCoin.Coupon storage ref"
														}
													},
													"id": 655,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "tokenReward",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 12,
													"src": "6992:32:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 656,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "7028:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "6992:37:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 651,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "6984:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 658,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6984:46:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 659,
									"nodeType": "ExpressionStatement",
									"src": "6984:46:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 665,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 660,
													"name": "coupons",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 97,
													"src": "7041:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
														"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
													}
												},
												"id": 662,
												"indexExpression": {
													"argumentTypes": null,
													"id": 661,
													"name": "_couponCode",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 644,
													"src": "7049:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "7041:20:0",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_Coupon_$19_storage",
													"typeString": "struct AsyncCoin.Coupon storage ref"
												}
											},
											"id": 663,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "active",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 18,
											"src": "7041:27:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 664,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "7071:4:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "7041:34:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 666,
									"nodeType": "ExpressionStatement",
									"src": "7041:34:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 667,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "7093:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 650,
									"id": 668,
									"nodeType": "Return",
									"src": "7086:11:0"
								}
							]
						},
						"documentation": null,
						"id": 670,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 647,
								"modifierName": {
									"argumentTypes": null,
									"id": 646,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "6942:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "6942:9:0"
							}
						],
						"name": "enableCoupon",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 645,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 644,
									"name": "_couponCode",
									"nodeType": "VariableDeclaration",
									"scope": 670,
									"src": "6915:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 643,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "6915:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "6914:20:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 650,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 649,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 670,
									"src": "6961:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 648,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "6961:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "6960:14:0"
						},
						"scope": 1164,
						"src": "6893:211:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 787,
							"nodeType": "Block",
							"src": "7181:1114:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 683,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 678,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "7199:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 679,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "7199:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 681,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "7221:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 680,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "7213:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 682,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "7213:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "7199:24:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 677,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "7191:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 684,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "7191:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 685,
									"nodeType": "ExpressionStatement",
									"src": "7191:33:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 692,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 688,
																"name": "_couponCode",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 672,
																"src": "7248:11:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_string_memory_ptr",
																	"typeString": "string memory"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_string_memory_ptr",
																	"typeString": "string memory"
																}
															],
															"id": 687,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "7242:5:0",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
																"typeString": "type(bytes storage pointer)"
															},
															"typeName": "bytes"
														},
														"id": 689,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "7242:18:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes_memory",
															"typeString": "bytes memory"
														}
													},
													"id": 690,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "length",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "7242:25:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 691,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "7270:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "7242:29:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 686,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "7234:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 693,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "7234:38:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 694,
									"nodeType": "ExpressionStatement",
									"src": "7234:38:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 701,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 696,
															"name": "coupons",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 97,
															"src": "7338:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
															}
														},
														"id": 698,
														"indexExpression": {
															"argumentTypes": null,
															"id": 697,
															"name": "_couponCode",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "7346:11:0",
															"typeDescriptions": {
																"typeIdentifier": "t_string_memory_ptr",
																"typeString": "string memory"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "7338:20:0",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_Coupon_$19_storage",
															"typeString": "struct AsyncCoin.Coupon storage ref"
														}
													},
													"id": 699,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "active",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 18,
													"src": "7338:27:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "74727565",
													"id": 700,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "7369:4:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "true"
												},
												"src": "7338:35:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 695,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "7330:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 702,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "7330:44:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 703,
									"nodeType": "ExpressionStatement",
									"src": "7330:44:0"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"id": 709,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 704,
													"name": "coupons",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 97,
													"src": "7456:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
														"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
													}
												},
												"id": 706,
												"indexExpression": {
													"argumentTypes": null,
													"id": 705,
													"name": "_couponCode",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "7464:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "7456:20:0",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_Coupon_$19_storage",
													"typeString": "struct AsyncCoin.Coupon storage ref"
												}
											},
											"id": 707,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "infinite",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 16,
											"src": "7456:29:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 708,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "7489:5:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "7456:38:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 720,
									"nodeType": "IfStatement",
									"src": "7452:114:0",
									"trueBody": {
										"id": 719,
										"nodeType": "Block",
										"src": "7496:70:0",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 716,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 711,
																		"name": "coupons",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 97,
																		"src": "7518:7:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																			"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
																		}
																	},
																	"id": 713,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 712,
																		"name": "_couponCode",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 672,
																		"src": "7526:11:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_string_memory_ptr",
																			"typeString": "string memory"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "7518:20:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_Coupon_$19_storage",
																		"typeString": "struct AsyncCoin.Coupon storage ref"
																	}
																},
																"id": 714,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "timesUsable",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 14,
																"src": "7518:32:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": ">",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "30",
																"id": 715,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "7553:1:0",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_0_by_1",
																	"typeString": "int_const 0"
																},
																"value": "0"
															},
															"src": "7518:36:0",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														],
														"id": 710,
														"name": "require",
														"nodeType": "Identifier",
														"overloadedDeclarations": [
															1465,
															1466
														],
														"referencedDeclaration": 1465,
														"src": "7510:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
															"typeString": "function (bool) pure"
														}
													},
													"id": 717,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "7510:45:0",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 718,
												"nodeType": "ExpressionStatement",
												"src": "7510:45:0"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 728,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "!",
												"prefix": true,
												"src": "7651:41:0",
												"subExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 722,
															"name": "redeemedCoupons",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 103,
															"src": "7652:15:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_string_memory_$_t_bool_$_$",
																"typeString": "mapping(address => mapping(string memory => bool))"
															}
														},
														"id": 725,
														"indexExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 723,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1462,
																"src": "7668:3:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 724,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "7668:10:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "7652:27:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_string_memory_$_t_bool_$",
															"typeString": "mapping(string memory => bool)"
														}
													},
													"id": 727,
													"indexExpression": {
														"argumentTypes": null,
														"id": 726,
														"name": "_couponCode",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "7680:11:0",
														"typeDescriptions": {
															"typeIdentifier": "t_string_memory_ptr",
															"typeString": "string memory"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "7652:40:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 721,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "7643:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 729,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "7643:50:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 730,
									"nodeType": "ExpressionStatement",
									"src": "7643:50:0"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"id": 736,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 731,
													"name": "coupons",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 97,
													"src": "7751:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
														"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
													}
												},
												"id": 733,
												"indexExpression": {
													"argumentTypes": null,
													"id": 732,
													"name": "_couponCode",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "7759:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "7751:20:0",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_Coupon_$19_storage",
													"typeString": "struct AsyncCoin.Coupon storage ref"
												}
											},
											"id": 734,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "infinite",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 16,
											"src": "7751:29:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 735,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "7784:5:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "7751:38:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 766,
									"nodeType": "IfStatement",
									"src": "7747:335:0",
									"trueBody": {
										"id": 765,
										"nodeType": "Block",
										"src": "7791:291:0",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 748,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 737,
																"name": "coupons",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 97,
																"src": "7805:7:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																	"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
																}
															},
															"id": 739,
															"indexExpression": {
																"argumentTypes": null,
																"id": 738,
																"name": "_couponCode",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 672,
																"src": "7813:11:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_string_memory_ptr",
																	"typeString": "string memory"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "7805:20:0",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Coupon_$19_storage",
																"typeString": "struct AsyncCoin.Coupon storage ref"
															}
														},
														"id": 740,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "timesUsable",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 14,
														"src": "7805:32:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"hexValue": "31",
																"id": 746,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "7877:1:0",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																},
																"value": "1"
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																}
															],
															"expression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 741,
																		"name": "coupons",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 97,
																		"src": "7840:7:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																			"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
																		}
																	},
																	"id": 743,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 742,
																		"name": "_couponCode",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 672,
																		"src": "7848:11:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_string_memory_ptr",
																			"typeString": "string memory"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "7840:20:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_Coupon_$19_storage",
																		"typeString": "struct AsyncCoin.Coupon storage ref"
																	}
																},
																"id": 744,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "timesUsable",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 14,
																"src": "7840:32:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"id": 745,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sub",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 1402,
															"src": "7840:36:0",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
																"typeString": "function (uint256,uint256) pure returns (uint256)"
															}
														},
														"id": 747,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "7840:39:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "7805:74:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 749,
												"nodeType": "ExpressionStatement",
												"src": "7805:74:0"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 755,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 750,
																"name": "coupons",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 97,
																"src": "7966:7:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																	"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
																}
															},
															"id": 752,
															"indexExpression": {
																"argumentTypes": null,
																"id": 751,
																"name": "_couponCode",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 672,
																"src": "7974:11:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_string_memory_ptr",
																	"typeString": "string memory"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "7966:20:0",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Coupon_$19_storage",
																"typeString": "struct AsyncCoin.Coupon storage ref"
															}
														},
														"id": 753,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "timesUsable",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 14,
														"src": "7966:32:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "31",
														"id": 754,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "8001:1:0",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_1_by_1",
															"typeString": "int_const 1"
														},
														"value": "1"
													},
													"src": "7966:36:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 764,
												"nodeType": "IfStatement",
												"src": "7962:110:0",
												"trueBody": {
													"id": 763,
													"nodeType": "Block",
													"src": "8004:68:0",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 761,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 756,
																			"name": "coupons",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 97,
																			"src": "8022:7:0",
																			"typeDescriptions": {
																				"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																				"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
																			}
																		},
																		"id": 758,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 757,
																			"name": "_couponCode",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 672,
																			"src": "8030:11:0",
																			"typeDescriptions": {
																				"typeIdentifier": "t_string_memory_ptr",
																				"typeString": "string memory"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "8022:20:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_Coupon_$19_storage",
																			"typeString": "struct AsyncCoin.Coupon storage ref"
																		}
																	},
																	"id": 759,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"memberName": "active",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 18,
																	"src": "8022:27:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"hexValue": "66616c7365",
																	"id": 760,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "bool",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "8052:5:0",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"value": "false"
																},
																"src": "8022:35:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"id": 762,
															"nodeType": "ExpressionStatement",
															"src": "8022:35:0"
														}
													]
												}
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 774,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 767,
													"name": "redeemedCoupons",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 103,
													"src": "8153:15:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_string_memory_$_t_bool_$_$",
														"typeString": "mapping(address => mapping(string memory => bool))"
													}
												},
												"id": 771,
												"indexExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 768,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "8169:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 769,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "8169:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "8153:27:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_string_memory_$_t_bool_$",
													"typeString": "mapping(string memory => bool)"
												}
											},
											"id": 772,
											"indexExpression": {
												"argumentTypes": null,
												"id": 770,
												"name": "_couponCode",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "8181:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "8153:40:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 773,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "8196:4:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "8153:47:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 775,
									"nodeType": "ExpressionStatement",
									"src": "8153:47:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 777,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "8221:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 778,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "8221:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 779,
														"name": "coupons",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 97,
														"src": "8233:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
															"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
														}
													},
													"id": 781,
													"indexExpression": {
														"argumentTypes": null,
														"id": 780,
														"name": "_couponCode",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "8241:11:0",
														"typeDescriptions": {
															"typeIdentifier": "t_string_memory_ptr",
															"typeString": "string memory"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "8233:20:0",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_Coupon_$19_storage",
														"typeString": "struct AsyncCoin.Coupon storage ref"
													}
												},
												"id": 782,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "tokenReward",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 12,
												"src": "8233:32:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 776,
											"name": "mintTokens",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 527,
											"src": "8210:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
												"typeString": "function (address,uint256) returns (bool)"
											}
										},
										"id": 783,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8210:56:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 784,
									"nodeType": "ExpressionStatement",
									"src": "8210:56:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 785,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "8284:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 676,
									"id": 786,
									"nodeType": "Return",
									"src": "8277:11:0"
								}
							]
						},
						"documentation": null,
						"id": 788,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "redeemCoupon",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 673,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 672,
									"name": "_couponCode",
									"nodeType": "VariableDeclaration",
									"scope": 788,
									"src": "7132:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 671,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "7132:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "7131:20:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 676,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 675,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 788,
									"src": "7168:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 674,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "7168:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "7167:14:0"
						},
						"scope": 1164,
						"src": "7110:1185:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 825,
							"nodeType": "Block",
							"src": "8411:228:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 802,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 798,
													"name": "_frozenAddress",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 790,
													"src": "8429:14:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 800,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "8455:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 799,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "8447:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 801,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "8447:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "8429:28:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 797,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "8421:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 803,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8421:37:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 804,
									"nodeType": "ExpressionStatement",
									"src": "8421:37:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 809,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 806,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "8476:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 807,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "8476:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 808,
													"name": "_frozenAddress",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 790,
													"src": "8490:14:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "8476:28:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 805,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "8468:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 810,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8468:37:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 811,
									"nodeType": "ExpressionStatement",
									"src": "8468:37:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 816,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 812,
												"name": "frozenAddresses",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 107,
												"src": "8516:15:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
													"typeString": "mapping(address => bool)"
												}
											},
											"id": 814,
											"indexExpression": {
												"argumentTypes": null,
												"id": 813,
												"name": "_frozenAddress",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 790,
												"src": "8532:14:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "8516:31:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 815,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "8550:4:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "8516:38:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 817,
									"nodeType": "ExpressionStatement",
									"src": "8516:38:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 819,
												"name": "_frozenAddress",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 790,
												"src": "8589:14:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "74727565",
												"id": 820,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "bool",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "8605:4:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"value": "true"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 818,
											"name": "AddressFreezeChange",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 52,
											"src": "8569:19:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_bool_$returns$__$",
												"typeString": "function (address,bool)"
											}
										},
										"id": 821,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8569:41:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 822,
									"nodeType": "EmitStatement",
									"src": "8564:46:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 823,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "8628:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 796,
									"id": 824,
									"nodeType": "Return",
									"src": "8621:11:0"
								}
							]
						},
						"documentation": null,
						"id": 826,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 793,
								"modifierName": {
									"argumentTypes": null,
									"id": 792,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "8379:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "8379:9:0"
							}
						],
						"name": "freezeAddress",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 791,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 790,
									"name": "_frozenAddress",
									"nodeType": "VariableDeclaration",
									"scope": 826,
									"src": "8348:22:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 789,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "8348:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "8347:24:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 796,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 795,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 826,
									"src": "8398:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 794,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "8398:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "8397:14:0"
						},
						"scope": 1164,
						"src": "8325:314:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 864,
							"nodeType": "Block",
							"src": "8775:241:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 840,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 836,
													"name": "_frozenAddress",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 828,
													"src": "8793:14:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 838,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "8819:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 837,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "8811:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 839,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "8811:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "8793:28:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 835,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "8785:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 841,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8785:37:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 842,
									"nodeType": "ExpressionStatement",
									"src": "8785:37:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 848,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 844,
														"name": "frozenAddresses",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 107,
														"src": "8840:15:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
															"typeString": "mapping(address => bool)"
														}
													},
													"id": 846,
													"indexExpression": {
														"argumentTypes": null,
														"id": 845,
														"name": "_frozenAddress",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 828,
														"src": "8856:14:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "8840:31:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "74727565",
													"id": 847,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "8875:4:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "true"
												},
												"src": "8840:39:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 843,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "8832:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 849,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8832:48:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 850,
									"nodeType": "ExpressionStatement",
									"src": "8832:48:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 855,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 851,
												"name": "frozenAddresses",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 107,
												"src": "8891:15:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
													"typeString": "mapping(address => bool)"
												}
											},
											"id": 853,
											"indexExpression": {
												"argumentTypes": null,
												"id": 852,
												"name": "_frozenAddress",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 828,
												"src": "8907:14:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "8891:31:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 854,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "8925:5:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "8891:39:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 856,
									"nodeType": "ExpressionStatement",
									"src": "8891:39:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 858,
												"name": "_frozenAddress",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 828,
												"src": "8965:14:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "66616c7365",
												"id": 859,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "bool",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "8981:5:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"value": "false"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 857,
											"name": "AddressFreezeChange",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 52,
											"src": "8945:19:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_bool_$returns$__$",
												"typeString": "function (address,bool)"
											}
										},
										"id": 860,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8945:42:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 861,
									"nodeType": "EmitStatement",
									"src": "8940:47:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 862,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "9005:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 834,
									"id": 863,
									"nodeType": "Return",
									"src": "8998:11:0"
								}
							]
						},
						"documentation": null,
						"id": 865,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 831,
								"modifierName": {
									"argumentTypes": null,
									"id": 830,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "8743:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "8743:9:0"
							}
						],
						"name": "unfreezeAddress",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 829,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 828,
									"name": "_frozenAddress",
									"nodeType": "VariableDeclaration",
									"scope": 865,
									"src": "8712:22:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 827,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "8712:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "8711:24:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 834,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 833,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 865,
									"src": "8762:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 832,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "8762:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "8761:14:0"
						},
						"scope": 1164,
						"src": "8687:329:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 896,
							"nodeType": "Block",
							"src": "9089:182:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 878,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 873,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "9107:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 874,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "9107:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 876,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "9129:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 875,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "9121:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 877,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "9121:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "9107:24:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 872,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "9099:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 879,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "9099:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 880,
									"nodeType": "ExpressionStatement",
									"src": "9099:33:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 886,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 881,
												"name": "addressToName",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 111,
												"src": "9143:13:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_string_storage_$",
													"typeString": "mapping(address => string storage ref)"
												}
											},
											"id": 884,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 882,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "9157:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 883,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "9157:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "9143:25:0",
											"typeDescriptions": {
												"typeIdentifier": "t_string_storage",
												"typeString": "string storage ref"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 885,
											"name": "_addressName",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 867,
											"src": "9171:12:0",
											"typeDescriptions": {
												"typeIdentifier": "t_string_memory_ptr",
												"typeString": "string memory"
											}
										},
										"src": "9143:40:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage",
											"typeString": "string storage ref"
										}
									},
									"id": 887,
									"nodeType": "ExpressionStatement",
									"src": "9143:40:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 889,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "9217:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 890,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "9217:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 891,
												"name": "_addressName",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 867,
												"src": "9229:12:0",
												"typeDescriptions": {
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											],
											"id": 888,
											"name": "AddressNameChange",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 64,
											"src": "9199:17:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (address,string memory)"
											}
										},
										"id": 892,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "9199:43:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 893,
									"nodeType": "EmitStatement",
									"src": "9194:48:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 894,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "9260:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 871,
									"id": 895,
									"nodeType": "Return",
									"src": "9253:11:0"
								}
							]
						},
						"documentation": null,
						"id": 897,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "setName",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 868,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 867,
									"name": "_addressName",
									"nodeType": "VariableDeclaration",
									"scope": 897,
									"src": "9039:19:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 866,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "9039:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9038:21:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 871,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 870,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 897,
									"src": "9076:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 869,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "9076:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9075:14:0"
						},
						"scope": 1164,
						"src": "9022:249:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 927,
							"nodeType": "Block",
							"src": "9359:179:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 911,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 907,
													"name": "_address",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 899,
													"src": "9377:8:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 909,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "9397:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 908,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "9389:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 910,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "9389:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "9377:22:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 906,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "9369:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 912,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "9369:31:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 913,
									"nodeType": "ExpressionStatement",
									"src": "9369:31:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 918,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 914,
												"name": "allowedToBuyTokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 115,
												"src": "9411:18:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
													"typeString": "mapping(address => bool)"
												}
											},
											"id": 916,
											"indexExpression": {
												"argumentTypes": null,
												"id": 915,
												"name": "_address",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 899,
												"src": "9430:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "9411:28:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 917,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "9442:4:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "9411:35:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 919,
									"nodeType": "ExpressionStatement",
									"src": "9411:35:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 921,
												"name": "_address",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 899,
												"src": "9494:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "74727565",
												"id": 922,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "bool",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "9504:4:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"value": "true"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 920,
											"name": "AddressCanBuyTokensStatusChange",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 70,
											"src": "9462:31:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_bool_$returns$__$",
												"typeString": "function (address,bool)"
											}
										},
										"id": 923,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "9462:47:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 924,
									"nodeType": "EmitStatement",
									"src": "9457:52:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 925,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "9527:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 905,
									"id": 926,
									"nodeType": "Return",
									"src": "9520:11:0"
								}
							]
						},
						"documentation": null,
						"id": 928,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 902,
								"modifierName": {
									"argumentTypes": null,
									"id": 901,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "9327:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "9327:9:0"
							}
						],
						"name": "setAllowedToBuy",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 900,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 899,
									"name": "_address",
									"nodeType": "VariableDeclaration",
									"scope": 928,
									"src": "9302:16:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 898,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "9302:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9301:18:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 905,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 904,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 928,
									"src": "9346:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 903,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "9346:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9345:14:0"
						},
						"scope": 1164,
						"src": "9277:261:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 958,
							"nodeType": "Block",
							"src": "9629:181:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 942,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 938,
													"name": "_address",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 930,
													"src": "9647:8:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 940,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "9667:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 939,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "9659:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 941,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "9659:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "9647:22:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 937,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "9639:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 943,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "9639:31:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 944,
									"nodeType": "ExpressionStatement",
									"src": "9639:31:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 949,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 945,
												"name": "allowedToBuyTokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 115,
												"src": "9681:18:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
													"typeString": "mapping(address => bool)"
												}
											},
											"id": 947,
											"indexExpression": {
												"argumentTypes": null,
												"id": 946,
												"name": "_address",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 930,
												"src": "9700:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "9681:28:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 948,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "9712:5:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "9681:36:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 950,
									"nodeType": "ExpressionStatement",
									"src": "9681:36:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 952,
												"name": "_address",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 930,
												"src": "9765:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "66616c7365",
												"id": 953,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "bool",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "9775:5:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"value": "false"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 951,
											"name": "AddressCanBuyTokensStatusChange",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 70,
											"src": "9733:31:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_bool_$returns$__$",
												"typeString": "function (address,bool)"
											}
										},
										"id": 954,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "9733:48:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 955,
									"nodeType": "EmitStatement",
									"src": "9728:53:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 956,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "9799:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 936,
									"id": 957,
									"nodeType": "Return",
									"src": "9792:11:0"
								}
							]
						},
						"documentation": null,
						"id": 959,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 933,
								"modifierName": {
									"argumentTypes": null,
									"id": 932,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "9597:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "9597:9:0"
							}
						],
						"name": "setNotAllowedToBuy",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 931,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 930,
									"name": "_address",
									"nodeType": "VariableDeclaration",
									"scope": 959,
									"src": "9572:16:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 929,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "9572:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9571:18:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 936,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 935,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 959,
									"src": "9616:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 934,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "9616:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9615:14:0"
						},
						"scope": 1164,
						"src": "9544:266:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 976,
							"nodeType": "Block",
							"src": "9906:81:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"id": 974,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"id": 970,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 966,
													"name": "allowedToBuyTokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 115,
													"src": "9923:18:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
														"typeString": "mapping(address => bool)"
													}
												},
												"id": 968,
												"indexExpression": {
													"argumentTypes": null,
													"id": 967,
													"name": "_address",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 961,
													"src": "9942:8:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "9923:28:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "74727565",
												"id": 969,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "bool",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "9955:4:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"value": "true"
											},
											"src": "9923:36:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "||",
										"rightExpression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											},
											"id": 973,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 971,
												"name": "_address",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 961,
												"src": "9963:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"id": 972,
												"name": "owner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1237,
												"src": "9975:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"src": "9963:17:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"src": "9923:57:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 965,
									"id": 975,
									"nodeType": "Return",
									"src": "9916:64:0"
								}
							]
						},
						"documentation": null,
						"id": 977,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "canBuyTokens",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 962,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 961,
									"name": "_address",
									"nodeType": "VariableDeclaration",
									"scope": 977,
									"src": "9838:16:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 960,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "9838:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9837:18:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 965,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 964,
									"name": "addressCanBuyTokens",
									"nodeType": "VariableDeclaration",
									"scope": 977,
									"src": "9881:24:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 963,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "9881:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9880:26:0"
						},
						"scope": 1164,
						"src": "9816:171:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1074,
							"nodeType": "Block",
							"src": "10051:562:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 988,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 983,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "10069:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 984,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "10069:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 986,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "10091:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 985,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "10083:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 987,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "10083:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "10069:24:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 982,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "10061:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 989,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10061:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 990,
									"nodeType": "ExpressionStatement",
									"src": "10061:33:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 995,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 992,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "10112:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 993,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "10112:9:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 994,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "10124:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "10112:13:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 991,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "10104:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 996,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10104:22:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 997,
									"nodeType": "ExpressionStatement",
									"src": "10104:22:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 1009,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 1004,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 999,
															"name": "allowedToBuyTokens",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 115,
															"src": "10144:18:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
																"typeString": "mapping(address => bool)"
															}
														},
														"id": 1002,
														"indexExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1000,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1462,
																"src": "10163:3:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 1001,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "10163:10:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "10144:30:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "74727565",
														"id": 1003,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "10178:4:0",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "true"
													},
													"src": "10144:38:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "||",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													},
													"id": 1008,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1005,
														"name": "owner",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1237,
														"src": "10186:5:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1006,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1462,
															"src": "10195:3:0",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 1007,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "10195:10:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"src": "10186:19:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "10144:61:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 998,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "10136:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1010,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10136:70:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1011,
									"nodeType": "ExpressionStatement",
									"src": "10136:70:0"
								},
								{
									"assignments": [
										1013
									],
									"declarations": [
										{
											"constant": false,
											"id": 1013,
											"name": "remaining",
											"nodeType": "VariableDeclaration",
											"scope": 1075,
											"src": "10217:14:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 1012,
												"name": "uint",
												"nodeType": "ElementaryTypeName",
												"src": "10217:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1020,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"hexValue": "31",
												"id": 1018,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "10250:7:0",
												"subdenomination": "ether",
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1000000000000000000_by_1",
													"typeString": "int_const 1000000000000000000"
												},
												"value": "1"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_rational_1000000000000000000_by_1",
													"typeString": "int_const 1000000000000000000"
												}
											],
											"expression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1014,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1462,
															"src": "10235:3:0",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 1015,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "value",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "10235:9:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 1016,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "10234:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"id": 1017,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "mod",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 1446,
											"src": "10234:15:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
												"typeString": "function (uint256,uint256) pure returns (uint256)"
											}
										},
										"id": 1019,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10234:24:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "10217:41:0"
								},
								{
									"assignments": [
										1022
									],
									"declarations": [
										{
											"constant": false,
											"id": 1022,
											"name": "spentEther",
											"nodeType": "VariableDeclaration",
											"scope": 1075,
											"src": "10268:15:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 1021,
												"name": "uint",
												"nodeType": "ElementaryTypeName",
												"src": "10268:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1029,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1027,
												"name": "remaining",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1013,
												"src": "10302:9:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1023,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1462,
															"src": "10287:3:0",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 1024,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "value",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "10287:9:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 1025,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "10286:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"id": 1026,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sub",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 1402,
											"src": "10286:15:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
												"typeString": "function (uint256,uint256) pure returns (uint256)"
											}
										},
										"id": 1028,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10286:26:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "10268:44:0"
								},
								{
									"assignments": [
										1031
									],
									"declarations": [
										{
											"constant": false,
											"id": 1031,
											"name": "tokensBought",
											"nodeType": "VariableDeclaration",
											"scope": 1075,
											"src": "10322:17:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 1030,
												"name": "uint",
												"nodeType": "ElementaryTypeName",
												"src": "10322:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1039,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"hexValue": "3130",
												"id": 1037,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "10370:2:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_10_by_1",
													"typeString": "int_const 10"
												},
												"value": "10"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_rational_10_by_1",
													"typeString": "int_const 10"
												}
											],
											"expression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"hexValue": "31",
														"id": 1034,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "10357:7:0",
														"subdenomination": "ether",
														"typeDescriptions": {
															"typeIdentifier": "t_rational_1000000000000000000_by_1",
															"typeString": "int_const 1000000000000000000"
														},
														"value": "1"
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_rational_1000000000000000000_by_1",
															"typeString": "int_const 1000000000000000000"
														}
													],
													"expression": {
														"argumentTypes": null,
														"id": 1032,
														"name": "spentEther",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1022,
														"src": "10342:10:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"id": 1033,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "div",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 1378,
													"src": "10342:14:0",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
														"typeString": "function (uint256,uint256) pure returns (uint256)"
													}
												},
												"id": 1035,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "10342:23:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"id": 1036,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "mul",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 1354,
											"src": "10342:27:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
												"typeString": "function (uint256,uint256) pure returns (uint256)"
											}
										},
										"id": 1038,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10342:31:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "10322:51:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1043,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1041,
													"name": "spentEther",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1022,
													"src": "10392:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 1042,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "10405:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "10392:14:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1040,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "10384:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1044,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10384:23:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1045,
									"nodeType": "ExpressionStatement",
									"src": "10384:23:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1049,
												"name": "spentEther",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1022,
												"src": "10433:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"id": 1046,
												"name": "owner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1237,
												"src": "10418:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 1048,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "10418:14:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 1050,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10418:26:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1051,
									"nodeType": "ExpressionStatement",
									"src": "10418:26:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1057,
												"name": "remaining",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1013,
												"src": "10474:9:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1052,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "10454:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1055,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "10454:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 1056,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "10454:19:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 1058,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10454:30:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1059,
									"nodeType": "ExpressionStatement",
									"src": "10454:30:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1061,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "10505:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1062,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "10505:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 1063,
												"name": "tokensBought",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1031,
												"src": "10517:12:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 1060,
											"name": "mintTokens",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 527,
											"src": "10494:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
												"typeString": "function (address,uint256) returns (bool)"
											}
										},
										"id": 1064,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10494:36:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1065,
									"nodeType": "ExpressionStatement",
									"src": "10494:36:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1067,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "10559:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1068,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "10559:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 1069,
												"name": "tokensBought",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1031,
												"src": "10571:12:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 1066,
											"name": "TokensBought",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 58,
											"src": "10546:12:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_uint256_$returns$__$",
												"typeString": "function (address,uint256)"
											}
										},
										"id": 1070,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10546:38:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1071,
									"nodeType": "EmitStatement",
									"src": "10541:43:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 1072,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "10602:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 981,
									"id": 1073,
									"nodeType": "Return",
									"src": "10595:11:0"
								}
							]
						},
						"documentation": null,
						"id": 1075,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "buyTokens",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 978,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "10011:2:0"
						},
						"payable": true,
						"returnParameters": {
							"id": 981,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 980,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 1075,
									"src": "10038:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 979,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "10038:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "10037:14:0"
						},
						"scope": 1164,
						"src": "9993:620:0",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1081,
							"nodeType": "Block",
							"src": "10645:28:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 1078,
											"name": "buyTokens",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1075,
											"src": "10655:9:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$__$returns$_t_bool_$",
												"typeString": "function () returns (bool)"
											}
										},
										"id": 1079,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10655:11:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1080,
									"nodeType": "ExpressionStatement",
									"src": "10655:11:0"
								}
							]
						},
						"documentation": null,
						"id": 1082,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1076,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "10627:2:0"
						},
						"payable": true,
						"returnParameters": {
							"id": 1077,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "10645:0:0"
						},
						"scope": 1164,
						"src": "10619:54:0",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1113,
							"nodeType": "Block",
							"src": "10747:157:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 1093,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1088,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "10765:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 1089,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "10765:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 1091,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "10787:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 1090,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "10779:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 1092,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "10779:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "10765:24:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1087,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "10757:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1094,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10757:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1095,
									"nodeType": "ExpressionStatement",
									"src": "10757:33:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1100,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1097,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "10808:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 1098,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "10808:9:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 1099,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "10820:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "10808:13:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1096,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "10800:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1101,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10800:22:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1102,
									"nodeType": "ExpressionStatement",
									"src": "10800:22:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1109,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1103,
											"name": "etherBalance",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 83,
											"src": "10833:12:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1106,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "10865:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 1107,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "10865:9:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"id": 1104,
													"name": "etherBalance",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 83,
													"src": "10848:12:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 1105,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "add",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1426,
												"src": "10848:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 1108,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "10848:27:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "10833:42:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1110,
									"nodeType": "ExpressionStatement",
									"src": "10833:42:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 1111,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "10893:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 1086,
									"id": 1112,
									"nodeType": "Return",
									"src": "10886:11:0"
								}
							]
						},
						"documentation": null,
						"id": 1114,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "sendEtherToContract",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1083,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "10707:2:0"
						},
						"payable": true,
						"returnParameters": {
							"id": 1086,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1085,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 1114,
									"src": "10734:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1084,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "10734:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "10733:14:0"
						},
						"scope": 1164,
						"src": "10679:225:0",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1142,
							"nodeType": "Block",
							"src": "10971:160:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1122,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1120,
													"name": "etherBalance",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 83,
													"src": "10989:12:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 1121,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "11005:7:0",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													},
													"value": "1"
												},
												"src": "10989:23:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1119,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "10981:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1123,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10981:32:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1124,
									"nodeType": "ExpressionStatement",
									"src": "10981:32:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"hexValue": "31",
												"id": 1130,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "11044:7:0",
												"subdenomination": "ether",
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1000000000000000000_by_1",
													"typeString": "int_const 1000000000000000000"
												},
												"value": "1"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_rational_1000000000000000000_by_1",
													"typeString": "int_const 1000000000000000000"
												}
											],
											"expression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1125,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "11024:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1128,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "11024:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 1129,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "11024:19:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 1131,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "11024:28:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1132,
									"nodeType": "ExpressionStatement",
									"src": "11024:28:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1138,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1133,
											"name": "etherBalance",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 83,
											"src": "11062:12:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "31",
													"id": 1136,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "11094:7:0",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													},
													"value": "1"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													}
												],
												"expression": {
													"argumentTypes": null,
													"id": 1134,
													"name": "etherBalance",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 83,
													"src": "11077:12:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 1135,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sub",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1402,
												"src": "11077:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 1137,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "11077:25:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "11062:40:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1139,
									"nodeType": "ExpressionStatement",
									"src": "11062:40:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 1140,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "11120:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 1118,
									"id": 1141,
									"nodeType": "Return",
									"src": "11113:11:0"
								}
							]
						},
						"documentation": null,
						"id": 1143,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "getEtherFromContract",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1115,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "10939:2:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 1118,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1117,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 1143,
									"src": "10958:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1116,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "10958:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "10957:14:0"
						},
						"scope": 1164,
						"src": "10910:221:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1150,
							"nodeType": "Block",
							"src": "11205:36:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1148,
										"name": "etherBalance",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 83,
										"src": "11222:12:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 1147,
									"id": 1149,
									"nodeType": "Return",
									"src": "11215:19:0"
								}
							]
						},
						"documentation": null,
						"id": 1151,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getContractEtherBalance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1144,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "11169:2:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 1147,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1146,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1151,
									"src": "11197:7:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1145,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "11197:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "11196:9:0"
						},
						"scope": 1164,
						"src": "11137:104:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1162,
							"nodeType": "Block",
							"src": "11339:53:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1158,
											"name": "addressToName",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 111,
											"src": "11356:13:0",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_address_$_t_string_storage_$",
												"typeString": "mapping(address => string storage ref)"
											}
										},
										"id": 1160,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1159,
											"name": "_addressToFind",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1153,
											"src": "11370:14:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "11356:29:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage",
											"typeString": "string storage ref"
										}
									},
									"functionReturnParameters": 1157,
									"id": 1161,
									"nodeType": "Return",
									"src": "11349:36:0"
								}
							]
						},
						"documentation": null,
						"id": 1163,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getAddressName",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1154,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1153,
									"name": "_addressToFind",
									"nodeType": "VariableDeclaration",
									"scope": 1163,
									"src": "11271:22:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1152,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "11271:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "11270:24:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 1157,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1156,
									"name": "addressName",
									"nodeType": "VariableDeclaration",
									"scope": 1163,
									"src": "11320:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1155,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "11320:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "11319:20:0"
						},
						"scope": 1164,
						"src": "11247:145:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 1165,
				"src": "147:11247:0"
			}
		],
		"src": "0:11395:0"
	},
	"legacyAST": {
		"absolutePath": "/home/marko/EthereumAsyncProjects/AsyncCoinContract/contracts/AsyncCoin.sol",
		"exportedSymbols": {
			"AsyncCoin": [
				1164
			]
		},
		"id": 1165,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:0"
			},
			{
				"absolutePath": "/home/marko/EthereumAsyncProjects/AsyncCoinContract/contracts/open-zeppellin/SafeMath.sol",
				"file": "./open-zeppellin/SafeMath.sol",
				"id": 2,
				"nodeType": "ImportDirective",
				"scope": 1165,
				"sourceUnit": 1448,
				"src": "26:39:0",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/home/marko/EthereumAsyncProjects/AsyncCoinContract/contracts/open-zeppellin/Ownable.sol",
				"file": "./open-zeppellin/Ownable.sol",
				"id": 3,
				"nodeType": "ImportDirective",
				"scope": 1165,
				"sourceUnit": 1320,
				"src": "66:38:0",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/home/marko/EthereumAsyncProjects/AsyncCoinContract/contracts/interface/ERC20Interface.sol",
				"file": "./interface/ERC20Interface.sol",
				"id": 4,
				"nodeType": "ImportDirective",
				"scope": 1165,
				"sourceUnit": 1234,
				"src": "105:40:0",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 5,
							"name": "Ownable",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 1319,
							"src": "169:7:0",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Ownable_$1319",
								"typeString": "contract Ownable"
							}
						},
						"id": 6,
						"nodeType": "InheritanceSpecifier",
						"src": "169:7:0"
					},
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 7,
							"name": "ERC20Interface",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 1233,
							"src": "178:14:0",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_ERC20Interface_$1233",
								"typeString": "contract ERC20Interface"
							}
						},
						"id": 8,
						"nodeType": "InheritanceSpecifier",
						"src": "178:14:0"
					}
				],
				"contractDependencies": [
					1233,
					1319
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1164,
				"linearizedBaseContracts": [
					1164,
					1233,
					1319
				],
				"name": "AsyncCoin",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"canonicalName": "AsyncCoin.Coupon",
						"id": 19,
						"members": [
							{
								"constant": false,
								"id": 10,
								"name": "code",
								"nodeType": "VariableDeclaration",
								"scope": 19,
								"src": "223:11:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_string_storage_ptr",
									"typeString": "string"
								},
								"typeName": {
									"id": 9,
									"name": "string",
									"nodeType": "ElementaryTypeName",
									"src": "223:6:0",
									"typeDescriptions": {
										"typeIdentifier": "t_string_storage_ptr",
										"typeString": "string"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 12,
								"name": "tokenReward",
								"nodeType": "VariableDeclaration",
								"scope": 19,
								"src": "244:19:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 11,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "244:7:0",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 14,
								"name": "timesUsable",
								"nodeType": "VariableDeclaration",
								"scope": 19,
								"src": "273:19:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								},
								"typeName": {
									"id": 13,
									"name": "uint256",
									"nodeType": "ElementaryTypeName",
									"src": "273:7:0",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 16,
								"name": "infinite",
								"nodeType": "VariableDeclaration",
								"scope": 19,
								"src": "302:13:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								},
								"typeName": {
									"id": 15,
									"name": "bool",
									"nodeType": "ElementaryTypeName",
									"src": "302:4:0",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									}
								},
								"value": null,
								"visibility": "internal"
							},
							{
								"constant": false,
								"id": 18,
								"name": "active",
								"nodeType": "VariableDeclaration",
								"scope": 19,
								"src": "325:11:0",
								"stateVariable": false,
								"storageLocation": "default",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								},
								"typeName": {
									"id": 17,
									"name": "bool",
									"nodeType": "ElementaryTypeName",
									"src": "325:4:0",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									}
								},
								"value": null,
								"visibility": "internal"
							}
						],
						"name": "Coupon",
						"nodeType": "StructDefinition",
						"scope": 1164,
						"src": "199:144:0",
						"visibility": "public"
					},
					{
						"id": 22,
						"libraryName": {
							"contractScope": null,
							"id": 20,
							"name": "SafeMath",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 1447,
							"src": "412:8:0",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_SafeMath_$1447",
								"typeString": "library SafeMath"
							}
						},
						"nodeType": "UsingForDirective",
						"src": "406:27:0",
						"typeName": {
							"id": 21,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "425:7:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						}
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 30,
						"name": "Transfer",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 29,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 24,
									"indexed": true,
									"name": "from",
									"nodeType": "VariableDeclaration",
									"scope": 30,
									"src": "454:20:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 23,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "454:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 26,
									"indexed": true,
									"name": "to",
									"nodeType": "VariableDeclaration",
									"scope": 30,
									"src": "476:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 25,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "476:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 28,
									"indexed": false,
									"name": "tokens",
									"nodeType": "VariableDeclaration",
									"scope": 30,
									"src": "496:14:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 27,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "496:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "453:58:0"
						},
						"src": "439:73:0"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 38,
						"name": "Approval",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 37,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 32,
									"indexed": true,
									"name": "tokenOwner",
									"nodeType": "VariableDeclaration",
									"scope": 38,
									"src": "532:26:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 31,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "532:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 34,
									"indexed": true,
									"name": "spender",
									"nodeType": "VariableDeclaration",
									"scope": 38,
									"src": "560:23:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 33,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "560:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 36,
									"indexed": false,
									"name": "tokens",
									"nodeType": "VariableDeclaration",
									"scope": 38,
									"src": "585:14:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 35,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "585:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "531:69:0"
						},
						"src": "517:84:0"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 46,
						"name": "TokensMinted",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 45,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 40,
									"indexed": true,
									"name": "to",
									"nodeType": "VariableDeclaration",
									"scope": 46,
									"src": "625:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 39,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "625:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 42,
									"indexed": false,
									"name": "tokens",
									"nodeType": "VariableDeclaration",
									"scope": 46,
									"src": "645:14:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 41,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "645:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 44,
									"indexed": false,
									"name": "newTotalSupply",
									"nodeType": "VariableDeclaration",
									"scope": 46,
									"src": "661:22:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 43,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "661:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "624:60:0"
						},
						"src": "606:79:0"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 52,
						"name": "AddressFreezeChange",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 51,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 48,
									"indexed": true,
									"name": "to",
									"nodeType": "VariableDeclaration",
									"scope": 52,
									"src": "716:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 47,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "716:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 50,
									"indexed": false,
									"name": "state",
									"nodeType": "VariableDeclaration",
									"scope": 52,
									"src": "736:10:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 49,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "736:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "715:32:0"
						},
						"src": "690:58:0"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 58,
						"name": "TokensBought",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 57,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 54,
									"indexed": true,
									"name": "to",
									"nodeType": "VariableDeclaration",
									"scope": 58,
									"src": "772:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 53,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "772:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 56,
									"indexed": false,
									"name": "tokens",
									"nodeType": "VariableDeclaration",
									"scope": 58,
									"src": "792:11:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 55,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "792:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "771:33:0"
						},
						"src": "753:52:0"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 64,
						"name": "AddressNameChange",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 63,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 60,
									"indexed": true,
									"name": "to",
									"nodeType": "VariableDeclaration",
									"scope": 64,
									"src": "834:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 59,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "834:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 62,
									"indexed": false,
									"name": "name",
									"nodeType": "VariableDeclaration",
									"scope": 64,
									"src": "854:11:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 61,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "854:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "833:33:0"
						},
						"src": "810:57:0"
					},
					{
						"anonymous": false,
						"documentation": null,
						"id": 70,
						"name": "AddressCanBuyTokensStatusChange",
						"nodeType": "EventDefinition",
						"parameters": {
							"id": 69,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 66,
									"indexed": true,
									"name": "to",
									"nodeType": "VariableDeclaration",
									"scope": 70,
									"src": "910:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 65,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "910:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 68,
									"indexed": false,
									"name": "state",
									"nodeType": "VariableDeclaration",
									"scope": 70,
									"src": "930:10:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 67,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "930:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "909:32:0"
						},
						"src": "872:70:0"
					},
					{
						"constant": true,
						"id": 73,
						"name": "name",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "948:41:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_string_memory",
							"typeString": "string"
						},
						"typeName": {
							"id": 71,
							"name": "string",
							"nodeType": "ElementaryTypeName",
							"src": "948:6:0",
							"typeDescriptions": {
								"typeIdentifier": "t_string_storage_ptr",
								"typeString": "string"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "4173796e63436f696e",
							"id": 72,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "string",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "978:11:0",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_stringliteral_946342d9d738e5fc5b5dd6b522fe4479e6dabaf2260b065b3234fe31cd82028e",
								"typeString": "literal_string \"AsyncCoin\""
							},
							"value": "AsyncCoin"
						},
						"visibility": "public"
					},
					{
						"constant": true,
						"id": 76,
						"name": "symbol",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "995:37:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_string_memory",
							"typeString": "string"
						},
						"typeName": {
							"id": 74,
							"name": "string",
							"nodeType": "ElementaryTypeName",
							"src": "995:6:0",
							"typeDescriptions": {
								"typeIdentifier": "t_string_storage_ptr",
								"typeString": "string"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "415343",
							"id": 75,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "string",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1027:5:0",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_stringliteral_5f832cd8e5ac2aef6affd696bae37ca133688daf268e883c50499a707b642c07",
								"typeString": "literal_string \"ASC\""
							},
							"value": "ASC"
						},
						"visibility": "public"
					},
					{
						"constant": true,
						"id": 79,
						"name": "decimals",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1093:34:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint8",
							"typeString": "uint8"
						},
						"typeName": {
							"id": 77,
							"name": "uint8",
							"nodeType": "ElementaryTypeName",
							"src": "1093:5:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint8",
								"typeString": "uint8"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "30",
							"id": 78,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "number",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "1126:1:0",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_rational_0_by_1",
								"typeString": "int_const 0"
							},
							"value": "0"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 81,
						"name": "totalSupply",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1199:26:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 80,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "1199:7:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 83,
						"name": "etherBalance",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1258:27:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 82,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "1258:7:0",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 87,
						"name": "addressToBalance",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1346:51:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
							"typeString": "mapping(address => uint256)"
						},
						"typeName": {
							"id": 86,
							"keyType": {
								"id": 84,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "1354:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "1346:27:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
								"typeString": "mapping(address => uint256)"
							},
							"valueType": {
								"id": 85,
								"name": "uint256",
								"nodeType": "ElementaryTypeName",
								"src": "1365:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_uint256",
									"typeString": "uint256"
								}
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 93,
						"name": "allowed",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1534:52:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
							"typeString": "mapping(address => mapping(address => uint256))"
						},
						"typeName": {
							"id": 92,
							"keyType": {
								"id": 88,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "1542:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "1534:44:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
								"typeString": "mapping(address => mapping(address => uint256))"
							},
							"valueType": {
								"id": 91,
								"keyType": {
									"id": 89,
									"name": "address",
									"nodeType": "ElementaryTypeName",
									"src": "1561:7:0",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									}
								},
								"nodeType": "Mapping",
								"src": "1553:24:0",
								"typeDescriptions": {
									"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
									"typeString": "mapping(address => uint256)"
								},
								"valueType": {
									"id": 90,
									"name": "uint",
									"nodeType": "ElementaryTypeName",
									"src": "1572:4:0",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									}
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 97,
						"name": "coupons",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1670:33:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
							"typeString": "mapping(string => struct AsyncCoin.Coupon)"
						},
						"typeName": {
							"id": 96,
							"keyType": {
								"id": 94,
								"name": "string",
								"nodeType": "ElementaryTypeName",
								"src": "1678:6:0",
								"typeDescriptions": {
									"typeIdentifier": "t_string_storage_ptr",
									"typeString": "string"
								}
							},
							"nodeType": "Mapping",
							"src": "1670:25:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
								"typeString": "mapping(string => struct AsyncCoin.Coupon)"
							},
							"valueType": {
								"contractScope": null,
								"id": 95,
								"name": "Coupon",
								"nodeType": "UserDefinedTypeName",
								"referencedDeclaration": 19,
								"src": "1688:6:0",
								"typeDescriptions": {
									"typeIdentifier": "t_struct$_Coupon_$19_storage_ptr",
									"typeString": "struct AsyncCoin.Coupon"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 103,
						"name": "redeemedCoupons",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1822:59:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_string_memory_$_t_bool_$_$",
							"typeString": "mapping(address => mapping(string => bool))"
						},
						"typeName": {
							"id": 102,
							"keyType": {
								"id": 98,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "1830:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "1822:43:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_string_memory_$_t_bool_$_$",
								"typeString": "mapping(address => mapping(string => bool))"
							},
							"valueType": {
								"id": 101,
								"keyType": {
									"id": 99,
									"name": "string",
									"nodeType": "ElementaryTypeName",
									"src": "1849:6:0",
									"typeDescriptions": {
										"typeIdentifier": "t_string_storage_ptr",
										"typeString": "string"
									}
								},
								"nodeType": "Mapping",
								"src": "1841:23:0",
								"typeDescriptions": {
									"typeIdentifier": "t_mapping$_t_string_memory_$_t_bool_$",
									"typeString": "mapping(string => bool)"
								},
								"valueType": {
									"id": 100,
									"name": "bool",
									"nodeType": "ElementaryTypeName",
									"src": "1859:4:0",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									}
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 107,
						"name": "frozenAddresses",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "1953:40:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
							"typeString": "mapping(address => bool)"
						},
						"typeName": {
							"id": 106,
							"keyType": {
								"id": 104,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "1961:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "1953:24:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
								"typeString": "mapping(address => bool)"
							},
							"valueType": {
								"id": 105,
								"name": "bool",
								"nodeType": "ElementaryTypeName",
								"src": "1972:4:0",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 111,
						"name": "addressToName",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "2050:40:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_string_storage_$",
							"typeString": "mapping(address => string)"
						},
						"typeName": {
							"id": 110,
							"keyType": {
								"id": 108,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "2058:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "2050:26:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_string_storage_$",
								"typeString": "mapping(address => string)"
							},
							"valueType": {
								"id": 109,
								"name": "string",
								"nodeType": "ElementaryTypeName",
								"src": "2069:6:0",
								"typeDescriptions": {
									"typeIdentifier": "t_string_storage_ptr",
									"typeString": "string"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 115,
						"name": "allowedToBuyTokens",
						"nodeType": "VariableDeclaration",
						"scope": 1164,
						"src": "2134:43:0",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
							"typeString": "mapping(address => bool)"
						},
						"typeName": {
							"id": 114,
							"keyType": {
								"id": 112,
								"name": "address",
								"nodeType": "ElementaryTypeName",
								"src": "2142:7:0",
								"typeDescriptions": {
									"typeIdentifier": "t_address",
									"typeString": "address"
								}
							},
							"nodeType": "Mapping",
							"src": "2134:24:0",
							"typeDescriptions": {
								"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
								"typeString": "mapping(address => bool)"
							},
							"valueType": {
								"id": 113,
								"name": "bool",
								"nodeType": "ElementaryTypeName",
								"src": "2153:4:0",
								"typeDescriptions": {
									"typeIdentifier": "t_bool",
									"typeString": "bool"
								}
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"body": {
							"id": 137,
							"nodeType": "Block",
							"src": "2205:419:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 124,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 119,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "2364:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 120,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "2364:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 122,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "2386:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 121,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "2378:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 123,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "2378:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "2364:24:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4f776e65722063616e277420626520656d7074792e",
												"id": 125,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "2390:23:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_634950abcb8478dd0330e12f30b8d97418887bd958dc983f2d95ac6b97db28db",
													"typeString": "literal_string \"Owner can't be empty.\""
												},
												"value": "Owner can't be empty."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_634950abcb8478dd0330e12f30b8d97418887bd958dc983f2d95ac6b97db28db",
													"typeString": "literal_string \"Owner can't be empty.\""
												}
											],
											"id": 118,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1466,
											"src": "2356:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 126,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2356:58:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 127,
									"nodeType": "ExpressionStatement",
									"src": "2356:58:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 131,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 128,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1237,
											"src": "2480:5:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 129,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1462,
												"src": "2488:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 130,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sender",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "2488:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "2480:18:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 132,
									"nodeType": "ExpressionStatement",
									"src": "2480:18:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 135,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 133,
											"name": "totalSupply",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												81
											],
											"referencedDeclaration": 81,
											"src": "2602:11:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 134,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "2616:1:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "2602:15:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 136,
									"nodeType": "ExpressionStatement",
									"src": "2602:15:0"
								}
							]
						},
						"documentation": null,
						"id": 138,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 116,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2195:2:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 117,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2205:0:0"
						},
						"scope": 1164,
						"src": "2184:440:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 148,
							"nodeType": "Block",
							"src": "2687:43:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										},
										"id": 146,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 143,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1462,
												"src": "2704:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 144,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sender",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "2704:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"id": 145,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1237,
											"src": "2718:5:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "2704:19:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 142,
									"id": 147,
									"nodeType": "Return",
									"src": "2697:26:0"
								}
							]
						},
						"documentation": null,
						"id": 149,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "isOwner",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 139,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2646:2:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 142,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 141,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 149,
									"src": "2674:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 140,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "2674:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2673:14:0"
						},
						"scope": 1164,
						"src": "2630:100:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 156,
							"nodeType": "Block",
							"src": "2789:35:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 154,
										"name": "totalSupply",
										"nodeType": "Identifier",
										"overloadedDeclarations": [
											81
										],
										"referencedDeclaration": 81,
										"src": "2806:11:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 153,
									"id": 155,
									"nodeType": "Return",
									"src": "2799:18:0"
								}
							]
						},
						"documentation": null,
						"id": 157,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "totalSupply",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 150,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2756:2:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 153,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 152,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 157,
									"src": "2784:4:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 151,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "2784:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2783:6:0"
						},
						"scope": 1164,
						"src": "2736:88:0",
						"stateMutability": "view",
						"superFunction": 1171,
						"visibility": "public"
					},
					{
						"body": {
							"id": 167,
							"nodeType": "Block",
							"src": "2889:45:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 163,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "2916:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 164,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "2916:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 162,
											"name": "balanceOf",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												188
											],
											"referencedDeclaration": 188,
											"src": "2906:9:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_view$_t_address_$returns$_t_uint256_$",
												"typeString": "function (address) view returns (uint256)"
											}
										},
										"id": 165,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "2906:21:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 161,
									"id": 166,
									"nodeType": "Return",
									"src": "2899:28:0"
								}
							]
						},
						"documentation": null,
						"id": 168,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "myBalance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 158,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "2848:2:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 161,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 160,
									"name": "balance",
									"nodeType": "VariableDeclaration",
									"scope": 168,
									"src": "2876:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 159,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "2876:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2875:14:0"
						},
						"scope": 1164,
						"src": "2830:104:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 187,
							"nodeType": "Block",
							"src": "3017:96:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 180,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 176,
													"name": "tokenOwner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 170,
													"src": "3035:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 178,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "3057:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 177,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "3049:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 179,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "3049:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "3035:24:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 175,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "3027:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 181,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3027:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 182,
									"nodeType": "ExpressionStatement",
									"src": "3027:33:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 183,
											"name": "addressToBalance",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 87,
											"src": "3078:16:0",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
												"typeString": "mapping(address => uint256)"
											}
										},
										"id": 185,
										"indexExpression": {
											"argumentTypes": null,
											"id": 184,
											"name": "tokenOwner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 170,
											"src": "3095:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "3078:28:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 174,
									"id": 186,
									"nodeType": "Return",
									"src": "3071:35:0"
								}
							]
						},
						"documentation": null,
						"id": 188,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "balanceOf",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 171,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 170,
									"name": "tokenOwner",
									"nodeType": "VariableDeclaration",
									"scope": 188,
									"src": "2959:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 169,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "2959:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "2958:20:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 174,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 173,
									"name": "balance",
									"nodeType": "VariableDeclaration",
									"scope": 188,
									"src": "3004:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 172,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "3004:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "3003:14:0"
						},
						"scope": 1164,
						"src": "2940:173:0",
						"stateMutability": "view",
						"superFunction": 1178,
						"visibility": "public"
					},
					{
						"body": {
							"id": 225,
							"nodeType": "Block",
							"src": "3217:182:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 202,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 198,
													"name": "_tokenOwner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 190,
													"src": "3235:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 200,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "3258:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 199,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "3250:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 201,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "3250:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "3235:25:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 197,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "3227:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 203,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3227:34:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 204,
									"nodeType": "ExpressionStatement",
									"src": "3227:34:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 210,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 206,
													"name": "_spender",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 192,
													"src": "3279:8:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 208,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "3299:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 207,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "3291:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 209,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "3291:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "3279:22:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 205,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "3271:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 211,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3271:31:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 212,
									"nodeType": "ExpressionStatement",
									"src": "3271:31:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 216,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 214,
													"name": "_tokenOwner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 190,
													"src": "3320:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 215,
													"name": "_spender",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 192,
													"src": "3335:8:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "3320:23:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 213,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "3312:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 217,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3312:32:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 218,
									"nodeType": "ExpressionStatement",
									"src": "3312:32:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 219,
												"name": "allowed",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 93,
												"src": "3362:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
													"typeString": "mapping(address => mapping(address => uint256))"
												}
											},
											"id": 221,
											"indexExpression": {
												"argumentTypes": null,
												"id": 220,
												"name": "_tokenOwner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 190,
												"src": "3370:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "3362:20:0",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
												"typeString": "mapping(address => uint256)"
											}
										},
										"id": 223,
										"indexExpression": {
											"argumentTypes": null,
											"id": 222,
											"name": "_spender",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 192,
											"src": "3383:8:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "3362:30:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 196,
									"id": 224,
									"nodeType": "Return",
									"src": "3355:37:0"
								}
							]
						},
						"documentation": null,
						"id": 226,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "allowance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 193,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 190,
									"name": "_tokenOwner",
									"nodeType": "VariableDeclaration",
									"scope": 226,
									"src": "3138:19:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 189,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "3138:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 192,
									"name": "_spender",
									"nodeType": "VariableDeclaration",
									"scope": 226,
									"src": "3159:16:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 191,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "3159:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "3137:39:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 196,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 195,
									"name": "remaining",
									"nodeType": "VariableDeclaration",
									"scope": 226,
									"src": "3202:14:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 194,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "3202:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "3201:16:0"
						},
						"scope": 1164,
						"src": "3119:280:0",
						"stateMutability": "view",
						"superFunction": 1187,
						"visibility": "public"
					},
					{
						"body": {
							"id": 312,
							"nodeType": "Block",
							"src": "3479:775:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 240,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 236,
													"name": "_to",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 228,
													"src": "3497:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 238,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "3512:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 237,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "3504:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 239,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "3504:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "3497:17:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "526563656976696e6720616464726573732063616e2774206265206e756c6c2e",
												"id": 241,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "3516:34:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_6d5fdf6af8261d9a72c25f6bc01c1a2c29bcc416d9522e22de92761934f87ef5",
													"typeString": "literal_string \"Receiving address can't be null.\""
												},
												"value": "Receiving address can't be null."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_6d5fdf6af8261d9a72c25f6bc01c1a2c29bcc416d9522e22de92761934f87ef5",
													"typeString": "literal_string \"Receiving address can't be null.\""
												}
											],
											"id": 235,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1466,
											"src": "3489:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 242,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3489:62:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 243,
									"nodeType": "ExpressionStatement",
									"src": "3489:62:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 248,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 245,
													"name": "_to",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 228,
													"src": "3569:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 246,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "3576:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 247,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "3576:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "3569:17:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "43616e27742073656e7420746f6b656e7320746f20796f757273656c662e",
												"id": 249,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "3588:32:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_1a17f82f54ef3f6fe463f559ee8301b95cff1cc53df2855bcf30073872397d2d",
													"typeString": "literal_string \"Can't sent tokens to yourself.\""
												},
												"value": "Can't sent tokens to yourself."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_1a17f82f54ef3f6fe463f559ee8301b95cff1cc53df2855bcf30073872397d2d",
													"typeString": "literal_string \"Can't sent tokens to yourself.\""
												}
											],
											"id": 244,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1466,
											"src": "3561:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 250,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3561:60:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 251,
									"nodeType": "ExpressionStatement",
									"src": "3561:60:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 255,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 253,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 230,
													"src": "3639:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 254,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "3649:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "3639:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "4e756d626572206f662073656e7420746f6b656e73206d75737420626520626967676572207468616e207a65726f2e",
												"id": 256,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "3652:49:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_587a5ac3c46e5f4f85b60e367c506728bc721ff94224395f3e325d3bb49c6c62",
													"typeString": "literal_string \"Number of sent tokens must be bigger than zero.\""
												},
												"value": "Number of sent tokens must be bigger than zero."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_587a5ac3c46e5f4f85b60e367c506728bc721ff94224395f3e325d3bb49c6c62",
													"typeString": "literal_string \"Number of sent tokens must be bigger than zero.\""
												}
											],
											"id": 252,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1466,
											"src": "3631:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 257,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3631:71:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 258,
									"nodeType": "ExpressionStatement",
									"src": "3631:71:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 265,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 260,
														"name": "addressToBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 87,
														"src": "3720:16:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 263,
													"indexExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 261,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1462,
															"src": "3737:3:0",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 262,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "3737:10:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "3720:28:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 264,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 230,
													"src": "3752:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "3720:39:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "53656e6465722068617320746f206861766520656e6f75676820746f6b656e7320746f207472616e73666572207468656d2e",
												"id": 266,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "3761:52:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_7330adee06735ce1ece281681981471736da8ebd318c34c473f3c0fd645c9bbe",
													"typeString": "literal_string \"Sender has to have enough tokens to transfer them.\""
												},
												"value": "Sender has to have enough tokens to transfer them."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_7330adee06735ce1ece281681981471736da8ebd318c34c473f3c0fd645c9bbe",
													"typeString": "literal_string \"Sender has to have enough tokens to transfer them.\""
												}
											],
											"id": 259,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1466,
											"src": "3712:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 267,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3712:102:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 268,
									"nodeType": "ExpressionStatement",
									"src": "3712:102:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 275,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 270,
														"name": "frozenAddresses",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 107,
														"src": "3888:15:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
															"typeString": "mapping(address => bool)"
														}
													},
													"id": 273,
													"indexExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 271,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1462,
															"src": "3904:3:0",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 272,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "3904:10:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "3888:27:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 274,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "3919:5:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												},
												"src": "3888:36:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "596f7572206163636f756e742069732066726f7a656e2c20736f20796f752063616e2774206d616b652074686973207472616e73616374696f6e2e",
												"id": 276,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "string",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "3926:61:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_stringliteral_3856f85f82a560a0a31551c9d6e47baac36cd12415d9e0d221798851c6ba3f6a",
													"typeString": "literal_string \"Your account is frozen, so you can't make this transaction.\""
												},
												"value": "Your account is frozen, so you can't make this transaction."
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												{
													"typeIdentifier": "t_stringliteral_3856f85f82a560a0a31551c9d6e47baac36cd12415d9e0d221798851c6ba3f6a",
													"typeString": "literal_string \"Your account is frozen, so you can't make this transaction.\""
												}
											],
											"id": 269,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1466,
											"src": "3880:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (bool,string memory) pure"
											}
										},
										"id": 277,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "3880:108:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 278,
									"nodeType": "ExpressionStatement",
									"src": "3880:108:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 290,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 279,
												"name": "addressToBalance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 87,
												"src": "4036:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 282,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 280,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "4053:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 281,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "4053:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "4036:28:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 288,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 230,
													"src": "4100:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 283,
														"name": "addressToBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 87,
														"src": "4067:16:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 286,
													"indexExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 284,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1462,
															"src": "4084:3:0",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 285,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "4084:10:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4067:28:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 287,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sub",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1402,
												"src": "4067:32:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 289,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "4067:41:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "4036:72:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 291,
									"nodeType": "ExpressionStatement",
									"src": "4036:72:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 301,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 292,
												"name": "addressToBalance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 87,
												"src": "4118:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 294,
											"indexExpression": {
												"argumentTypes": null,
												"id": 293,
												"name": "_to",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 228,
												"src": "4135:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "4118:21:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 299,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 230,
													"src": "4168:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 295,
														"name": "addressToBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 87,
														"src": "4142:16:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 297,
													"indexExpression": {
														"argumentTypes": null,
														"id": 296,
														"name": "_to",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 228,
														"src": "4159:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4142:21:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 298,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "add",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1426,
												"src": "4142:25:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 300,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "4142:34:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "4118:58:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 302,
									"nodeType": "ExpressionStatement",
									"src": "4118:58:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 304,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "4200:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 305,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "4200:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 306,
												"name": "_to",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 228,
												"src": "4212:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 307,
												"name": "_tokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 230,
												"src": "4217:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 303,
											"name": "Transfer",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												30
											],
											"referencedDeclaration": 30,
											"src": "4191:8:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
												"typeString": "function (address,address,uint256)"
											}
										},
										"id": 308,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4191:34:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 309,
									"nodeType": "EmitStatement",
									"src": "4186:39:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 310,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "4243:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 234,
									"id": 311,
									"nodeType": "Return",
									"src": "4236:11:0"
								}
							]
						},
						"documentation": null,
						"id": 313,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "transfer",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 231,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 228,
									"name": "_to",
									"nodeType": "VariableDeclaration",
									"scope": 313,
									"src": "3423:11:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 227,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "3423:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 230,
									"name": "_tokens",
									"nodeType": "VariableDeclaration",
									"scope": 313,
									"src": "3436:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 229,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "3436:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "3422:27:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 234,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 233,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 313,
									"src": "3466:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 232,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "3466:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "3465:14:0"
						},
						"scope": 1164,
						"src": "3405:849:0",
						"stateMutability": "nonpayable",
						"superFunction": 1196,
						"visibility": "public"
					},
					{
						"body": {
							"id": 425,
							"nodeType": "Block",
							"src": "4353:714:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 329,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 325,
													"name": "_from",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 315,
													"src": "4423:5:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 327,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "4440:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 326,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "4432:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 328,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "4432:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "4423:19:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 324,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "4415:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 330,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4415:28:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 331,
									"nodeType": "ExpressionStatement",
									"src": "4415:28:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 337,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 333,
													"name": "_to",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 317,
													"src": "4461:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 335,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "4476:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 334,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "4468:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 336,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "4468:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "4461:17:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 332,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "4453:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 338,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4453:26:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 339,
									"nodeType": "ExpressionStatement",
									"src": "4453:26:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 343,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 341,
													"name": "_from",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 315,
													"src": "4497:5:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 342,
													"name": "_to",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 317,
													"src": "4506:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "4497:12:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 340,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "4489:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 344,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4489:21:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 345,
									"nodeType": "ExpressionStatement",
									"src": "4489:21:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 349,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 347,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 319,
													"src": "4528:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 348,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "4538:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "4528:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 346,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "4520:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 350,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4520:20:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 351,
									"nodeType": "ExpressionStatement",
									"src": "4520:20:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 359,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 353,
															"name": "allowed",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 93,
															"src": "4558:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
																"typeString": "mapping(address => mapping(address => uint256))"
															}
														},
														"id": 355,
														"indexExpression": {
															"argumentTypes": null,
															"id": 354,
															"name": "_from",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 315,
															"src": "4566:5:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "4558:14:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 357,
													"indexExpression": {
														"argumentTypes": null,
														"id": 356,
														"name": "_to",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 317,
														"src": "4573:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4558:19:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 358,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 319,
													"src": "4581:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "4558:30:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 352,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "4550:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 360,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4550:39:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 361,
									"nodeType": "ExpressionStatement",
									"src": "4550:39:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 367,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 363,
														"name": "addressToBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 87,
														"src": "4607:16:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 365,
													"indexExpression": {
														"argumentTypes": null,
														"id": 364,
														"name": "_from",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 315,
														"src": "4624:5:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4607:23:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 366,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 319,
													"src": "4634:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"src": "4607:34:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 362,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "4599:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 368,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4599:43:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 369,
									"nodeType": "ExpressionStatement",
									"src": "4599:43:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 375,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 371,
														"name": "frozenAddresses",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 107,
														"src": "4716:15:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
															"typeString": "mapping(address => bool)"
														}
													},
													"id": 373,
													"indexExpression": {
														"argumentTypes": null,
														"id": 372,
														"name": "_from",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 315,
														"src": "4732:5:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4716:22:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "66616c7365",
													"id": 374,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "4742:5:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "false"
												},
												"src": "4716:31:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 370,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "4708:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 376,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "4708:40:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 377,
									"nodeType": "ExpressionStatement",
									"src": "4708:40:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 387,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 378,
												"name": "addressToBalance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 87,
												"src": "4786:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 380,
											"indexExpression": {
												"argumentTypes": null,
												"id": 379,
												"name": "_from",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 315,
												"src": "4803:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "4786:23:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 385,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 319,
													"src": "4840:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 381,
														"name": "addressToBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 87,
														"src": "4812:16:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 383,
													"indexExpression": {
														"argumentTypes": null,
														"id": 382,
														"name": "_from",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 315,
														"src": "4829:5:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4812:23:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 384,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sub",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1402,
												"src": "4812:27:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 386,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "4812:36:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "4786:62:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 388,
									"nodeType": "ExpressionStatement",
									"src": "4786:62:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 404,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 389,
													"name": "allowed",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 93,
													"src": "4858:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
														"typeString": "mapping(address => mapping(address => uint256))"
													}
												},
												"id": 393,
												"indexExpression": {
													"argumentTypes": null,
													"id": 390,
													"name": "_from",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 315,
													"src": "4866:5:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "4858:14:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 394,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 391,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "4873:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 392,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "4873:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "4858:26:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 402,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 319,
													"src": "4918:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 395,
															"name": "allowed",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 93,
															"src": "4887:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
																"typeString": "mapping(address => mapping(address => uint256))"
															}
														},
														"id": 397,
														"indexExpression": {
															"argumentTypes": null,
															"id": 396,
															"name": "_from",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 315,
															"src": "4895:5:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "4887:14:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 400,
													"indexExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 398,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1462,
															"src": "4902:3:0",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 399,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "4902:10:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4887:26:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 401,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sub",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1402,
												"src": "4887:30:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 403,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "4887:39:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "4858:68:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 405,
									"nodeType": "ExpressionStatement",
									"src": "4858:68:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 415,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 406,
												"name": "addressToBalance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 87,
												"src": "4936:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 408,
											"indexExpression": {
												"argumentTypes": null,
												"id": 407,
												"name": "_to",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 317,
												"src": "4953:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "4936:21:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 413,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 319,
													"src": "4986:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 409,
														"name": "addressToBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 87,
														"src": "4960:16:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 411,
													"indexExpression": {
														"argumentTypes": null,
														"id": 410,
														"name": "_to",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 317,
														"src": "4977:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "4960:21:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 412,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "add",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1426,
												"src": "4960:25:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 414,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "4960:34:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "4936:58:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 416,
									"nodeType": "ExpressionStatement",
									"src": "4936:58:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 418,
												"name": "_from",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 315,
												"src": "5018:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 419,
												"name": "_to",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 317,
												"src": "5025:3:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 420,
												"name": "_tokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 319,
												"src": "5030:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 417,
											"name": "Transfer",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												30
											],
											"referencedDeclaration": 30,
											"src": "5009:8:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
												"typeString": "function (address,address,uint256)"
											}
										},
										"id": 421,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5009:29:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 422,
									"nodeType": "EmitStatement",
									"src": "5004:34:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 423,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "5056:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 323,
									"id": 424,
									"nodeType": "Return",
									"src": "5049:11:0"
								}
							]
						},
						"documentation": null,
						"id": 426,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "transferFrom",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 320,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 315,
									"name": "_from",
									"nodeType": "VariableDeclaration",
									"scope": 426,
									"src": "4282:13:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 314,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "4282:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 317,
									"name": "_to",
									"nodeType": "VariableDeclaration",
									"scope": 426,
									"src": "4297:11:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 316,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "4297:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 319,
									"name": "_tokens",
									"nodeType": "VariableDeclaration",
									"scope": 426,
									"src": "4310:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 318,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "4310:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "4281:42:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 323,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 322,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 426,
									"src": "4340:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 321,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "4340:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "4339:14:0"
						},
						"scope": 1164,
						"src": "4260:807:0",
						"stateMutability": "nonpayable",
						"superFunction": 1216,
						"visibility": "public"
					},
					{
						"body": {
							"id": 482,
							"nodeType": "Block",
							"src": "5151:280:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 440,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 436,
													"name": "_spender",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 428,
													"src": "5169:8:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 438,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "5189:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 437,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "5181:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 439,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "5181:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "5169:22:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 435,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "5161:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 441,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5161:31:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 442,
									"nodeType": "ExpressionStatement",
									"src": "5161:31:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 447,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 444,
													"name": "_spender",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 428,
													"src": "5210:8:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 445,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "5222:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 446,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "5222:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "5210:22:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 443,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "5202:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 448,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5202:31:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 449,
									"nodeType": "ExpressionStatement",
									"src": "5202:31:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 453,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 451,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 430,
													"src": "5251:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 452,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "5261:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "5251:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 450,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "5243:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 454,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5243:20:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 455,
									"nodeType": "ExpressionStatement",
									"src": "5243:20:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 471,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 456,
													"name": "allowed",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 93,
													"src": "5274:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
														"typeString": "mapping(address => mapping(address => uint256))"
													}
												},
												"id": 460,
												"indexExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 457,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "5282:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 458,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "5282:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "5274:19:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 461,
											"indexExpression": {
												"argumentTypes": null,
												"id": 459,
												"name": "_spender",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 428,
												"src": "5294:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "5274:29:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 469,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 430,
													"src": "5340:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 462,
															"name": "allowed",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 93,
															"src": "5306:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
																"typeString": "mapping(address => mapping(address => uint256))"
															}
														},
														"id": 465,
														"indexExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 463,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1462,
																"src": "5314:3:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 464,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "5314:10:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "5306:19:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 467,
													"indexExpression": {
														"argumentTypes": null,
														"id": 466,
														"name": "_spender",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 428,
														"src": "5326:8:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "5306:29:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 468,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "add",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1426,
												"src": "5306:33:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 470,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "5306:42:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "5274:74:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 472,
									"nodeType": "ExpressionStatement",
									"src": "5274:74:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 474,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "5372:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 475,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "5372:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 476,
												"name": "_spender",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 428,
												"src": "5384:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 477,
												"name": "_tokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 430,
												"src": "5394:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 473,
											"name": "Approval",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												38
											],
											"referencedDeclaration": 38,
											"src": "5363:8:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
												"typeString": "function (address,address,uint256)"
											}
										},
										"id": 478,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5363:39:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 479,
									"nodeType": "EmitStatement",
									"src": "5358:44:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 480,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "5420:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 434,
									"id": 481,
									"nodeType": "Return",
									"src": "5413:11:0"
								}
							]
						},
						"documentation": null,
						"id": 483,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "approve",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 431,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 428,
									"name": "_spender",
									"nodeType": "VariableDeclaration",
									"scope": 483,
									"src": "5090:16:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 427,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "5090:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 430,
									"name": "_tokens",
									"nodeType": "VariableDeclaration",
									"scope": 483,
									"src": "5108:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 429,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "5108:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "5089:32:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 434,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 433,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 483,
									"src": "5138:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 432,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "5138:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "5137:14:0"
						},
						"scope": 1164,
						"src": "5073:358:0",
						"stateMutability": "nonpayable",
						"superFunction": 1205,
						"visibility": "public"
					},
					{
						"body": {
							"id": 526,
							"nodeType": "Block",
							"src": "5553:273:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 501,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 492,
												"name": "addressToBalance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 87,
												"src": "5563:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
													"typeString": "mapping(address => uint256)"
												}
											},
											"id": 494,
											"indexExpression": {
												"argumentTypes": null,
												"id": 493,
												"name": "_receiver",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 485,
												"src": "5580:9:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "5563:27:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 499,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 487,
													"src": "5625:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 495,
														"name": "addressToBalance",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 87,
														"src": "5593:16:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
															"typeString": "mapping(address => uint256)"
														}
													},
													"id": 497,
													"indexExpression": {
														"argumentTypes": null,
														"id": 496,
														"name": "_receiver",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 485,
														"src": "5610:9:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "5593:27:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 498,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "add",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1426,
												"src": "5593:31:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 500,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "5593:40:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "5563:70:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 502,
									"nodeType": "ExpressionStatement",
									"src": "5563:70:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 508,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 503,
											"name": "totalSupply",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												81
											],
											"referencedDeclaration": 81,
											"src": "5643:11:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 506,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 487,
													"src": "5673:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"id": 504,
													"name": "totalSupply",
													"nodeType": "Identifier",
													"overloadedDeclarations": [
														81
													],
													"referencedDeclaration": 81,
													"src": "5657:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 505,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "add",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1426,
												"src": "5657:15:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 507,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "5657:24:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "5643:38:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 509,
									"nodeType": "ExpressionStatement",
									"src": "5643:38:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 511,
												"name": "_receiver",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 485,
												"src": "5710:9:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 512,
												"name": "_tokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 487,
												"src": "5721:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											{
												"argumentTypes": null,
												"id": 513,
												"name": "totalSupply",
												"nodeType": "Identifier",
												"overloadedDeclarations": [
													81
												],
												"referencedDeclaration": 81,
												"src": "5730:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 510,
											"name": "TokensMinted",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 46,
											"src": "5697:12:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_uint256_$_t_uint256_$returns$__$",
												"typeString": "function (address,uint256,uint256)"
											}
										},
										"id": 514,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5697:45:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 515,
									"nodeType": "EmitStatement",
									"src": "5692:50:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"hexValue": "30",
														"id": 518,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "5774:1:0",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														}
													],
													"id": 517,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"lValueRequested": false,
													"nodeType": "ElementaryTypeNameExpression",
													"src": "5766:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_type$_t_address_$",
														"typeString": "type(address)"
													},
													"typeName": "address"
												},
												"id": 519,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "typeConversion",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "5766:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 520,
												"name": "_receiver",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 485,
												"src": "5778:9:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 521,
												"name": "_tokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 487,
												"src": "5789:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 516,
											"name": "Transfer",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												30
											],
											"referencedDeclaration": 30,
											"src": "5757:8:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
												"typeString": "function (address,address,uint256)"
											}
										},
										"id": 522,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5757:40:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 523,
									"nodeType": "EmitStatement",
									"src": "5752:45:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 524,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "5815:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 491,
									"id": 525,
									"nodeType": "Return",
									"src": "5808:11:0"
								}
							]
						},
						"documentation": null,
						"id": 527,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "mintTokens",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 488,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 485,
									"name": "_receiver",
									"nodeType": "VariableDeclaration",
									"scope": 527,
									"src": "5490:17:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 484,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "5490:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 487,
									"name": "_tokens",
									"nodeType": "VariableDeclaration",
									"scope": 527,
									"src": "5509:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 486,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "5509:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "5489:33:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 491,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 490,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 527,
									"src": "5540:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 489,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "5540:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "5539:14:0"
						},
						"scope": 1164,
						"src": "5470:356:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 559,
							"nodeType": "Block",
							"src": "5929:142:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 543,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 539,
													"name": "_receiver",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 529,
													"src": "5947:9:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 541,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "5968:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 540,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "5960:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 542,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "5960:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "5947:23:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 538,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "5939:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 544,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5939:32:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 545,
									"nodeType": "ExpressionStatement",
									"src": "5939:32:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 549,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 547,
													"name": "_tokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 531,
													"src": "5989:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 548,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "5999:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "5989:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 546,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "5981:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 550,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "5981:20:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 551,
									"nodeType": "ExpressionStatement",
									"src": "5981:20:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 553,
												"name": "_receiver",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 529,
												"src": "6023:9:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 554,
												"name": "_tokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 531,
												"src": "6034:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 552,
											"name": "mintTokens",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 527,
											"src": "6012:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
												"typeString": "function (address,uint256) returns (bool)"
											}
										},
										"id": 555,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6012:30:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 556,
									"nodeType": "ExpressionStatement",
									"src": "6012:30:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 557,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "6060:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 537,
									"id": 558,
									"nodeType": "Return",
									"src": "6053:11:0"
								}
							]
						},
						"documentation": null,
						"id": 560,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 534,
								"modifierName": {
									"argumentTypes": null,
									"id": 533,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "5897:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "5897:9:0"
							}
						],
						"name": "ownerMintTokens",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 532,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 529,
									"name": "_receiver",
									"nodeType": "VariableDeclaration",
									"scope": 560,
									"src": "5857:17:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 528,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "5857:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 531,
									"name": "_tokens",
									"nodeType": "VariableDeclaration",
									"scope": 560,
									"src": "5876:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 530,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "5876:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "5856:33:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 537,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 536,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 560,
									"src": "5916:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 535,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "5916:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "5915:14:0"
						},
						"scope": 1164,
						"src": "5832:239:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 613,
							"nodeType": "Block",
							"src": "6204:464:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 576,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 574,
													"name": "_tokenReward",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 564,
													"src": "6222:12:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 575,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6237:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "6222:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 573,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "6214:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 577,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6214:25:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 578,
									"nodeType": "ExpressionStatement",
									"src": "6214:25:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 585,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 581,
																"name": "_couponCode",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 562,
																"src": "6263:11:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_string_memory_ptr",
																	"typeString": "string memory"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_string_memory_ptr",
																	"typeString": "string memory"
																}
															],
															"id": 580,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "6257:5:0",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
																"typeString": "type(bytes storage pointer)"
															},
															"typeName": "bytes"
														},
														"id": 582,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "6257:18:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes_memory",
															"typeString": "bytes memory"
														}
													},
													"id": 583,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "length",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "6257:25:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 584,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6285:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "6257:29:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 579,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "6249:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 586,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6249:38:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 587,
									"nodeType": "ExpressionStatement",
									"src": "6249:38:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 594,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 589,
															"name": "coupons",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 97,
															"src": "6348:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
															}
														},
														"id": 591,
														"indexExpression": {
															"argumentTypes": null,
															"id": 590,
															"name": "_couponCode",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 562,
															"src": "6356:11:0",
															"typeDescriptions": {
																"typeIdentifier": "t_string_memory_ptr",
																"typeString": "string memory"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "6348:20:0",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_Coupon_$19_storage",
															"typeString": "struct AsyncCoin.Coupon storage ref"
														}
													},
													"id": 592,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "tokenReward",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 12,
													"src": "6348:32:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 593,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6384:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "6348:37:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 588,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "6340:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 595,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6340:46:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 596,
									"nodeType": "ExpressionStatement",
									"src": "6340:46:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 609,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 597,
												"name": "coupons",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 97,
												"src": "6397:7:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
													"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
												}
											},
											"id": 599,
											"indexExpression": {
												"argumentTypes": null,
												"id": 598,
												"name": "_couponCode",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 562,
												"src": "6405:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "6397:20:0",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_Coupon_$19_storage",
												"typeString": "struct AsyncCoin.Coupon storage ref"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 601,
													"name": "_couponCode",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 562,
													"src": "6448:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												},
												{
													"argumentTypes": null,
													"id": 602,
													"name": "_tokenReward",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 564,
													"src": "6487:12:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"id": 603,
													"name": "_timeCouponCanBeUsed",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 566,
													"src": "6527:20:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												{
													"argumentTypes": null,
													"hexValue": "74727565",
													"id": 604,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6570:4:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "true"
												},
												{
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 607,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 605,
														"name": "_timeCouponCanBeUsed",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 566,
														"src": "6599:20:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "30",
														"id": 606,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "6623:1:0",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_0_by_1",
															"typeString": "int_const 0"
														},
														"value": "0"
													},
													"src": "6599:25:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												}
											],
											"expression": {
												"argumentTypes": null,
												"id": 600,
												"name": "Coupon",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 19,
												"src": "6420:6:0",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_struct$_Coupon_$19_storage_ptr_$",
													"typeString": "type(struct AsyncCoin.Coupon storage pointer)"
												}
											},
											"id": 608,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "structConstructorCall",
											"lValueRequested": false,
											"names": [
												"code",
												"tokenReward",
												"timesUsable",
												"active",
												"infinite"
											],
											"nodeType": "FunctionCall",
											"src": "6420:219:0",
											"typeDescriptions": {
												"typeIdentifier": "t_struct$_Coupon_$19_memory",
												"typeString": "struct AsyncCoin.Coupon memory"
											}
										},
										"src": "6397:242:0",
										"typeDescriptions": {
											"typeIdentifier": "t_struct$_Coupon_$19_storage",
											"typeString": "struct AsyncCoin.Coupon storage ref"
										}
									},
									"id": 610,
									"nodeType": "ExpressionStatement",
									"src": "6397:242:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 611,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "6657:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 572,
									"id": 612,
									"nodeType": "Return",
									"src": "6650:11:0"
								}
							]
						},
						"documentation": null,
						"id": 614,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 569,
								"modifierName": {
									"argumentTypes": null,
									"id": 568,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "6172:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "6172:9:0"
							}
						],
						"name": "createCoupon",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 567,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 562,
									"name": "_couponCode",
									"nodeType": "VariableDeclaration",
									"scope": 614,
									"src": "6099:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 561,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "6099:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 564,
									"name": "_tokenReward",
									"nodeType": "VariableDeclaration",
									"scope": 614,
									"src": "6119:17:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 563,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "6119:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 566,
									"name": "_timeCouponCanBeUsed",
									"nodeType": "VariableDeclaration",
									"scope": 614,
									"src": "6138:25:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 565,
										"name": "uint",
										"nodeType": "ElementaryTypeName",
										"src": "6138:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "6098:66:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 572,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 571,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 614,
									"src": "6191:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 570,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "6191:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "6190:14:0"
						},
						"scope": 1164,
						"src": "6077:591:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 641,
							"nodeType": "Block",
							"src": "6756:131:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 629,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 624,
															"name": "coupons",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 97,
															"src": "6774:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
															}
														},
														"id": 626,
														"indexExpression": {
															"argumentTypes": null,
															"id": 625,
															"name": "_couponCode",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 616,
															"src": "6782:11:0",
															"typeDescriptions": {
																"typeIdentifier": "t_string_memory_ptr",
																"typeString": "string memory"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "6774:20:0",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_Coupon_$19_storage",
															"typeString": "struct AsyncCoin.Coupon storage ref"
														}
													},
													"id": 627,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "tokenReward",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 12,
													"src": "6774:32:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 628,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "6810:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "6774:37:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 623,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "6766:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 630,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6766:46:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 631,
									"nodeType": "ExpressionStatement",
									"src": "6766:46:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 637,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 632,
													"name": "coupons",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 97,
													"src": "6823:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
														"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
													}
												},
												"id": 634,
												"indexExpression": {
													"argumentTypes": null,
													"id": 633,
													"name": "_couponCode",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 616,
													"src": "6831:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "6823:20:0",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_Coupon_$19_storage",
													"typeString": "struct AsyncCoin.Coupon storage ref"
												}
											},
											"id": 635,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "active",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 18,
											"src": "6823:27:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 636,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "6853:5:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "6823:35:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 638,
									"nodeType": "ExpressionStatement",
									"src": "6823:35:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 639,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "6876:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 622,
									"id": 640,
									"nodeType": "Return",
									"src": "6869:11:0"
								}
							]
						},
						"documentation": null,
						"id": 642,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 619,
								"modifierName": {
									"argumentTypes": null,
									"id": 618,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "6724:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "6724:9:0"
							}
						],
						"name": "disableCoupon",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 617,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 616,
									"name": "_couponCode",
									"nodeType": "VariableDeclaration",
									"scope": 642,
									"src": "6697:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 615,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "6697:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "6696:20:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 622,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 621,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 642,
									"src": "6743:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 620,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "6743:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "6742:14:0"
						},
						"scope": 1164,
						"src": "6674:213:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 669,
							"nodeType": "Block",
							"src": "6974:130:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 657,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 652,
															"name": "coupons",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 97,
															"src": "6992:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
															}
														},
														"id": 654,
														"indexExpression": {
															"argumentTypes": null,
															"id": 653,
															"name": "_couponCode",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 644,
															"src": "7000:11:0",
															"typeDescriptions": {
																"typeIdentifier": "t_string_memory_ptr",
																"typeString": "string memory"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "6992:20:0",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_Coupon_$19_storage",
															"typeString": "struct AsyncCoin.Coupon storage ref"
														}
													},
													"id": 655,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "tokenReward",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 12,
													"src": "6992:32:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 656,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "7028:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "6992:37:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 651,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "6984:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 658,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "6984:46:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 659,
									"nodeType": "ExpressionStatement",
									"src": "6984:46:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 665,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 660,
													"name": "coupons",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 97,
													"src": "7041:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
														"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
													}
												},
												"id": 662,
												"indexExpression": {
													"argumentTypes": null,
													"id": 661,
													"name": "_couponCode",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 644,
													"src": "7049:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "7041:20:0",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_Coupon_$19_storage",
													"typeString": "struct AsyncCoin.Coupon storage ref"
												}
											},
											"id": 663,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"memberName": "active",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 18,
											"src": "7041:27:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 664,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "7071:4:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "7041:34:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 666,
									"nodeType": "ExpressionStatement",
									"src": "7041:34:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 667,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "7093:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 650,
									"id": 668,
									"nodeType": "Return",
									"src": "7086:11:0"
								}
							]
						},
						"documentation": null,
						"id": 670,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 647,
								"modifierName": {
									"argumentTypes": null,
									"id": 646,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "6942:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "6942:9:0"
							}
						],
						"name": "enableCoupon",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 645,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 644,
									"name": "_couponCode",
									"nodeType": "VariableDeclaration",
									"scope": 670,
									"src": "6915:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 643,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "6915:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "6914:20:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 650,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 649,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 670,
									"src": "6961:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 648,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "6961:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "6960:14:0"
						},
						"scope": 1164,
						"src": "6893:211:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 787,
							"nodeType": "Block",
							"src": "7181:1114:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 683,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 678,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "7199:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 679,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "7199:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 681,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "7221:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 680,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "7213:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 682,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "7213:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "7199:24:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 677,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "7191:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 684,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "7191:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 685,
									"nodeType": "ExpressionStatement",
									"src": "7191:33:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 692,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"id": 688,
																"name": "_couponCode",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 672,
																"src": "7248:11:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_string_memory_ptr",
																	"typeString": "string memory"
																}
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_string_memory_ptr",
																	"typeString": "string memory"
																}
															],
															"id": 687,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"nodeType": "ElementaryTypeNameExpression",
															"src": "7242:5:0",
															"typeDescriptions": {
																"typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
																"typeString": "type(bytes storage pointer)"
															},
															"typeName": "bytes"
														},
														"id": 689,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "typeConversion",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "7242:18:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bytes_memory",
															"typeString": "bytes memory"
														}
													},
													"id": 690,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "length",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "7242:25:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 691,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "7270:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "7242:29:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 686,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "7234:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 693,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "7234:38:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 694,
									"nodeType": "ExpressionStatement",
									"src": "7234:38:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 701,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 696,
															"name": "coupons",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 97,
															"src": "7338:7:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
															}
														},
														"id": 698,
														"indexExpression": {
															"argumentTypes": null,
															"id": 697,
															"name": "_couponCode",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 672,
															"src": "7346:11:0",
															"typeDescriptions": {
																"typeIdentifier": "t_string_memory_ptr",
																"typeString": "string memory"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "7338:20:0",
														"typeDescriptions": {
															"typeIdentifier": "t_struct$_Coupon_$19_storage",
															"typeString": "struct AsyncCoin.Coupon storage ref"
														}
													},
													"id": 699,
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "active",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 18,
													"src": "7338:27:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "74727565",
													"id": 700,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "7369:4:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "true"
												},
												"src": "7338:35:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 695,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "7330:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 702,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "7330:44:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 703,
									"nodeType": "ExpressionStatement",
									"src": "7330:44:0"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"id": 709,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 704,
													"name": "coupons",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 97,
													"src": "7456:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
														"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
													}
												},
												"id": 706,
												"indexExpression": {
													"argumentTypes": null,
													"id": 705,
													"name": "_couponCode",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "7464:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "7456:20:0",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_Coupon_$19_storage",
													"typeString": "struct AsyncCoin.Coupon storage ref"
												}
											},
											"id": 707,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "infinite",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 16,
											"src": "7456:29:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 708,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "7489:5:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "7456:38:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 720,
									"nodeType": "IfStatement",
									"src": "7452:114:0",
									"trueBody": {
										"id": 719,
										"nodeType": "Block",
										"src": "7496:70:0",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"id": 716,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"leftExpression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 711,
																		"name": "coupons",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 97,
																		"src": "7518:7:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																			"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
																		}
																	},
																	"id": 713,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 712,
																		"name": "_couponCode",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 672,
																		"src": "7526:11:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_string_memory_ptr",
																			"typeString": "string memory"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "7518:20:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_Coupon_$19_storage",
																		"typeString": "struct AsyncCoin.Coupon storage ref"
																	}
																},
																"id": 714,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "timesUsable",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 14,
																"src": "7518:32:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"nodeType": "BinaryOperation",
															"operator": ">",
															"rightExpression": {
																"argumentTypes": null,
																"hexValue": "30",
																"id": 715,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "7553:1:0",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_0_by_1",
																	"typeString": "int_const 0"
																},
																"value": "0"
															},
															"src": "7518:36:0",
															"typeDescriptions": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															}
														],
														"id": 710,
														"name": "require",
														"nodeType": "Identifier",
														"overloadedDeclarations": [
															1465,
															1466
														],
														"referencedDeclaration": 1465,
														"src": "7510:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
															"typeString": "function (bool) pure"
														}
													},
													"id": 717,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"kind": "functionCall",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "7510:45:0",
													"typeDescriptions": {
														"typeIdentifier": "t_tuple$__$",
														"typeString": "tuple()"
													}
												},
												"id": 718,
												"nodeType": "ExpressionStatement",
												"src": "7510:45:0"
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 728,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "!",
												"prefix": true,
												"src": "7651:41:0",
												"subExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 722,
															"name": "redeemedCoupons",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 103,
															"src": "7652:15:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_string_memory_$_t_bool_$_$",
																"typeString": "mapping(address => mapping(string memory => bool))"
															}
														},
														"id": 725,
														"indexExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 723,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1462,
																"src": "7668:3:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 724,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "7668:10:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "7652:27:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_string_memory_$_t_bool_$",
															"typeString": "mapping(string memory => bool)"
														}
													},
													"id": 727,
													"indexExpression": {
														"argumentTypes": null,
														"id": 726,
														"name": "_couponCode",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "7680:11:0",
														"typeDescriptions": {
															"typeIdentifier": "t_string_memory_ptr",
															"typeString": "string memory"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "7652:40:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 721,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "7643:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 729,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "7643:50:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 730,
									"nodeType": "ExpressionStatement",
									"src": "7643:50:0"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"id": 736,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 731,
													"name": "coupons",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 97,
													"src": "7751:7:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
														"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
													}
												},
												"id": 733,
												"indexExpression": {
													"argumentTypes": null,
													"id": 732,
													"name": "_couponCode",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 672,
													"src": "7759:11:0",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "7751:20:0",
												"typeDescriptions": {
													"typeIdentifier": "t_struct$_Coupon_$19_storage",
													"typeString": "struct AsyncCoin.Coupon storage ref"
												}
											},
											"id": 734,
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "infinite",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 16,
											"src": "7751:29:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 735,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "7784:5:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "7751:38:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 766,
									"nodeType": "IfStatement",
									"src": "7747:335:0",
									"trueBody": {
										"id": 765,
										"nodeType": "Block",
										"src": "7791:291:0",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 748,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 737,
																"name": "coupons",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 97,
																"src": "7805:7:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																	"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
																}
															},
															"id": 739,
															"indexExpression": {
																"argumentTypes": null,
																"id": 738,
																"name": "_couponCode",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 672,
																"src": "7813:11:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_string_memory_ptr",
																	"typeString": "string memory"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "7805:20:0",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Coupon_$19_storage",
																"typeString": "struct AsyncCoin.Coupon storage ref"
															}
														},
														"id": 740,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": true,
														"memberName": "timesUsable",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 14,
														"src": "7805:32:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"arguments": [
															{
																"argumentTypes": null,
																"hexValue": "31",
																"id": 746,
																"isConstant": false,
																"isLValue": false,
																"isPure": true,
																"kind": "number",
																"lValueRequested": false,
																"nodeType": "Literal",
																"src": "7877:1:0",
																"subdenomination": null,
																"typeDescriptions": {
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																},
																"value": "1"
															}
														],
														"expression": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_rational_1_by_1",
																	"typeString": "int_const 1"
																}
															],
															"expression": {
																"argumentTypes": null,
																"expression": {
																	"argumentTypes": null,
																	"baseExpression": {
																		"argumentTypes": null,
																		"id": 741,
																		"name": "coupons",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 97,
																		"src": "7840:7:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																			"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
																		}
																	},
																	"id": 743,
																	"indexExpression": {
																		"argumentTypes": null,
																		"id": 742,
																		"name": "_couponCode",
																		"nodeType": "Identifier",
																		"overloadedDeclarations": [],
																		"referencedDeclaration": 672,
																		"src": "7848:11:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_string_memory_ptr",
																			"typeString": "string memory"
																		}
																	},
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"nodeType": "IndexAccess",
																	"src": "7840:20:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_struct$_Coupon_$19_storage",
																		"typeString": "struct AsyncCoin.Coupon storage ref"
																	}
																},
																"id": 744,
																"isConstant": false,
																"isLValue": true,
																"isPure": false,
																"lValueRequested": false,
																"memberName": "timesUsable",
																"nodeType": "MemberAccess",
																"referencedDeclaration": 14,
																"src": "7840:32:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															},
															"id": 745,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sub",
															"nodeType": "MemberAccess",
															"referencedDeclaration": 1402,
															"src": "7840:36:0",
															"typeDescriptions": {
																"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
																"typeString": "function (uint256,uint256) pure returns (uint256)"
															}
														},
														"id": 747,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"kind": "functionCall",
														"lValueRequested": false,
														"names": [],
														"nodeType": "FunctionCall",
														"src": "7840:39:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"src": "7805:74:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 749,
												"nodeType": "ExpressionStatement",
												"src": "7805:74:0"
											},
											{
												"condition": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"id": 755,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"baseExpression": {
																"argumentTypes": null,
																"id": 750,
																"name": "coupons",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 97,
																"src": "7966:7:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																	"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
																}
															},
															"id": 752,
															"indexExpression": {
																"argumentTypes": null,
																"id": 751,
																"name": "_couponCode",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 672,
																"src": "7974:11:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_string_memory_ptr",
																	"typeString": "string memory"
																}
															},
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"nodeType": "IndexAccess",
															"src": "7966:20:0",
															"typeDescriptions": {
																"typeIdentifier": "t_struct$_Coupon_$19_storage",
																"typeString": "struct AsyncCoin.Coupon storage ref"
															}
														},
														"id": 753,
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "timesUsable",
														"nodeType": "MemberAccess",
														"referencedDeclaration": 14,
														"src": "7966:32:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "<",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "31",
														"id": 754,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "8001:1:0",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_rational_1_by_1",
															"typeString": "int_const 1"
														},
														"value": "1"
													},
													"src": "7966:36:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"falseBody": null,
												"id": 764,
												"nodeType": "IfStatement",
												"src": "7962:110:0",
												"trueBody": {
													"id": 763,
													"nodeType": "Block",
													"src": "8004:68:0",
													"statements": [
														{
															"expression": {
																"argumentTypes": null,
																"id": 761,
																"isConstant": false,
																"isLValue": false,
																"isPure": false,
																"lValueRequested": false,
																"leftHandSide": {
																	"argumentTypes": null,
																	"expression": {
																		"argumentTypes": null,
																		"baseExpression": {
																			"argumentTypes": null,
																			"id": 756,
																			"name": "coupons",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 97,
																			"src": "8022:7:0",
																			"typeDescriptions": {
																				"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
																				"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
																			}
																		},
																		"id": 758,
																		"indexExpression": {
																			"argumentTypes": null,
																			"id": 757,
																			"name": "_couponCode",
																			"nodeType": "Identifier",
																			"overloadedDeclarations": [],
																			"referencedDeclaration": 672,
																			"src": "8030:11:0",
																			"typeDescriptions": {
																				"typeIdentifier": "t_string_memory_ptr",
																				"typeString": "string memory"
																			}
																		},
																		"isConstant": false,
																		"isLValue": true,
																		"isPure": false,
																		"lValueRequested": false,
																		"nodeType": "IndexAccess",
																		"src": "8022:20:0",
																		"typeDescriptions": {
																			"typeIdentifier": "t_struct$_Coupon_$19_storage",
																			"typeString": "struct AsyncCoin.Coupon storage ref"
																		}
																	},
																	"id": 759,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": true,
																	"memberName": "active",
																	"nodeType": "MemberAccess",
																	"referencedDeclaration": 18,
																	"src": "8022:27:0",
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	}
																},
																"nodeType": "Assignment",
																"operator": "=",
																"rightHandSide": {
																	"argumentTypes": null,
																	"hexValue": "66616c7365",
																	"id": 760,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"kind": "bool",
																	"lValueRequested": false,
																	"nodeType": "Literal",
																	"src": "8052:5:0",
																	"subdenomination": null,
																	"typeDescriptions": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"value": "false"
																},
																"src": "8022:35:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															},
															"id": 762,
															"nodeType": "ExpressionStatement",
															"src": "8022:35:0"
														}
													]
												}
											}
										]
									}
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 774,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 767,
													"name": "redeemedCoupons",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 103,
													"src": "8153:15:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_string_memory_$_t_bool_$_$",
														"typeString": "mapping(address => mapping(string memory => bool))"
													}
												},
												"id": 771,
												"indexExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 768,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "8169:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 769,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "8169:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "8153:27:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_string_memory_$_t_bool_$",
													"typeString": "mapping(string memory => bool)"
												}
											},
											"id": 772,
											"indexExpression": {
												"argumentTypes": null,
												"id": 770,
												"name": "_couponCode",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 672,
												"src": "8181:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "8153:40:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 773,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "8196:4:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "8153:47:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 775,
									"nodeType": "ExpressionStatement",
									"src": "8153:47:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 777,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "8221:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 778,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "8221:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 779,
														"name": "coupons",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 97,
														"src": "8233:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_string_memory_$_t_struct$_Coupon_$19_storage_$",
															"typeString": "mapping(string memory => struct AsyncCoin.Coupon storage ref)"
														}
													},
													"id": 781,
													"indexExpression": {
														"argumentTypes": null,
														"id": 780,
														"name": "_couponCode",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 672,
														"src": "8241:11:0",
														"typeDescriptions": {
															"typeIdentifier": "t_string_memory_ptr",
															"typeString": "string memory"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "8233:20:0",
													"typeDescriptions": {
														"typeIdentifier": "t_struct$_Coupon_$19_storage",
														"typeString": "struct AsyncCoin.Coupon storage ref"
													}
												},
												"id": 782,
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "tokenReward",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 12,
												"src": "8233:32:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 776,
											"name": "mintTokens",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 527,
											"src": "8210:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
												"typeString": "function (address,uint256) returns (bool)"
											}
										},
										"id": 783,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8210:56:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 784,
									"nodeType": "ExpressionStatement",
									"src": "8210:56:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 785,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "8284:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 676,
									"id": 786,
									"nodeType": "Return",
									"src": "8277:11:0"
								}
							]
						},
						"documentation": null,
						"id": 788,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "redeemCoupon",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 673,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 672,
									"name": "_couponCode",
									"nodeType": "VariableDeclaration",
									"scope": 788,
									"src": "7132:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 671,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "7132:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "7131:20:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 676,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 675,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 788,
									"src": "7168:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 674,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "7168:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "7167:14:0"
						},
						"scope": 1164,
						"src": "7110:1185:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 825,
							"nodeType": "Block",
							"src": "8411:228:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 802,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 798,
													"name": "_frozenAddress",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 790,
													"src": "8429:14:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 800,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "8455:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 799,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "8447:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 801,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "8447:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "8429:28:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 797,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "8421:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 803,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8421:37:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 804,
									"nodeType": "ExpressionStatement",
									"src": "8421:37:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 809,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 806,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "8476:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 807,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "8476:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"id": 808,
													"name": "_frozenAddress",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 790,
													"src": "8490:14:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "8476:28:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 805,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "8468:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 810,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8468:37:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 811,
									"nodeType": "ExpressionStatement",
									"src": "8468:37:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 816,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 812,
												"name": "frozenAddresses",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 107,
												"src": "8516:15:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
													"typeString": "mapping(address => bool)"
												}
											},
											"id": 814,
											"indexExpression": {
												"argumentTypes": null,
												"id": 813,
												"name": "_frozenAddress",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 790,
												"src": "8532:14:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "8516:31:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 815,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "8550:4:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "8516:38:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 817,
									"nodeType": "ExpressionStatement",
									"src": "8516:38:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 819,
												"name": "_frozenAddress",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 790,
												"src": "8589:14:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "74727565",
												"id": 820,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "bool",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "8605:4:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"value": "true"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 818,
											"name": "AddressFreezeChange",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 52,
											"src": "8569:19:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_bool_$returns$__$",
												"typeString": "function (address,bool)"
											}
										},
										"id": 821,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8569:41:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 822,
									"nodeType": "EmitStatement",
									"src": "8564:46:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 823,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "8628:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 796,
									"id": 824,
									"nodeType": "Return",
									"src": "8621:11:0"
								}
							]
						},
						"documentation": null,
						"id": 826,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 793,
								"modifierName": {
									"argumentTypes": null,
									"id": 792,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "8379:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "8379:9:0"
							}
						],
						"name": "freezeAddress",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 791,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 790,
									"name": "_frozenAddress",
									"nodeType": "VariableDeclaration",
									"scope": 826,
									"src": "8348:22:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 789,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "8348:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "8347:24:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 796,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 795,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 826,
									"src": "8398:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 794,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "8398:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "8397:14:0"
						},
						"scope": 1164,
						"src": "8325:314:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 864,
							"nodeType": "Block",
							"src": "8775:241:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 840,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 836,
													"name": "_frozenAddress",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 828,
													"src": "8793:14:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 838,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "8819:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 837,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "8811:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 839,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "8811:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "8793:28:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 835,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "8785:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 841,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8785:37:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 842,
									"nodeType": "ExpressionStatement",
									"src": "8785:37:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 848,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"baseExpression": {
														"argumentTypes": null,
														"id": 844,
														"name": "frozenAddresses",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 107,
														"src": "8840:15:0",
														"typeDescriptions": {
															"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
															"typeString": "mapping(address => bool)"
														}
													},
													"id": 846,
													"indexExpression": {
														"argumentTypes": null,
														"id": 845,
														"name": "_frozenAddress",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 828,
														"src": "8856:14:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"isConstant": false,
													"isLValue": true,
													"isPure": false,
													"lValueRequested": false,
													"nodeType": "IndexAccess",
													"src": "8840:31:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "74727565",
													"id": 847,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "bool",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "8875:4:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"value": "true"
												},
												"src": "8840:39:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 843,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "8832:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 849,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8832:48:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 850,
									"nodeType": "ExpressionStatement",
									"src": "8832:48:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 855,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 851,
												"name": "frozenAddresses",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 107,
												"src": "8891:15:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
													"typeString": "mapping(address => bool)"
												}
											},
											"id": 853,
											"indexExpression": {
												"argumentTypes": null,
												"id": 852,
												"name": "_frozenAddress",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 828,
												"src": "8907:14:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "8891:31:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 854,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "8925:5:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "8891:39:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 856,
									"nodeType": "ExpressionStatement",
									"src": "8891:39:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 858,
												"name": "_frozenAddress",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 828,
												"src": "8965:14:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "66616c7365",
												"id": 859,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "bool",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "8981:5:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"value": "false"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 857,
											"name": "AddressFreezeChange",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 52,
											"src": "8945:19:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_bool_$returns$__$",
												"typeString": "function (address,bool)"
											}
										},
										"id": 860,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "8945:42:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 861,
									"nodeType": "EmitStatement",
									"src": "8940:47:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 862,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "9005:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 834,
									"id": 863,
									"nodeType": "Return",
									"src": "8998:11:0"
								}
							]
						},
						"documentation": null,
						"id": 865,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 831,
								"modifierName": {
									"argumentTypes": null,
									"id": 830,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "8743:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "8743:9:0"
							}
						],
						"name": "unfreezeAddress",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 829,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 828,
									"name": "_frozenAddress",
									"nodeType": "VariableDeclaration",
									"scope": 865,
									"src": "8712:22:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 827,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "8712:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "8711:24:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 834,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 833,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 865,
									"src": "8762:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 832,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "8762:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "8761:14:0"
						},
						"scope": 1164,
						"src": "8687:329:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 896,
							"nodeType": "Block",
							"src": "9089:182:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 878,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 873,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "9107:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 874,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "9107:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 876,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "9129:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 875,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "9121:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 877,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "9121:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "9107:24:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 872,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "9099:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 879,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "9099:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 880,
									"nodeType": "ExpressionStatement",
									"src": "9099:33:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 886,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 881,
												"name": "addressToName",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 111,
												"src": "9143:13:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_string_storage_$",
													"typeString": "mapping(address => string storage ref)"
												}
											},
											"id": 884,
											"indexExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 882,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "9157:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 883,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "9157:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "9143:25:0",
											"typeDescriptions": {
												"typeIdentifier": "t_string_storage",
												"typeString": "string storage ref"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 885,
											"name": "_addressName",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 867,
											"src": "9171:12:0",
											"typeDescriptions": {
												"typeIdentifier": "t_string_memory_ptr",
												"typeString": "string memory"
											}
										},
										"src": "9143:40:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage",
											"typeString": "string storage ref"
										}
									},
									"id": 887,
									"nodeType": "ExpressionStatement",
									"src": "9143:40:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 889,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "9217:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 890,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "9217:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 891,
												"name": "_addressName",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 867,
												"src": "9229:12:0",
												"typeDescriptions": {
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											],
											"id": 888,
											"name": "AddressNameChange",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 64,
											"src": "9199:17:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (address,string memory)"
											}
										},
										"id": 892,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "9199:43:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 893,
									"nodeType": "EmitStatement",
									"src": "9194:48:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 894,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "9260:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 871,
									"id": 895,
									"nodeType": "Return",
									"src": "9253:11:0"
								}
							]
						},
						"documentation": null,
						"id": 897,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "setName",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 868,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 867,
									"name": "_addressName",
									"nodeType": "VariableDeclaration",
									"scope": 897,
									"src": "9039:19:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 866,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "9039:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9038:21:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 871,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 870,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 897,
									"src": "9076:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 869,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "9076:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9075:14:0"
						},
						"scope": 1164,
						"src": "9022:249:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 927,
							"nodeType": "Block",
							"src": "9359:179:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 911,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 907,
													"name": "_address",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 899,
													"src": "9377:8:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 909,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "9397:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 908,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "9389:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 910,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "9389:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "9377:22:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 906,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "9369:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 912,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "9369:31:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 913,
									"nodeType": "ExpressionStatement",
									"src": "9369:31:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 918,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 914,
												"name": "allowedToBuyTokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 115,
												"src": "9411:18:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
													"typeString": "mapping(address => bool)"
												}
											},
											"id": 916,
											"indexExpression": {
												"argumentTypes": null,
												"id": 915,
												"name": "_address",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 899,
												"src": "9430:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "9411:28:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 917,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "9442:4:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "9411:35:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 919,
									"nodeType": "ExpressionStatement",
									"src": "9411:35:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 921,
												"name": "_address",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 899,
												"src": "9494:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "74727565",
												"id": 922,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "bool",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "9504:4:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"value": "true"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 920,
											"name": "AddressCanBuyTokensStatusChange",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 70,
											"src": "9462:31:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_bool_$returns$__$",
												"typeString": "function (address,bool)"
											}
										},
										"id": 923,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "9462:47:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 924,
									"nodeType": "EmitStatement",
									"src": "9457:52:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 925,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "9527:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 905,
									"id": 926,
									"nodeType": "Return",
									"src": "9520:11:0"
								}
							]
						},
						"documentation": null,
						"id": 928,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 902,
								"modifierName": {
									"argumentTypes": null,
									"id": 901,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "9327:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "9327:9:0"
							}
						],
						"name": "setAllowedToBuy",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 900,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 899,
									"name": "_address",
									"nodeType": "VariableDeclaration",
									"scope": 928,
									"src": "9302:16:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 898,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "9302:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9301:18:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 905,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 904,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 928,
									"src": "9346:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 903,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "9346:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9345:14:0"
						},
						"scope": 1164,
						"src": "9277:261:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 958,
							"nodeType": "Block",
							"src": "9629:181:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 942,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 938,
													"name": "_address",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 930,
													"src": "9647:8:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 940,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "9667:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 939,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "9659:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 941,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "9659:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "9647:22:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 937,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "9639:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 943,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "9639:31:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 944,
									"nodeType": "ExpressionStatement",
									"src": "9639:31:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 949,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 945,
												"name": "allowedToBuyTokens",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 115,
												"src": "9681:18:0",
												"typeDescriptions": {
													"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
													"typeString": "mapping(address => bool)"
												}
											},
											"id": 947,
											"indexExpression": {
												"argumentTypes": null,
												"id": 946,
												"name": "_address",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 930,
												"src": "9700:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": true,
											"nodeType": "IndexAccess",
											"src": "9681:28:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "66616c7365",
											"id": 948,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "9712:5:0",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "false"
										},
										"src": "9681:36:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 950,
									"nodeType": "ExpressionStatement",
									"src": "9681:36:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 952,
												"name": "_address",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 930,
												"src": "9765:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"hexValue": "66616c7365",
												"id": 953,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "bool",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "9775:5:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"value": "false"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 951,
											"name": "AddressCanBuyTokensStatusChange",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 70,
											"src": "9733:31:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_bool_$returns$__$",
												"typeString": "function (address,bool)"
											}
										},
										"id": 954,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "9733:48:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 955,
									"nodeType": "EmitStatement",
									"src": "9728:53:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 956,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "9799:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 936,
									"id": 957,
									"nodeType": "Return",
									"src": "9792:11:0"
								}
							]
						},
						"documentation": null,
						"id": 959,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": null,
								"id": 933,
								"modifierName": {
									"argumentTypes": null,
									"id": 932,
									"name": "onlyOwner",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 1267,
									"src": "9597:9:0",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "9597:9:0"
							}
						],
						"name": "setNotAllowedToBuy",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 931,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 930,
									"name": "_address",
									"nodeType": "VariableDeclaration",
									"scope": 959,
									"src": "9572:16:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 929,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "9572:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9571:18:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 936,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 935,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 959,
									"src": "9616:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 934,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "9616:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9615:14:0"
						},
						"scope": 1164,
						"src": "9544:266:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 976,
							"nodeType": "Block",
							"src": "9906:81:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"id": 974,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"id": 970,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"baseExpression": {
													"argumentTypes": null,
													"id": 966,
													"name": "allowedToBuyTokens",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 115,
													"src": "9923:18:0",
													"typeDescriptions": {
														"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
														"typeString": "mapping(address => bool)"
													}
												},
												"id": 968,
												"indexExpression": {
													"argumentTypes": null,
													"id": 967,
													"name": "_address",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 961,
													"src": "9942:8:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"isConstant": false,
												"isLValue": true,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "IndexAccess",
												"src": "9923:28:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"hexValue": "74727565",
												"id": 969,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "bool",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "9955:4:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"value": "true"
											},
											"src": "9923:36:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "||",
										"rightExpression": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											},
											"id": 973,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"id": 971,
												"name": "_address",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 961,
												"src": "9963:8:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "==",
											"rightExpression": {
												"argumentTypes": null,
												"id": 972,
												"name": "owner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1237,
												"src": "9975:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"src": "9963:17:0",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"src": "9923:57:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 965,
									"id": 975,
									"nodeType": "Return",
									"src": "9916:64:0"
								}
							]
						},
						"documentation": null,
						"id": 977,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "canBuyTokens",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 962,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 961,
									"name": "_address",
									"nodeType": "VariableDeclaration",
									"scope": 977,
									"src": "9838:16:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 960,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "9838:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9837:18:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 965,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 964,
									"name": "addressCanBuyTokens",
									"nodeType": "VariableDeclaration",
									"scope": 977,
									"src": "9881:24:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 963,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "9881:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "9880:26:0"
						},
						"scope": 1164,
						"src": "9816:171:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1074,
							"nodeType": "Block",
							"src": "10051:562:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 988,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 983,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "10069:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 984,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "10069:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 986,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "10091:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 985,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "10083:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 987,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "10083:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "10069:24:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 982,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "10061:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 989,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10061:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 990,
									"nodeType": "ExpressionStatement",
									"src": "10061:33:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 995,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 992,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "10112:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 993,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "10112:9:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 994,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "10124:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "10112:13:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 991,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "10104:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 996,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10104:22:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 997,
									"nodeType": "ExpressionStatement",
									"src": "10104:22:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												},
												"id": 1009,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													},
													"id": 1004,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"baseExpression": {
															"argumentTypes": null,
															"id": 999,
															"name": "allowedToBuyTokens",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 115,
															"src": "10144:18:0",
															"typeDescriptions": {
																"typeIdentifier": "t_mapping$_t_address_$_t_bool_$",
																"typeString": "mapping(address => bool)"
															}
														},
														"id": 1002,
														"indexExpression": {
															"argumentTypes": null,
															"expression": {
																"argumentTypes": null,
																"id": 1000,
																"name": "msg",
																"nodeType": "Identifier",
																"overloadedDeclarations": [],
																"referencedDeclaration": 1462,
																"src": "10163:3:0",
																"typeDescriptions": {
																	"typeIdentifier": "t_magic_message",
																	"typeString": "msg"
																}
															},
															"id": 1001,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"memberName": "sender",
															"nodeType": "MemberAccess",
															"referencedDeclaration": null,
															"src": "10163:10:0",
															"typeDescriptions": {
																"typeIdentifier": "t_address",
																"typeString": "address"
															}
														},
														"isConstant": false,
														"isLValue": true,
														"isPure": false,
														"lValueRequested": false,
														"nodeType": "IndexAccess",
														"src": "10144:30:0",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"hexValue": "74727565",
														"id": 1003,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "10178:4:0",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "true"
													},
													"src": "10144:38:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "||",
												"rightExpression": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													},
													"id": 1008,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftExpression": {
														"argumentTypes": null,
														"id": 1005,
														"name": "owner",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1237,
														"src": "10186:5:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"nodeType": "BinaryOperation",
													"operator": "==",
													"rightExpression": {
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1006,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1462,
															"src": "10195:3:0",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 1007,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "sender",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "10195:10:0",
														"typeDescriptions": {
															"typeIdentifier": "t_address",
															"typeString": "address"
														}
													},
													"src": "10186:19:0",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"src": "10144:61:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 998,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "10136:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1010,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10136:70:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1011,
									"nodeType": "ExpressionStatement",
									"src": "10136:70:0"
								},
								{
									"assignments": [
										1013
									],
									"declarations": [
										{
											"constant": false,
											"id": 1013,
											"name": "remaining",
											"nodeType": "VariableDeclaration",
											"scope": 1075,
											"src": "10217:14:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 1012,
												"name": "uint",
												"nodeType": "ElementaryTypeName",
												"src": "10217:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1020,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"hexValue": "31",
												"id": 1018,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "10250:7:0",
												"subdenomination": "ether",
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1000000000000000000_by_1",
													"typeString": "int_const 1000000000000000000"
												},
												"value": "1"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_rational_1000000000000000000_by_1",
													"typeString": "int_const 1000000000000000000"
												}
											],
											"expression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1014,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1462,
															"src": "10235:3:0",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 1015,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "value",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "10235:9:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 1016,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "10234:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"id": 1017,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "mod",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 1446,
											"src": "10234:15:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
												"typeString": "function (uint256,uint256) pure returns (uint256)"
											}
										},
										"id": 1019,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10234:24:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "10217:41:0"
								},
								{
									"assignments": [
										1022
									],
									"declarations": [
										{
											"constant": false,
											"id": 1022,
											"name": "spentEther",
											"nodeType": "VariableDeclaration",
											"scope": 1075,
											"src": "10268:15:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 1021,
												"name": "uint",
												"nodeType": "ElementaryTypeName",
												"src": "10268:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1029,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1027,
												"name": "remaining",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1013,
												"src": "10302:9:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"components": [
													{
														"argumentTypes": null,
														"expression": {
															"argumentTypes": null,
															"id": 1023,
															"name": "msg",
															"nodeType": "Identifier",
															"overloadedDeclarations": [],
															"referencedDeclaration": 1462,
															"src": "10287:3:0",
															"typeDescriptions": {
																"typeIdentifier": "t_magic_message",
																"typeString": "msg"
															}
														},
														"id": 1024,
														"isConstant": false,
														"isLValue": false,
														"isPure": false,
														"lValueRequested": false,
														"memberName": "value",
														"nodeType": "MemberAccess",
														"referencedDeclaration": null,
														"src": "10287:9:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													}
												],
												"id": 1025,
												"isConstant": false,
												"isInlineArray": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "TupleExpression",
												"src": "10286:11:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"id": 1026,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sub",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 1402,
											"src": "10286:15:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
												"typeString": "function (uint256,uint256) pure returns (uint256)"
											}
										},
										"id": 1028,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10286:26:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "10268:44:0"
								},
								{
									"assignments": [
										1031
									],
									"declarations": [
										{
											"constant": false,
											"id": 1031,
											"name": "tokensBought",
											"nodeType": "VariableDeclaration",
											"scope": 1075,
											"src": "10322:17:0",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"typeName": {
												"id": 1030,
												"name": "uint",
												"nodeType": "ElementaryTypeName",
												"src": "10322:4:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 1039,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"hexValue": "3130",
												"id": 1037,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "10370:2:0",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_10_by_1",
													"typeString": "int_const 10"
												},
												"value": "10"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_rational_10_by_1",
													"typeString": "int_const 10"
												}
											],
											"expression": {
												"argumentTypes": null,
												"arguments": [
													{
														"argumentTypes": null,
														"hexValue": "31",
														"id": 1034,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "number",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "10357:7:0",
														"subdenomination": "ether",
														"typeDescriptions": {
															"typeIdentifier": "t_rational_1000000000000000000_by_1",
															"typeString": "int_const 1000000000000000000"
														},
														"value": "1"
													}
												],
												"expression": {
													"argumentTypes": [
														{
															"typeIdentifier": "t_rational_1000000000000000000_by_1",
															"typeString": "int_const 1000000000000000000"
														}
													],
													"expression": {
														"argumentTypes": null,
														"id": 1032,
														"name": "spentEther",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1022,
														"src": "10342:10:0",
														"typeDescriptions": {
															"typeIdentifier": "t_uint256",
															"typeString": "uint256"
														}
													},
													"id": 1033,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "div",
													"nodeType": "MemberAccess",
													"referencedDeclaration": 1378,
													"src": "10342:14:0",
													"typeDescriptions": {
														"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
														"typeString": "function (uint256,uint256) pure returns (uint256)"
													}
												},
												"id": 1035,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"kind": "functionCall",
												"lValueRequested": false,
												"names": [],
												"nodeType": "FunctionCall",
												"src": "10342:23:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"id": 1036,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "mul",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 1354,
											"src": "10342:27:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
												"typeString": "function (uint256,uint256) pure returns (uint256)"
											}
										},
										"id": 1038,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10342:31:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "10322:51:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1043,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1041,
													"name": "spentEther",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1022,
													"src": "10392:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 1042,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "10405:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "10392:14:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1040,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "10384:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1044,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10384:23:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1045,
									"nodeType": "ExpressionStatement",
									"src": "10384:23:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1049,
												"name": "spentEther",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1022,
												"src": "10433:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"id": 1046,
												"name": "owner",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1237,
												"src": "10418:5:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 1048,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "10418:14:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 1050,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10418:26:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1051,
									"nodeType": "ExpressionStatement",
									"src": "10418:26:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 1057,
												"name": "remaining",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1013,
												"src": "10474:9:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"expression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1052,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "10454:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1055,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "10454:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 1056,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "10454:19:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 1058,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10454:30:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1059,
									"nodeType": "ExpressionStatement",
									"src": "10454:30:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1061,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "10505:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1062,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "10505:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 1063,
												"name": "tokensBought",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1031,
												"src": "10517:12:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 1060,
											"name": "mintTokens",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 527,
											"src": "10494:10:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
												"typeString": "function (address,uint256) returns (bool)"
											}
										},
										"id": 1064,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10494:36:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1065,
									"nodeType": "ExpressionStatement",
									"src": "10494:36:0"
								},
								{
									"eventCall": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1067,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "10559:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1068,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "10559:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 1069,
												"name": "tokensBought",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 1031,
												"src": "10571:12:0",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											],
											"id": 1066,
											"name": "TokensBought",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 58,
											"src": "10546:12:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_uint256_$returns$__$",
												"typeString": "function (address,uint256)"
											}
										},
										"id": 1070,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10546:38:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1071,
									"nodeType": "EmitStatement",
									"src": "10541:43:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 1072,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "10602:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 981,
									"id": 1073,
									"nodeType": "Return",
									"src": "10595:11:0"
								}
							]
						},
						"documentation": null,
						"id": 1075,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "buyTokens",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 978,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "10011:2:0"
						},
						"payable": true,
						"returnParameters": {
							"id": 981,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 980,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 1075,
									"src": "10038:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 979,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "10038:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "10037:14:0"
						},
						"scope": 1164,
						"src": "9993:620:0",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1081,
							"nodeType": "Block",
							"src": "10645:28:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 1078,
											"name": "buyTokens",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1075,
											"src": "10655:9:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$__$returns$_t_bool_$",
												"typeString": "function () returns (bool)"
											}
										},
										"id": 1079,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10655:11:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 1080,
									"nodeType": "ExpressionStatement",
									"src": "10655:11:0"
								}
							]
						},
						"documentation": null,
						"id": 1082,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1076,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "10627:2:0"
						},
						"payable": true,
						"returnParameters": {
							"id": 1077,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "10645:0:0"
						},
						"scope": 1164,
						"src": "10619:54:0",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1113,
							"nodeType": "Block",
							"src": "10747:157:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 1093,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1088,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "10765:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 1089,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "10765:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "!=",
												"rightExpression": {
													"argumentTypes": null,
													"arguments": [
														{
															"argumentTypes": null,
															"hexValue": "30",
															"id": 1091,
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"kind": "number",
															"lValueRequested": false,
															"nodeType": "Literal",
															"src": "10787:1:0",
															"subdenomination": null,
															"typeDescriptions": {
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															},
															"value": "0"
														}
													],
													"expression": {
														"argumentTypes": [
															{
																"typeIdentifier": "t_rational_0_by_1",
																"typeString": "int_const 0"
															}
														],
														"id": 1090,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"lValueRequested": false,
														"nodeType": "ElementaryTypeNameExpression",
														"src": "10779:7:0",
														"typeDescriptions": {
															"typeIdentifier": "t_type$_t_address_$",
															"typeString": "type(address)"
														},
														"typeName": "address"
													},
													"id": 1092,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "typeConversion",
													"lValueRequested": false,
													"names": [],
													"nodeType": "FunctionCall",
													"src": "10779:10:0",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "10765:24:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1087,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "10757:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1094,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10757:33:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1095,
									"nodeType": "ExpressionStatement",
									"src": "10757:33:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1100,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1097,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "10808:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 1098,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "10808:9:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 1099,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "10820:1:0",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "10808:13:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1096,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "10800:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1101,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10800:22:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1102,
									"nodeType": "ExpressionStatement",
									"src": "10800:22:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1109,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1103,
											"name": "etherBalance",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 83,
											"src": "10833:12:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1106,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 1462,
														"src": "10865:3:0",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 1107,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "10865:9:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												],
												"expression": {
													"argumentTypes": null,
													"id": 1104,
													"name": "etherBalance",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 83,
													"src": "10848:12:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 1105,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "add",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1426,
												"src": "10848:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 1108,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "10848:27:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "10833:42:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1110,
									"nodeType": "ExpressionStatement",
									"src": "10833:42:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 1111,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "10893:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 1086,
									"id": 1112,
									"nodeType": "Return",
									"src": "10886:11:0"
								}
							]
						},
						"documentation": null,
						"id": 1114,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "sendEtherToContract",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1083,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "10707:2:0"
						},
						"payable": true,
						"returnParameters": {
							"id": 1086,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1085,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 1114,
									"src": "10734:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1084,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "10734:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "10733:14:0"
						},
						"scope": 1164,
						"src": "10679:225:0",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1142,
							"nodeType": "Block",
							"src": "10971:160:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1122,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 1120,
													"name": "etherBalance",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 83,
													"src": "10989:12:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": ">=",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "31",
													"id": 1121,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "11005:7:0",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													},
													"value": "1"
												},
												"src": "10989:23:0",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1119,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												1465,
												1466
											],
											"referencedDeclaration": 1465,
											"src": "10981:7:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1123,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "10981:32:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1124,
									"nodeType": "ExpressionStatement",
									"src": "10981:32:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"hexValue": "31",
												"id": 1130,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "11044:7:0",
												"subdenomination": "ether",
												"typeDescriptions": {
													"typeIdentifier": "t_rational_1000000000000000000_by_1",
													"typeString": "int_const 1000000000000000000"
												},
												"value": "1"
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_rational_1000000000000000000_by_1",
													"typeString": "int_const 1000000000000000000"
												}
											],
											"expression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 1125,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1462,
													"src": "11024:3:0",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 1128,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "11024:10:0",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											"id": 1129,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "transfer",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "11024:19:0",
											"typeDescriptions": {
												"typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
												"typeString": "function (uint256)"
											}
										},
										"id": 1131,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "11024:28:0",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1132,
									"nodeType": "ExpressionStatement",
									"src": "11024:28:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1138,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1133,
											"name": "etherBalance",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 83,
											"src": "11062:12:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"hexValue": "31",
													"id": 1136,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "11094:7:0",
													"subdenomination": "ether",
													"typeDescriptions": {
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													},
													"value": "1"
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_rational_1000000000000000000_by_1",
														"typeString": "int_const 1000000000000000000"
													}
												],
												"expression": {
													"argumentTypes": null,
													"id": 1134,
													"name": "etherBalance",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 83,
													"src": "11077:12:0",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"id": 1135,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sub",
												"nodeType": "MemberAccess",
												"referencedDeclaration": 1402,
												"src": "11077:16:0",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
													"typeString": "function (uint256,uint256) pure returns (uint256)"
												}
											},
											"id": 1137,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "11077:25:0",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "11062:40:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1139,
									"nodeType": "ExpressionStatement",
									"src": "11062:40:0"
								},
								{
									"expression": {
										"argumentTypes": null,
										"hexValue": "74727565",
										"id": 1140,
										"isConstant": false,
										"isLValue": false,
										"isPure": true,
										"kind": "bool",
										"lValueRequested": false,
										"nodeType": "Literal",
										"src": "11120:4:0",
										"subdenomination": null,
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										},
										"value": "true"
									},
									"functionReturnParameters": 1118,
									"id": 1141,
									"nodeType": "Return",
									"src": "11113:11:0"
								}
							]
						},
						"documentation": null,
						"id": 1143,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "getEtherFromContract",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1115,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "10939:2:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 1118,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1117,
									"name": "success",
									"nodeType": "VariableDeclaration",
									"scope": 1143,
									"src": "10958:12:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 1116,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "10958:4:0",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "10957:14:0"
						},
						"scope": 1164,
						"src": "10910:221:0",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1150,
							"nodeType": "Block",
							"src": "11205:36:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 1148,
										"name": "etherBalance",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 83,
										"src": "11222:12:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 1147,
									"id": 1149,
									"nodeType": "Return",
									"src": "11215:19:0"
								}
							]
						},
						"documentation": null,
						"id": 1151,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getContractEtherBalance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1144,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "11169:2:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 1147,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1146,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1151,
									"src": "11197:7:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1145,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "11197:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "11196:9:0"
						},
						"scope": 1164,
						"src": "11137:104:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1162,
							"nodeType": "Block",
							"src": "11339:53:0",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"baseExpression": {
											"argumentTypes": null,
											"id": 1158,
											"name": "addressToName",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 111,
											"src": "11356:13:0",
											"typeDescriptions": {
												"typeIdentifier": "t_mapping$_t_address_$_t_string_storage_$",
												"typeString": "mapping(address => string storage ref)"
											}
										},
										"id": 1160,
										"indexExpression": {
											"argumentTypes": null,
											"id": 1159,
											"name": "_addressToFind",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1153,
											"src": "11370:14:0",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"isConstant": false,
										"isLValue": true,
										"isPure": false,
										"lValueRequested": false,
										"nodeType": "IndexAccess",
										"src": "11356:29:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage",
											"typeString": "string storage ref"
										}
									},
									"functionReturnParameters": 1157,
									"id": 1161,
									"nodeType": "Return",
									"src": "11349:36:0"
								}
							]
						},
						"documentation": null,
						"id": 1163,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "getAddressName",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1154,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1153,
									"name": "_addressToFind",
									"nodeType": "VariableDeclaration",
									"scope": 1163,
									"src": "11271:22:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 1152,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "11271:7:0",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "11270:24:0"
						},
						"payable": false,
						"returnParameters": {
							"id": 1157,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1156,
									"name": "addressName",
									"nodeType": "VariableDeclaration",
									"scope": 1163,
									"src": "11320:18:0",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 1155,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "11320:6:0",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "11319:20:0"
						},
						"scope": 1164,
						"src": "11247:145:0",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 1165,
				"src": "147:11247:0"
			}
		],
		"src": "0:11395:0"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {
		"3": {
			"events": {},
			"links": {},
			"address": "0xe81b52ac87311ef19089de0b497d2fa4aed5ef82",
			"transactionHash": "0xce660ca67490124d3595ad265b053f4214df3949b31754ff878367e90e23e3c0"
		}
	},
	"schemaVersion": "2.0.1",
	"updatedAt": "2018-10-18T10:27:22.414Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/AsyncCoin.json
// module id = 57
// module chunks = 0